<template>
    <div class="box-compose box-compose-ct" :class="{
        'is-fullscreen': isFullScreen,
        'í': theme !== 'dark' || actionName === EMAIL_ACTION.NEW_RECORD
    }" @change="someThingChanged()" v-loading="isSendingMail">

        <!-- <perfect-scrollbar
            class="zm-box-compose"
            :options="{ suppressScrollX: true }"
        > -->
        <!-- check riêng cho reply mới -->
        <div v-if="[EMAIL_ACTION.REPLY, EMAIL_ACTION.FORWARD, EMAIL_ACTION.REPLY_ALL, EMAIL_ACTION.EDIT_AS_NEW].includes(actionType)"
            class="d-flex justify-content-between mb-1 top_sub">
            <div class="d-flex align-items-center">
                <a style="line-height: normal" href="javascript:;" @click="$root.$emit('handleChangeMode')" v-if="$router.currentRoute.path !== READ_EMAIL_LAYOUT_ROUTER.RIGHT">
                    <i class="el-icon-arrow-left ic-light-dark"
                        style="font-size: 24px;font-weight: 600; color: #000;"></i>
                </a>
                <h2 v-if="modelData.subject" class="title title-mobile"
                    style="font-size: 24px;font-weight: 600; color: #000;">{{ modelData.subject }}
                </h2>
            </div>
<!--            <div v-if="[EMAIL_ACTION.REPLY, EMAIL_ACTION.FORWARD, EMAIL_ACTION.REPLY_ALL, EMAIL_ACTION.EDIT_AS_NEW].includes(actionType)" class="d-flex align-items-center" v-if="mobileAndTabletCheck() !== 'mobile'">-->
<!--                <span @click="handleZoom" class="icon-zoom-dark">-->
<!--                    <img v-if="isFullScreen" width="20px" style="cursor: pointer;"-->
<!--                        src="../../../../assets/images/minimize.svg" />-->
<!--                    <img class="color_zoom" v-else width="20px" style="cursor: pointer;"-->
<!--                        src="../../../../assets/images/zoomout.svg" />-->
<!--                </span>-->
<!--            </div>-->
        </div>

        <div class="editor_off" :class="[actionType != EMAIL_ACTION.NEW_RECORD ? 'reply-mode': '']">
            <div class="row-input" v-if="fromAddresses.length > 1">
                <span class="head">{{ $t("zimbra.zhMsg.FILT_COND_HEADER_from") }}</span>
                <div class="w-100">
                    <el-select v-model="modelData.from" size="medium" class="select-from-address"
                        style="max-width: unset;" @change="changeFromAddress" value-key="uuid"
                        :value="defaultFromAddressOption">
                        <el-option v-for="item in fromAddresses" class="select-from-address-option" :key="item.uuid"
                            :label="item.label" :value="item" allow-create="true">
                            <!-- <span class="select-from-address-span">{{ item.label }}</span> -->
                            <span class="select-from-address-span">{{ item.identity?.zimbraPrefIdentityName }}
                                &nbsp</span>
                            <span> ({{ item.d || '' }}<{{ item.a }}>)</span>
                        </el-option>
                    </el-select>
                </div>
            </div>
            <!-- <div class="row-input row-input-subject">
            <span class="head">{{ $t("zimbra.zhMsg.FILT_COND_HEADER_from") }}</span>
            <input v-model="emailAddress" type="text" class="form-control from_mail" disabled />
        </div> -->
            <AddressSelector :showAvatar="true" ref="toAddressSelector" v-model="modelData.to" @change="handleSaveDraft"
                @changeText="changeTextTo" :type="$t('zimbra.zhMsg.FILT_COND_HEADER_to')" :showCc="showCc"
                :showBcc="showBcc" @keydown.native.ctrl.71="handleOpenDialogFormVisible"
                             @focus_input="handleFocusAddress"
                @keydown.native.ctrl.77="openDialogFileChooser" @keydown.native.ctrl.72="handleChangFormat"
                @keydown.native.ctrl.83="handleKeySaveDraft" @handleShowAddressSelector="handleShowAddressSelector"
                @openDialogAddressSeletor="openDialogAddressSeletor" @moveAddress="moveAddress" />
            <AddressSelector :showAvatar="true" v-if="!showCc" v-model="modelData.cc" @change="handleSaveDraft"
                @changeText="changeTextCc" ref="ccAddressSelector" :type="$t('zimbra.zhMsg.cc')" :showCc="false"
                :showBcc="false" @keydown.native.ctrl.71="handleOpenDialogFormVisible"
                @keydown.native.ctrl.77="openDialogFileChooser" @keydown.native.ctrl.72="handleChangFormat"
                @keydown.native.ctrl.83="handleKeySaveDraft" @openDialogAddressSeletor="openDialogAddressSeletor"
                @moveAddress="moveAddress"  @focus_input="handleFocusAddress"/>
            <AddressSelector :showAvatar="true" v-if="!showBcc" v-model="modelData.bcc" @change="handleSaveDraft"
                @changeText="changeTextBcc" ref="bccAddressSelector" :type="$t('zimbra.zhMsg.bcc')" :showCc="false"
                :showBcc="false" @keydown.native.ctrl.71="handleOpenDialogFormVisible"
                @keydown.native.ctrl.77="openDialogFileChooser" @keydown.native.ctrl.72="handleChangFormat"
                @keydown.native.ctrl.83="handleKeySaveDraft" @openDialogAddressSeletor="openDialogAddressSeletor"
                @moveAddress="moveAddress" @focus_input="handleFocusAddress" />
            <div class="row-input row-input-subject">
                <span class="head" style="margin-bottom: 0!important;" @click="$refs.subjectInput.focus()">{{
                    $t("zimbra.zhMsg.FILT_COND_HEADER_subject") }}</span>
                <input @keydown.ctrl.71="handleOpenDialogFormVisible" @keydown.ctrl.77="openDialogFileChooser"
                    @keydown.ctrl.72="handleChangFormat" @keydown.ctrl.83="handleKeySaveDraft"
                    v-model="modelData.subject" @change="handleSaveDraft" type="text" class="form-control"
                    value="Eos et est sed corporis ut. Temporibus iste" ref="subjectInput" />
            </div>
            <div class="row-input row-input-attach">
                <el-tooltip :tabindex="-1"  class="item" effect="dark" :content="$t('zimbra.zmMsg.attach')" placement="top-start">
                    <el-dropdown :tabindex="-1" class="dropdown-attach-file" split-button size="small" placement="bottom-start"
                        style="flex: 0 0 auto;margin-right: 2rem;" trigger="click"
                        :class="[actionType === EMAIL_ACTION.EDIT_REPLY_CAL ? 'noclick' : '', ' item left']"
                        @click="openDialogFileChooser" @command="handleAttachCommand">
                        {{ $t("zimbra.zmMsg.attach") }}
                        <el-dropdown-menu slot="dropdown" tabindex="-1" >
                            <el-dropdown-item :command="ATTACT_TYPE.MY_COMPUTER">
                                {{ $t("zimbra.zmMsg.myComputer") }}
                            </el-dropdown-item>
                            <el-dropdown-item :class="[contentType == EMAIL_CONTENT_TYPE.HTML ? '' : 'noclick']"
                                :command="ATTACT_TYPE.ATTACHINLINE">
                                {{ $t("zimbra.zmMsg.attachInline") }}
                            </el-dropdown-item>
                            <el-dropdown-item :command="ATTACT_TYPE.BRIEFCASE">
                                {{ $t("zimbra.zhMsg.ALT_APP_BRIEFCASE") }}
                            </el-dropdown-item>
                            <el-dropdown-item :command="ATTACT_TYPE.CONTACTS">
                                {{ $t("zimbra.zhMsg.addressBook") }}
                            </el-dropdown-item>
                            <el-dropdown-item :command="ATTACT_TYPE.MAIL">
                                {{ $t("zimbra.zhMsg.ALT_APP_MAIL") }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-tooltip>
                <div class="w-100">
                    <div class="list-attach" id="drop_zone" @drop.prevent="dropHandler" @dragover.prevent>
                        <template
                            v-if="fileUploading || (listFileAttachmentDisplay && listFileAttachmentDisplay.length > 0)">
                            <template v-if="fileUploading">
                                <el-progress :text-inside="true" :stroke-width="22" :width="200"
                                             :percentage="percentUploading" :format="formatprogress"></el-progress>
                            </template>
                            <div v-for="(item, index) in listFileAttachmentDisplay" :key="index" class="item">
                                <i :class="`ic ic-${classFileType(item.filename || item.name)}`"></i>
                                <el-popover trigger="hover" popper-class="zm-view-attachment view-file-name"
                                            :open-delay="500">
                                    {{ item.name }}
                                    <span v-if="item?.part" slot="reference" class="first">
                                        <a href="javascript:;" @click="actionClickFileAttach(item, draftId)">
                                            {{ item.nameShort }}
                                        </a>
                                    </span>
                                    <span v-else slot="reference" class="first">{{ item.nameShort }}</span>
                                </el-popover>
                                <a href="javascript:;" class="remove-attach"
                                   @click.stop="onRemoveAttachment(index)"></a>
                            </div>
                        </template>
                        <template v-else>
                            <i>
                                {{ $t("zimbra.zmMsg.dndTooltip") }}
                            </i>
                        </template>
                    </div>
                    <div v-if="
                        listFileAttachmentOrigin &&
                        listFileAttachmentOrigin.length > 0
                    ">
                        <a href="javascript:;" class="zm-reply-attach-origin" @click="addOriginalAttachments">
                            {{ $t("zimbra.zmMsg.replyAttach") }}
                        </a>
                    </div>
                </div>
                <input type="file" style="display: none" ref="fileChooser" @change="onSelectedFile"
                       multiple="multiple" />
            </div>
            <div class="zb-editor" style="flex-grow: 1" @click="visible = false" :class="{
                'newrecord-mode': actionType === EMAIL_ACTION.NEW_RECORD,
                'replyall-mode': actionType === EMAIL_ACTION.REPLY_ALL,
                'forward-mode': actionType === EMAIL_ACTION.FORWARD
            }">
                <div class="editor-wrapper" ref="wrapperEditor" @dragover.prevent="onDropOver" @drop.prevent="onDrop"
                     @dragleave.prevent="onDragLeave">
                    <transition name="fade">
                        <div v-show="showDropZone" class="drop-zone-overlay">
                            <div class="drop-zone">
                                <p>{{ $t('zimbraNokey.drop_file_to_upload') }}</p>
                            </div>
                        </div>
                    </transition>
<!--                    <ai-compose-dialog-->
<!--                        :visible="dialogAI"-->
<!--                        :type-dialog-ai="typeDialogAI"-->
<!--                        @close="dialogAI = false"-->
<!--                        @submit="openComposePopup"-->
<!--                    />-->
                    <editor ref="refEditor" api-key="4zky3dv5w4gtp5qhvtqxn4kqrsv40aetwg5231hix40ff9xq"
                            v-if="contentType == EMAIL_CONTENT_TYPE.HTML" v-model="editorModel" class="form-control" :init="{
                            selector: 'textarea',
                            height: '100%',
                            paste_data_images: true,
                            forced_root_block: 'p',
                            forced_root_block_attrs: {
                                style: `  color: ${htmlEditorDefaultFontColor.content}; margin: .2rem 0`
                            },
                            extended_valid_elements: 'img[src|alt|width|height|dfsrc|data-mce-src]',
                            paste_preprocess: function (plugin, args) {
                                paste_preprocess(plugin, args);
                            },
                            menubar: false,
                            statusbar: false,
                            setup: function (ed) {
                                ed.on('PreInit', () => {
                                    this.editorTiny = ed;
                                    ed.editorManager.addI18n('vi', {
                                        'Fonts': 'Kiểu chữ'
                                    });
                                });
                                ed.on('dragover', function (e) {
                                    e.preventDefault()
                                    showDropZone = true
                                })
                                ed.on('init', () => {
                                    handleInitEditorObserver(ed, observer)
                                });
                                ed.on('keydown', function (e) {
                                    if (e.ctrlKey && e.keyCode == 13) {
                                        handleSendMsgShortcut(e);
                                    }
                                    if (e.key === 'Tab') {
                                        e.preventDefault()
                                        ed.execCommand('mceInsertContent', false, '&emsp;')
                                    }
                                    if (e.key === 'Backspace' || e.key === 'Delete') {
                                        const node = ed.selection.getNode();
                                        if (node.tagName === 'SPAN' && node.getAttribute('data-type') == 'email-source') {
                                            ed.dom.remove(node);
                                        }

                                    }
                                    if (e.keyCode === 9) {
                                        handleTab(e, ed);
                                    }
                                    if (e.ctrlKey && e.keyCode == 83) {
                                        handleKeySaveDraft(e);
                                    }
                                    if (e.ctrlKey && e.keyCode == 71) {
                                        handleOpenDialogFormVisible(e);
                                    }
                                    if (e.ctrlKey && e.keyCode == 77) {
                                        openDialogFileChooser(e);
                                    }
                                    if (e.ctrlKey && e.keyCode == 72) {
                                        handleChangFormat(e);
                                    }
                                });
                                ed.ui.registry.addButton('choiceFile', {
                                    icon: 'image',
                                    onAction: function () {
                                        handleOpenBrowser(ed);
                                    }
                                });
                                // ed.ui.registry.addMenuButton('ai', {
                                //   icon: 'edit-ai',
                                //   tooltip: $t('zimbraNokey.aiCompose'),   // i18n cho tooltip
                                //   fetch: (callback) => {
                                //     callback([
                                //       {
                                //         type: 'menuitem',
                                //         text: $t('zimbraNokey.composeNew'),
                                //         onAction: () => {
                                //           dialogAI = true;
                                //           typeDialogAI = ACTION_AI_COMPOSE.COMPOSE_MAIL;
                                //         }
                                //       },
                                //       {
                                //         type: 'menuitem',
                                //         text: $t('zimbraNokey.customAI'),
                                //         onAction: () => {
                                //           const selectedText = ed.selection.getContent({ format: 'text' });
                                //           if(!selectedText){
                                //               $message({message: $t('zimbraNokey.noSelectedText'),type: 'warning'})}else {
                                //               dialogAI = true;
                                //               typeDialogAI = ACTION_AI_COMPOSE.CUSTOM;
                                //               requireContent = selectedText
                                //               }
                                //         }
                                //       },
                                //       {
                                //         type: 'menuitem',
                                //         text: $t('zimbraNokey.shorterMail'),
                                //         onAction: () => {
                                //           const selectedText = ed.selection.getContent({ format: 'text' });
                                //           handleAIStream(ed, selectedText, ACTION_AI_COMPOSE.SHORTER_MAIL);
                                //         }
                                //       },
                                //       {
                                //         type: 'menuitem',
                                //         text: $t('zimbraNokey.longerMail'),
                                //         onAction: () => {
                                //           const selectedText = ed.selection.getContent({ format: 'text' });
                                //           handleAIStream(ed, selectedText, ACTION_AI_COMPOSE.LONGER_MAIL);
                                //         }
                                //       },
                                //       {
                                //         type: 'menuitem',
                                //         text: $t('zimbraNokey.formalize'),
                                //         onAction: () => {
                                //           const selectedText = ed.selection.getContent({ format: 'text' });
                                //           handleAIStream(ed, selectedText, ACTION_AI_COMPOSE.FORMALIZE);
                                //         }
                                //       },
                                //       {
                                //         type: 'menuitem',
                                //         text: $t('zimbraNokey.translateEn'),
                                //         onAction: () => {
                                //           const selectedText = ed.selection.getContent({ format: 'text' });
                                //           handleAIStream(ed, selectedText, ACTION_AI_COMPOSE.TRANSLATE_EN);
                                //         }
                                //       },
                                //       {
                                //         type: 'menuitem',
                                //         text: $t('zimbraNokey.standardFormat'),
                                //         onAction: () => {
                                //           const selectedText = ed.selection.getContent({ format: 'text' });
                                //           handleAIStream(ed, selectedText, ACTION_AI_COMPOSE.STANDARD_FORMAT);
                                //         }
                                //       }
                                //     ]);
                                //   }
                                // });

                                // Custom icon chevrondown for Tiny
                                // ed.ui.registry.addIcon('edit-ai', `<svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'> <path d='M15.3457 17.4817V8.2959H16.9881V17.4817H15.3457Z' fill='white'/> <path d='M15.3457 17.4817V8.2959H16.9881V17.4817H15.3457Z' fill='url(#paint1_linear_2186_154365)'/> <path d='M5.94922 17.4817L9.23394 8.2959H11.08L14.3647 17.4817H12.6396L11.863 15.1072H8.44459L7.66797 17.4817H5.94922ZM10.1379 9.93189L8.85836 13.8405H11.4492L10.1761 9.93189H10.1379Z' fill='url(#paint2_linear_2186_154365)'/> <path d='M18.3701 1.48145C18.3701 1.48145 18.6482 2.67531 19.1715 3.19858C19.6947 3.72185 20.8886 3.99996 20.8886 3.99996C20.8886 3.99996 19.6947 4.27808 19.1715 4.80135C18.6482 5.32462 18.3701 6.51848 18.3701 6.51848C18.3701 6.51848 18.092 5.32462 17.5687 4.80135C17.0454 4.27808 15.8516 3.99996 15.8516 3.99996C15.8516 3.99996 17.0454 3.72185 17.5687 3.19858C18.092 2.67531 18.3701 1.48145 18.3701 1.48145Z' fill='currentColor'/> <path d='M18.3701 1.48145C18.3701 1.48145 18.6482 2.67531 19.1715 3.19858C19.6947 3.72185 20.8886 3.99996 20.8886 3.99996C20.8886 3.99996 19.6947 4.27808 19.1715 4.80135C18.6482 5.32462 18.3701 6.51848 18.3701 6.51848C18.3701 6.51848 18.092 5.32462 17.5687 4.80135C17.0454 4.27808 15.8516 3.99996 15.8516 3.99996C15.8516 3.99996 17.0454 3.72185 17.5687 3.19858C18.092 2.67531 18.3701 1.48145 18.3701 1.48145Z' fill='url(#paint3_linear_2186_154365)'/> <path d='M20.8894 5.33301C20.8894 5.33301 21.0694 6.10551 21.4079 6.44409C21.7465 6.78268 22.519 6.96264 22.519 6.96264C22.519 6.96264 21.7465 7.1426 21.4079 7.48118C21.0694 7.81977 20.8894 8.59227 20.8894 8.59227C20.8894 8.59227 20.7094 7.81977 20.3709 7.48118C20.0323 7.1426 19.2598 6.96264 19.2598 6.96264C19.2598 6.96264 20.0323 6.78268 20.3709 6.44409C20.7094 6.10551 20.8894 5.33301 20.8894 5.33301Z' fill='white'/> <path d='M20.8894 5.33301C20.8894 5.33301 21.0694 6.10551 21.4079 6.44409C21.7465 6.78268 22.519 6.96264 22.519 6.96264C22.519 6.96264 21.7465 7.1426 21.4079 7.48118C21.0694 7.81977 20.8894 8.59227 20.8894 8.59227C20.8894 8.59227 20.7094 7.81977 20.3709 7.48118C20.0323 7.1426 19.2598 6.96264 19.2598 6.96264C19.2598 6.96264 20.0323 6.78268 20.3709 6.44409C20.7094 6.10551 20.8894 5.33301 20.8894 5.33301Z' fill='url(#paint4_linear_2186_154365)'/> <path d='M20.8886 1.03711C20.8886 1.03711 21.0031 1.5287 21.2186 1.74416C21.434 1.95963 21.9256 2.07415 21.9256 2.07415C21.9256 2.07415 21.434 2.18867 21.2186 2.40413C21.0031 2.61959 20.8886 3.11118 20.8886 3.11118C20.8886 3.11118 20.7741 2.61959 20.5586 2.40413C20.3432 2.18867 19.8516 2.07415 19.8516 2.07415C19.8516 2.07415 20.3432 1.95963 20.5586 1.74416C20.7741 1.5287 20.8886 1.03711 20.8886 1.03711Z' fill='white'/> <path d='M20.8886 1.03711C20.8886 1.03711 21.0031 1.5287 21.2186 1.74416C21.434 1.95963 21.9256 2.07415 21.9256 2.07415C21.9256 2.07415 21.434 2.18867 21.2186 2.40413C21.0031 2.61959 20.8886 3.11118 20.8886 3.11118C20.8886 3.11118 20.7741 2.61959 20.5586 2.40413C20.3432 2.18867 19.8516 2.07415 19.8516 2.07415C19.8516 2.07415 20.3432 1.95963 20.5586 1.74416C20.7741 1.5287 20.8886 1.03711 20.8886 1.03711Z' fill='url(#paint5_linear_2186_154365)'/> <defs> <clipPath id='paint0_angular_2186_154365_clip_path'><path d='M20.9727 10.9627C21.3817 10.9685 21.7086 11.3047 21.7028 11.7138L21.6037 18.8004C21.5709 21.1495 19.6572 23.0367 17.3079 23.0367H5.9252C3.55242 23.0367 1.62891 21.1132 1.62891 18.7404V7.11075C1.62891 4.73797 3.55242 2.81445 5.9252 2.81445H12.9622C13.3713 2.81445 13.703 3.14609 13.703 3.55519C13.703 3.96429 13.3713 4.29593 12.9622 4.29593H5.9252C4.37062 4.29593 3.11039 5.55617 3.11039 7.11075V18.7404C3.11039 20.295 4.37062 21.5552 5.9252 21.5552H17.3079C18.8471 21.5552 20.1009 20.3188 20.1224 18.7797L20.2216 11.6929C20.2274 11.2839 20.5636 10.957 20.9727 10.9627Z'/></clipPath><linearGradient id='paint1_linear_2186_154365' x1='15.9049' y1='8.29648' x2='16.1484' y2='17.4817' gradientUnits='userSpaceOnUse'> <stop stop-color='#0DE4D9'/> <stop offset='0.25' stop-color='#229ED2'/> <stop offset='0.507692' stop-color='#3856CB'/> <stop offset='0.740385' stop-color='#6041CB'/> <stop offset='1' stop-color='#8C2ACB'/> </linearGradient> <linearGradient id='paint2_linear_2186_154365' x1='8.81438' y1='8.29648' x2='13.3329' y2='17.4817' gradientUnits='userSpaceOnUse'> <stop stop-color='#0DE4D9'/> <stop offset='0.526888' stop-color='#3856CB'/> <stop offset='1' stop-color='#8C2ACB'/> </linearGradient> <linearGradient id='paint3_linear_2186_154365' x1='16.9627' y1='2.59256' x2='18.1219' y2='6.38846' gradientUnits='userSpaceOnUse'> <stop stop-color='#0DE4D9'/> <stop offset='0.25' stop-color='#229ED2'/> <stop offset='0.507692' stop-color='#3856CB'/> <stop offset='0.740385' stop-color='#6041CB'/> <stop offset='1' stop-color='#8C2ACB'/> </linearGradient> <linearGradient id='paint4_linear_2186_154365' x1='19.9787' y1='6.05196' x2='20.7288' y2='8.50813' gradientUnits='userSpaceOnUse'> <stop stop-color='#0DE4D9'/> <stop offset='0.25' stop-color='#229ED2'/> <stop offset='0.507692' stop-color='#3856CB'/> <stop offset='0.740385' stop-color='#6041CB'/> <stop offset='1' stop-color='#8C2ACB'/> </linearGradient> <linearGradient id='paint5_linear_2186_154365' x1='20.3091' y1='1.49463' x2='20.7864' y2='3.05764' gradientUnits='userSpaceOnUse'> <stop stop-color='#0DE4D9'/> <stop offset='0.25' stop-color='#229ED2'/> <stop offset='0.507692' stop-color='#3856CB'/> <stop offset='0.740385' stop-color='#6041CB'/> <stop offset='1' stop-color='#8C2ACB'/> </linearGradient> </defs> </svg>` );
                                ed.ui.registry.addIcon('chevron-down', `<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='square' stroke-linejoin='arcs' ><path d='M6 9l6 6 6-6' style='fill: none !important;' /></svg>`);
                                // Custom icon bold for Tiny
                                ed.ui.registry.addIcon('bold', `<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 32 32' height='26' width='26'  version='1.1'><path d='M17.251 14.504a3.66 3.66 0 0 1 1.46.294 3.78 3.78 0 0 1 1.195.803c.339.339.607.736.803 1.191a3.63 3.63 0 0 1 .294 1.456 3.66 3.66 0 0 1-.294 1.46 3.78 3.78 0 0 1-1.998 1.998 3.66 3.66 0 0 1-1.46.294H11V8h6.251c.449 0 .869.086 1.262.257s.736.404 1.031.698.527.638.698 1.031.257.813.257 1.262a3.2 3.2 0 0 1-.252 1.266c-.168.395-.4.74-.694 1.035a3.3 3.3 0 0 1-1.035.698c-.395.171-.818.257-1.266.257zm-1.75-4.501h-1.27v3.996h1.27c.275 0 .534-.053.778-.16s.456-.25.635-.429.323-.391.429-.635.16-.503.16-.778-.053-.533-.16-.774-.25-.453-.429-.635-.391-.325-.635-.429-.503-.156-.778-.156zm.496 9.995c.275 0 .534-.052.778-.156s.456-.247.635-.429.323-.394.429-.635.16-.499.16-.774-.052-.534-.156-.778-.247-.457-.429-.639-.395-.325-.639-.429-.503-.156-.778-.156h-1.767v3.996h1.767z' fill='currentColor' fill-rule='nonzero'/></svg>`);
                                // Custom icon italic for Tiny
                                ed.ui.registry.addIcon('italic', `<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 32 32' height='26' width='26' version='1.1'><g id='Italic' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><rect id='Rectangle' x='8' y='8' width='16' height='16'/><polygon fill='currentColor' fill-rule='nonzero' points='20.24 9.07692308 18.4994792 9.07692308 14.7377083 20.9230769 17.6733333 20.9230769 16.6466667 22 11 22 12.0266667 20.9230769 13.3180208 20.9230769 17.0797917 9.07692308 14.5933333 9.07692308 15.62 8 21.2666667 8'/></g></svg>`);
                                // Custom icon underline for Tiny
                                ed.ui.registry.addIcon('underline', `<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 32 32' height='26' width='26' version='1.1'><g id='Underline' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'><rect id='Rectangle' x='8' y='8' width='16' height='16'/><path d='M16.225,21.8666667 C15.3305511,21.8666667 14.5694476,21.7375013 13.9416667,21.4791667 C13.3138857,21.220832 12.8013909,20.8513913 12.4041667,20.3708333 C12.0069425,19.8902754 11.7166676,19.3097256 11.5333333,18.6291667 C11.3499991,17.9486077 11.2583333,17.1861153 11.2583333,16.3416667 L11.2583333,8 L12.8583333,8 L12.8583333,16.2333333 C12.8583333,16.8388919 12.918055,17.3972197 13.0375,17.9083333 C13.156945,18.419447 13.3541653,18.8624981 13.6291667,19.2375 C13.904168,19.6125019 14.2666644,19.9055545 14.7166667,20.1166667 C15.1666689,20.3277788 15.7249967,20.4333333 16.3916667,20.4333333 C17.0305587,20.4333333 17.5680534,20.3319455 18.0041667,20.1291667 C18.44028,19.9263879 18.7916653,19.6458351 19.0583333,19.2875 C19.3250013,18.9291649 19.5166661,18.5013914 19.6333333,18.0041667 C19.7500006,17.506942 19.8083333,16.9666696 19.8083333,16.3833333 L19.8083333,8 L21.4083333,8 L21.4083333,16.125 C21.4083333,17.0027822 21.312501,17.7958298 21.1208333,18.5041667 C20.9291657,19.2125035 20.626391,19.8152753 20.2125,20.3125 C19.798609,20.8097247 19.2638922,21.1930542 18.6083333,21.4625 C17.9527745,21.7319458 17.158338,21.8666667 16.225,21.8666667 Z M11,22.9333333 L21.6666667,22.9333333 L21.6666667,24 L11,24 L11,22.9333333 Z' id='' fill='currentColor' fill-rule='nonzero'/></g></svg>`);
                                // Custom icon strikethrough for Tiny
                                ed.ui.registry.addIcon('strike-through', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-5860 -8860 32 32' height='32' width='32' ><path d='M-5835.5-8843.437h-4.208c.014.221.063.438.145.643a1.59 1.59 0 0 0 .324.506 1.39 1.39 0 0 0 .494.328c.209.08.432.12.656.116.211.001.421-.037.618-.112s.383-.175.552-.3v.73c-.193.116-.404.201-.623.253s-.452.079-.681.079a2.4 2.4 0 0 1-.909-.166 2.11 2.11 0 0 1-.71-.465 2.16 2.16 0 0 1-.469-.71 2.56 2.56 0 0 1-.187-.9h-.92c-.026.3-.093.595-.2.876-.097.261-.241.503-.423.714-.18.204-.403.367-.652.477-.279.118-.581.176-.884.168a1.58 1.58 0 0 1-1.436-.8h-.017v.689h-.764v-2.126h-1.443v2.125h-.772v-.748h-.017a1.6 1.6 0 0 1-1.474.86 2 2 0 0 1-.6-.087 1.35 1.35 0 0 1-.481-.261c-.138-.119-.248-.268-.32-.436a1.47 1.47 0 0 1-.116-.6 2 2 0 0 1 .05-.444c.033-.146.092-.286.174-.411h-1.707v-1.061h4.491c-.003-.275-.09-.543-.249-.768a.86.86 0 0 0-.73-.295c-.285-.002-.568.05-.834.154a2.7 2.7 0 0 0-.726.436v-.789c.24-.153.504-.267.78-.336a3.48 3.48 0 0 1 .847-.1 1.64 1.64 0 0 1 1.253.436c.293.354.443.804.422 1.262h1.453v-3.893h.764v3.138h.017a1.8 1.8 0 0 1 1.651-.945 2.06 2.06 0 0 1 .722.12c.209.076.401.193.564.344s.3.337.4.54c.109.221.184.457.224.7h1.07c.069-.265.186-.515.344-.739a2.27 2.27 0 0 1 .537-.535 2.26 2.26 0 0 1 .685-.324 2.9 2.9 0 0 1 .8-.108 3.22 3.22 0 0 1 .569.05c.187.034.367.095.535.183v.78a1.89 1.89 0 0 0-1.137-.374 1.54 1.54 0 0 0-.934.282c-.267.2-.472.47-.594.78h4.076zm-12.509 0h-1.7c-.164.055-.306.16-.407.3a.92.92 0 0 0-.116.5.77.77 0 0 0 .075.349c.048.097.116.182.2.249a.85.85 0 0 0 .291.149c.113.034.231.051.349.05.189.003.376-.035.548-.112a1.25 1.25 0 0 0 .411-.3 1.34 1.34 0 0 0 .258-.455c.062-.176.092-.361.091-.548zm4.457-2.125a1.43 1.43 0 0 0-.888.282c-.254.195-.435.47-.515.78h2.7a1.42 1.42 0 0 0-.457-.772c-.235-.197-.534-.3-.84-.29zm-.116 3.718c.211.005.419-.04.61-.129a1.3 1.3 0 0 0 .44-.349c.122-.152.216-.325.278-.51a2.75 2.75 0 0 0 .133-.606h-2.822v.174c-.002.19.032.378.1.556.063.166.157.318.278.448s.269.23.432.3a1.35 1.35 0 0 0 .551.116z' fill='currentColor'/></svg>`);
                                // Custom icon removeformat for Tiny
                                ed.ui.registry.addIcon('remove-formatting', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-5860 -8788 32 32' height='32' width='32'><defs><style> .cls-14 {fill: none;} .cls-15, .cls-16 {fill: #2E77D0;} .cls-16 {stroke: #fff;stroke-width: 1.5px;} .cls-4 {fill: #666;}</style></defs><g id='FB:_Formatting' data-name='FB: Formatting' transform='translate(-6820 -9291.998)'><rect id='Rectangle_2295' data-name='Rectangle 2295' class='cls-14' width='32' height='32' rx='2' transform='translate(960 503.998)'/><g id='Group_3976' data-name='Group 3976'><path id='Path_1800' data-name='Path 1800' class='cls-15' d='M10.318-1.062h3.495V0H5.62L3.561-2.059a1.561,1.561,0,0,1-.344-.519,1.6,1.6,0,0,1-.12-.61,1.6,1.6,0,0,1,.12-.61,1.561,1.561,0,0,1,.344-.519L7.172-7.927l-.54-1.635H2.93L2.225-7.437H1.063L4.25-17H5.313L8.043-8.8l3.113-3.1,5,5ZM6.275-10.625,4.781-15.107,3.287-10.625Zm4.881.216L6.591-5.844l3.5,3.5,4.565-4.565ZM8.807-1.062l.54-.531-3.5-3.5L4.316-3.561a.511.511,0,0,0-.158.374.511.511,0,0,0,.158.374L6.068-1.062Z' transform='translate(968 527.998)'/><path id='Path_1397' data-name='Path 1397' class='cls-16' d='M8.807-1.062l.54-.531-3.5-3.5L4.316-3.561a.511.511,0,0,0-.158.374.511.511,0,0,0,.158.374L6.068-1.062Z' transform='translate(968 527.998)'/><path id='Path_1398' data-name='Path 1398' class='cls-4' d='M10.318-1.062h3.495V0H5.62L3.561-2.059a1.561,1.561,0,0,1-.344-.519,1.6,1.6,0,0,1-.12-.61,1.6,1.6,0,0,1,.12-.61,1.561,1.561,0,0,1,.344-.519l7.6-7.587,5,5Zm.838-9.347L6.591-5.844l3.5,3.5,4.565-4.565ZM8.807-1.062l.54-.531-3.5-3.5L4.316-3.561a.511.511,0,0,0-.158.374.511.511,0,0,0,.158.374L6.068-1.062Z' transform='translate(968 527.998)'/></g></g></svg>`);
                                // Custom icon forecolor for Tiny
                                ed.ui.registry.addIcon('text-color', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-6112 -8740 32 32'  height='26' width='26' ><defs><style> .cls-1 {fill: none;} .cls-2 {fill: currentColor;}</style></defs><g id='FB:_Color' data-name='FB: Color' transform='translate(-6999 -9194.9)'><rect id='Rectangle_2301' data-name='Rectangle 2301' class='cls-1' width='26' height='26' rx='2' transform='translate(887 456)'/><g id='Group_3809' data-name='Group 3809'><path id='Path_1600' data-name='Path 1600' class='cls-2' d='M3.926-3.187H2.806L7.413-17H8.525L13.132-3.187H12.011L10.6-7.437H5.337ZM5.694-8.5h4.549L7.969-15.315Z' transform='translate(895 479.999)'/><path id='tox-icon-text-color__color' data-name='Path 1000' stroke-width='5' fill: '#D82300' d='M13.813-2.125v3.063H2.125V-2.125Z' transform='translate(895 480)'/></g></g></svg>`);
                                // Custom icon backcolor for Tiny
                                ed.ui.registry.addIcon('highlight-bg-color', `<svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 22 22'><path id='tox-icon-highlight-bg-color__color' transform='translate(0,3)' fill='currentColor' d='M19 11.5s-2 2.17-2 3.5a2 2 8 0 0 2 2a2 2 0 0 0 2-2c0-1.33-2-3.5-2-3.5M5.21 10L10 5.21L14.79 10m1.77-1.06L7.62 0L6.21 1.41l2.38 2.38l-5.15 5.15c-.59.56-.59 1.53 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.59.59-1.56 0-2.12'/></path></svg>`);
                                // Custom icon outdent for Tiny
                                ed.ui.registry.addIcon('outdent', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-10408 -10457 32 32' height='32' width='32'><defs><style> .cls-5 {fill: none;} .cls-6 {fill: #666;} .cls-7 {fill: #2E77D0;}</style></defs><g id='_05-IndentLeft' data-name='05-IndentLeft' transform='translate(-11475 -10912.999)'><rect id='Rectangle_2306' data-name='Rectangle 2306' class='cls-5' width='32' height='32' rx='2' transform='translate(1067 455.999)'/><rect id='Rectangle_3057' data-name='Rectangle 3057' class='cls-6' width='9' height='1' transform='translate(1082 466.999)'/><rect id='Rectangle_3058' data-name='Rectangle 3058' class='cls-6' width='6' height='1' transform='translate(1082 468.999)'/><rect id='Rectangle_3059' data-name='Rectangle 3059' class='cls-6' width='9' height='1' transform='translate(1082 470.999)'/><rect id='Rectangle_3060' data-name='Rectangle 3060' class='cls-6' width='6' height='1' transform='translate(1082 472.999)'/><rect id='Rectangle_3061' data-name='Rectangle 3061' class='cls-6' width='9' height='1' transform='translate(1082 474.999)'/><g id='Group_3989' data-name='Group 3989' transform='translate(-11)'><rect id='Rectangle_3062' data-name='Rectangle 3062' class='cls-7' width='6' height='1' transform='translate(1086 470.999)'/><path id='Arrow' class='cls-7' d='M11395,10917v-4h4v1h-3v3Z' transform='translate(-14689.138 812.326) rotate(-45)'/></g></g></svg>`);
                                // Custom icon indent for Tiny
                                ed.ui.registry.addIcon('indent', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-10376 -10457 32 32' height='32' width='32'><defs><style> .cls-5 {fill: none;} .cls-6 {fill: #666;} .cls-7 {fill: #2E77D0;}</style></defs><g id='_06-IndentRight' data-name='06-IndentRight' transform='translate(-11443 -10912.999)'><rect id='Rectangle_2306' data-name='Rectangle 2306' class='cls-5' width='32' height='32' rx='2' transform='translate(1067 455.999)'/><rect id='Rectangle_3057' data-name='Rectangle 3057' class='cls-6' width='9' height='1' transform='translate(1082 466.999)'/><rect id='Rectangle_3058' data-name='Rectangle 3058' class='cls-6' width='6' height='1' transform='translate(1082 468.999)'/><rect id='Rectangle_3059' data-name='Rectangle 3059' class='cls-6' width='9' height='1' transform='translate(1082 470.999)'/><rect id='Rectangle_3060' data-name='Rectangle 3060' class='cls-6' width='6' height='1' transform='translate(1082 472.999)'/><rect id='Rectangle_3061' data-name='Rectangle 3061' class='cls-6' width='9' height='1' transform='translate(1082 474.999)'/><g id='Group_3988' data-name='Group 3988' transform='translate(2165.999 942.998) rotate(180)'><rect id='Rectangle_3062' data-name='Rectangle 3062' class='cls-7' width='6' height='1' transform='translate(1086 470.999)'/><path id='Arrow' class='cls-7' d='M11395,10917v-4h4v1h-3v3Z' transform='translate(-14689.138 812.326) rotate(-45)'/></g></g></svg>`);
                                // Custom icon unorderedList for Tiny
                                ed.ui.registry.addIcon('unordered-list', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-10568 -10457 32 32' height='32' width='32'><defs><style> .cls-8 {fill: none;} .cls-9 {fill: #666;}.cls-10 {fill: #2E77D0;}</style></defs><g id='_00-UL' data-name='00-UL' transform='translate(-11635 -10912.999)'><rect id='Rectangle_2306' data-name='Rectangle 2306' class='cls-8' width='32' height='32' rx='2' transform='translate(1067 455.999)'/><rect id='Rectangle_3057' data-name='Rectangle 3057' class='cls-9' width='13' height='1' transform='translate(1078 466.999)'/><rect id='Rectangle_3058' data-name='Rectangle 3058' class='cls-9' width='13' height='1' transform='translate(1078 469.999)'/><rect id='Rectangle_3059' data-name='Rectangle 3059' class='cls-9' width='13' height='1' transform='translate(1078 472.999)'/><rect id='Rectangle_3060' data-name='Rectangle 3060' class='cls-9' width='13' height='1' transform='translate(1078 475.999)'/><rect id='Rectangle_3062' data-name='Rectangle 3062' class='cls-10' width='1' height='1' transform='translate(1075 466.999)'/><rect id='Rectangle_3065' data-name='Rectangle 3065' class='cls-10' width='1' height='1' transform='translate(1075 469.999)'/><rect id='Rectangle_3064' data-name='Rectangle 3064' class='cls-10' width='1' height='1' transform='translate(1075 472.999)'/><rect id='Rectangle_3063' data-name='Rectangle 3063' class='cls-10' width='1' height='1' transform='translate(1075 475.999)'/></g></svg>`);
                                // Custom icon ordered-list for Tiny
                                ed.ui.registry.addIcon('ordered-list', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-10536 -10457 32 32' height='32' width='32'><path d='M-10524-10446h12v1h-12zm0 4h12v1h-12zm0 4h12v1h-12z' fill='currentColor'/><path d='M-10526.879-10446.1a1.5 1.5 0 0 1-.311.178c-.11.053-.231.083-.353.087v-.573q.257-.091.49-.2c.159-.074.309-.166.448-.274h.405v3.2h-.679zm-.008 3.486c.133-.001.266.018.394.054a.9.9 0 0 1 .324.166c.092.075.166.17.216.278a.9.9 0 0 1 .079.39.98.98 0 0 1-.1.452 1.49 1.49 0 0 1-.245.349c-.097.102-.204.194-.32.274q-.174.12-.32.224c-.086.061-.167.13-.241.205-.06.055-.096.131-.1.212h1.325v.573h-2.083q0-.191 0-.34a.89.89 0 0 1 .083-.323 1.39 1.39 0 0 1 .34-.477q.216-.2.427-.361a3.42 3.42 0 0 0 .369-.332.55.55 0 0 0 .158-.39c.012-.119-.034-.237-.125-.315a.55.55 0 0 0-.332-.091.96.96 0 0 0-.411.091 1.61 1.61 0 0 0-.361.232v-.606c.275-.177.595-.271.922-.268zm.3 5.8c.187.022.363.1.506.224a.64.64 0 0 1 .208.506c.006.153-.029.305-.1.44-.066.118-.158.219-.27.295a1.19 1.19 0 0 1-.386.166 1.86 1.86 0 0 1-.444.054 2.5 2.5 0 0 1-.4-.033 1.34 1.34 0 0 1-.386-.125v-.606c.104.077.22.136.344.174a1.29 1.29 0 0 0 .386.058.8.8 0 0 0 .386-.091.35.35 0 0 0 .17-.34c.008-.102-.032-.202-.108-.27-.077-.061-.166-.103-.261-.125-.105-.025-.212-.038-.32-.037h-.29v-.531h.266c.096 0 .192-.009.286-.029a.51.51 0 0 0 .233-.116c.07-.066.107-.161.1-.257a.32.32 0 0 0-.137-.3.62.62 0 0 0-.328-.083 1.07 1.07 0 0 0-.614.2v-.56a1.45 1.45 0 0 1 .378-.129 2.09 2.09 0 0 1 .394-.037c.123 0 .245.014.365.042s.226.071.324.137.173.148.232.245a.67.67 0 0 1 .091.357.74.74 0 0 1-.162.5.87.87 0 0 1-.461.261z' fill='currentColor'/></svg>`);
                                // Custom icon quote for Tiny
                                ed.ui.registry.addIcon('quote', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-6041 -10332 32 32' height='32' width='32'><defs><style>.cls-1 {fill: none;}.cls-2 {fill: currentColor;stroke: rgba(0,0,0,0);}</style></defs><g id='FB:_Blockquote' data-name='FB: Blockquote' transform='translate(-7068 -10737.999)'><rect id='Rectangle_2306' data-name='Rectangle 2306' class='cls-1' width='32' height='32' rx='2' transform='translate(1027 405.999)'/><path id='Path_1832' data-name='Path 1832' class='cls-2' d='M0,.548H2.756V3.4a6.779,6.779,0,0,1-.058.872,4.99,4.99,0,0,1-.191.867,4.138,4.138,0,0,1-.344.793,2.7,2.7,0,0,1-.51.652,2.25,2.25,0,0,1-.7.44,2.419,2.419,0,0,1-.909.162v-1.3a1.132,1.132,0,0,0,.535-.12,1.225,1.225,0,0,0,.386-.315,1.6,1.6,0,0,0,.253-.452,3.431,3.431,0,0,0,.149-.531,4.641,4.641,0,0,0,.075-.552q.021-.278.021-.51H0Zm7.263,0V3.4a6.8,6.8,0,0,1-.133,1.32,3.967,3.967,0,0,1-.448,1.22,2.67,2.67,0,0,1-.834.9,2.279,2.279,0,0,1-1.3.349v-1.3a1.08,1.08,0,0,0,.743-.253,1.664,1.664,0,0,0,.44-.631,3.189,3.189,0,0,0,.208-.809A6.4,6.4,0,0,0,5.993,3.4H4.532V.548Z' transform='translate(1039 418.451)'/></g></svg>`);
                                // Custom icon align-left for Tiny
                                ed.ui.registry.addIcon('align-left', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-10504 -10457 32 32' height='32' width='32'><defs><style>.cls-1 {fill: none;}.cls-2 {fill: #666;}</style></defs><g id='_02-Left' data-name='02-Left' transform='translate(-11571 -10912.999)'><rect id='Rectangle_2306' data-name='Rectangle 2306' class='cls-1' width='32' height='32' rx='2' transform='translate(1067 455.999)'/><rect id='Rectangle_3057' data-name='Rectangle 3057' class='cls-2' width='17' height='1' transform='translate(1075 464.999)'/><rect id='Rectangle_3058' data-name='Rectangle 3058' class='cls-2' width='13' height='1' transform='translate(1075 467.999)'/><rect id='Rectangle_3059' data-name='Rectangle 3059' class='cls-2' width='17' height='1' transform='translate(1075 470.999)'/><rect id='Rectangle_3060' data-name='Rectangle 3060' class='cls-2' width='13' height='1' transform='translate(1075 473.999)'/><rect id='Rectangle_3061' data-name='Rectangle 3061' class='cls-2' width='17' height='1' transform='translate(1075 476.999)'/></g></svg>`);
                                // Custom icon align-center for Tiny
                                ed.ui.registry.addIcon('align-center', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-10472 -10457 32 32' height='32' width='32'><defs><style>.cls-1 {fill: none;}.cls-2 {fill: #666;}</style></defs><g id='_03-Center' data-name='03-Center' transform='translate(-11539 -10912.999)'><rect id='Rectangle_2306' data-name='Rectangle 2306' class='cls-1' width='32' height='32' rx='2' transform='translate(1067 455.999)'/><rect id='Rectangle_3057' data-name='Rectangle 3057' class='cls-2' width='17' height='1' transform='translate(1075 464.999)'/><rect id='Rectangle_3058' data-name='Rectangle 3058' class='cls-2' width='13' height='1' transform='translate(1077 467.999)'/><rect id='Rectangle_3059' data-name='Rectangle 3059' class='cls-2' width='17' height='1' transform='translate(1075 470.999)'/><rect id='Rectangle_3060' data-name='Rectangle 3060' class='cls-2' width='13' height='1' transform='translate(1077 473.999)'/><rect id='Rectangle_3061' data-name='Rectangle 3061' class='cls-2' width='17' height='1' transform='translate(1075 476.999)'/></g></svg>`);
                                // Custom icon align-right for Tiny
                                ed.ui.registry.addIcon('align-right', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-10440 -10457 32 32' height='32' width='32'><defs><style>.cls-1 {fill: none;}.cls-2 {fill: #666;}</style></defs><g id='_04-Right' data-name='04-Right' transform='translate(-11507 -10912.999)'><rect id='Rectangle_2306' data-name='Rectangle 2306' class='cls-1' width='32' height='32' rx='2' transform='translate(1067 455.999)'/><rect id='Rectangle_3057' data-name='Rectangle 3057' class='cls-2' width='17' height='1' transform='translate(1075 464.999)'/><rect id='Rectangle_3058' data-name='Rectangle 3058' class='cls-2' width='13' height='1' transform='translate(1079 467.999)'/><rect id='Rectangle_3059' data-name='Rectangle 3059' class='cls-2' width='17' height='1' transform='translate(1075 470.999)'/><rect id='Rectangle_3060' data-name='Rectangle 3060' class='cls-2' width='13' height='1' transform='translate(1079 473.999)'/><rect id='Rectangle_3061' data-name='Rectangle 3061' class='cls-2' width='17' height='1' transform='translate(1075 476.999)'/></g></svg>`);
                                // Custom icon align-justify for Tiny
                                //ed.ui.registry.addIcon('align-justify', `<svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='#666' stroke-width='1' stroke-linecap='butt' stroke-linejoin='arcs'><path d='M21 9.5H3M21 4.5H3M21 14.5H3M21 19.5H3'/></svg>` );
                                // Custom icon image for Tiny
                                ed.ui.registry.addIcon('image', `<svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 20 20'><path fill='currentColor' d='m5.122.282l-.348 1.071A2.2 2.2 0 0 1 3.376 2.75l-1.072.348l-.022.006a.423.423 0 0 0 0 .798l1.072.348a2.2 2.2 0 0 1 1.399 1.397l.348 1.07a.423.423 0 0 0 .798 0l.348-1.07a2.2 2.2 0 0 1 1.399-1.403l1.072-.348a.423.423 0 0 0 0-.798L7.646 2.75a2.2 2.2 0 0 1-1.377-1.397L5.92.283a.423.423 0 0 0-.799 0M.217 8.213l.766-.248a1.58 1.58 0 0 0 .998-.999l.25-.764a.302.302 0 0 1 .57 0l.248.764a1.58 1.58 0 0 0 .984.999l.765.248a.302.302 0 0 1 0 .57l-.765.249a1.58 1.58 0 0 0-1 1.002l-.248.764a.302.302 0 0 1-.57 0l-.249-.764a1.58 1.58 0 0 0-.999-.999l-.765-.248a.302.302 0 0 1 0-.57zM3 14v-2.1a1.3 1.3 0 0 0 .244-.13c.22-.16.38-.371.48-.621l.26-.802l.016-.039V14c0 .373.102.722.28 1.02l4.669-4.588a1.5 1.5 0 0 1 2.102 0l4.67 4.588A2 2 0 0 0 16 14V6a2 2 0 0 0-2-2H9.91q.09-.239.09-.504q0-.26-.088-.496H14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3m11-6.5a1.5 1.5 0 1 1-3 0a1.5 1.5 0 0 1 3 0m-1 0a.5.5 0 1 0-1 0a.5.5 0 0 0 1 0m1 8.5c.37 0 .715-.1 1.012-.274l-4.662-4.58a.5.5 0 0 0-.7 0l-4.662 4.58A2 2 0 0 0 6 16z'/></svg>`);
                                // Custom icon link for Tiny
                                ed.ui.registry.addIcon('link', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-5896 -8896 32 32' width='32' height='32'><path d='M-5875.219-8882.625c.498-.003.991.097 1.448.295a3.79 3.79 0 0 1 1.979 1.979c.196.456.296.948.292 1.445.003.498-.097.991-.295 1.448a3.79 3.79 0 0 1-1.979 1.979c-.457.198-.95.298-1.448.295h-4.247c-.498.002-.991-.099-1.448-.298a3.79 3.79 0 0 1-1.979-1.979c-.198-.457-.298-.95-.295-1.448-.003-.498.097-.991.295-1.448a3.79 3.79 0 0 1 1.979-1.979c.457-.198.95-.298 1.448-.295h.531v1.063a4.93 4.93 0 0 0-1.208.145c-.366.088-.711.246-1.017.465-.295.215-.534.497-.7.822-.184.381-.274.801-.261 1.224a2.53 2.53 0 0 0 .212 1.029c.137.314.331.6.573.843s.526.44.839.578a2.53 2.53 0 0 0 1.031.212h4.25a2.53 2.53 0 0 0 1.029-.212c.314-.137.6-.331.843-.573s.436-.529.573-.843a2.53 2.53 0 0 0 .212-1.029c.013-.423-.077-.843-.261-1.224-.166-.325-.405-.607-.7-.822-.306-.219-.651-.377-1.017-.465a4.93 4.93 0 0 0-1.21-.144v-1.062zm-5.844 4.25v-1.062a4.93 4.93 0 0 0 1.208-.146c.366-.088.711-.246 1.017-.465.295-.215.534-.497.7-.822.184-.381.274-.801.261-1.224a2.53 2.53 0 0 0-.212-1.029c-.137-.314-.331-.6-.573-.843s-.525-.435-.838-.572a2.53 2.53 0 0 0-1.031-.212h-4.25a2.53 2.53 0 0 0-1.029.212c-.314.137-.6.331-.843.573s-.436.529-.573.843a2.53 2.53 0 0 0-.212 1.029c-.013.423.077.843.261 1.224.166.325.405.607.7.822.306.219.651.377 1.017.465a4.93 4.93 0 0 0 1.208.145v1.063h-.531c-.498.003-.99-.098-1.447-.296a3.79 3.79 0 0 1-1.979-1.979c-.196-.456-.295-.948-.291-1.445-.003-.498.097-.991.295-1.448a3.79 3.79 0 0 1 1.979-1.979c.457-.198.95-.298 1.448-.295h4.25c.498-.003.991.097 1.448.295a3.79 3.79 0 0 1 1.979 1.979c.198.457.298.95.295 1.448.003.498-.097.991-.295 1.448a3.79 3.79 0 0 1-1.979 1.979c-.457.198-.95.298-1.448.295z' fill='currentColor'/></svg>`);
                                // Custom icon unlink for Tiny
                                ed.ui.registry.addIcon('unlink', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-5860 -8896 32 32' width='32' height='32'><path d='M-5844.531-8885.812a3.56 3.56 0 0 1 1.444.295c.439.191.839.462 1.179.8a3.7 3.7 0 0 1 .8 1.179 3.63 3.63 0 0 1 .291 1.448 3.63 3.63 0 0 1-.291 1.448 3.7 3.7 0 0 1-.8 1.179c-.34.338-.74.609-1.179.8a3.56 3.56 0 0 1-1.444.295h-.531v-1.069h.531a2.57 2.57 0 0 0 1.031-.208 2.68 2.68 0 0 0 .843-.569c.243-.244.437-.531.573-.847a2.56 2.56 0 0 0 .212-1.033 2.53 2.53 0 0 0-.212-1.029c-.137-.314-.331-.6-.573-.843s-.529-.436-.843-.572a2.53 2.53 0 0 0-1.031-.212h-4.25a2.56 2.56 0 0 0-1.033.212c-.316.136-.603.33-.847.573a2.68 2.68 0 0 0-.569.843 2.57 2.57 0 0 0-.208 1.029 2.6 2.6 0 0 0 .208 1.033c.133.316.327.604.569.847s.531.436.847.569a2.6 2.6 0 0 0 1.033.208h.531v1.063h-.531c-.498.003-.992-.098-1.449-.297a3.79 3.79 0 0 1-1.979-1.979c-.196-.456-.295-.948-.291-1.445-.003-.498.097-.991.295-1.448a3.79 3.79 0 0 1 1.979-1.979c.457-.198.95-.298 1.448-.295zm7.952 6.712a2.66 2.66 0 0 0-.261-.971c-.142-.293-.336-.557-.573-.78a2.65 2.65 0 0 0-.818-.523c-.314-.128-.649-.193-.988-.191h-.531v-1.062h.531c.498-.003.991.097 1.448.295a3.79 3.79 0 0 1 1.979 1.979c.197.457.296.95.292 1.447a3.63 3.63 0 0 1-.091.8zm-9.546.191a2.6 2.6 0 0 0 .208 1.033c.133.316.327.604.569.847s.531.437.848.571a2.6 2.6 0 0 0 1.031.208h1.461l1.063 1.063h-2.524c-.498.003-.991-.097-1.448-.295a3.79 3.79 0 0 1-1.979-1.979c-.198-.457-.298-.95-.295-1.448-.003-.498.097-.991.295-1.448a3.79 3.79 0 0 1 1.979-1.979c.457-.198.95-.298 1.448-.295h.531v1.063h-.531a2.56 2.56 0 0 0-1.031.217c-.316.136-.603.33-.847.573a2.68 2.68 0 0 0-.569.843 2.57 2.57 0 0 0-.209 1.029zm10.6 2.374l-1.875 1.879 1.875 1.884-.747.747-1.884-1.875-1.885 1.883-.747-.755 1.888-1.884-1.888-1.885.747-.747 1.885 1.888 1.884-1.888z' fill='currentColor'/><path d='M-5835.525-8876.532l-1.875 1.876 1.875 1.884-.747.747-1.884-1.875-1.885 1.883-.747-.755 1.888-1.884-1.888-1.885.747-.747 1.885 1.888 1.884-1.888z' fill='currentColor'/></svg>`);
                                // Custom icon superscript for Tiny
                                ed.ui.registry.addIcon('superscript', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-5824 -8896 32 32' width='32' height='32'><defs><style>.cls-1 {fill: none;}</style></defs><g id='FB:_Superstring' data-name='FB: Superstring' transform='translate(-6876 -9199.999)'> <rect id='Rectangle_2295' data-name='Rectangle 2295' class='cls-1' width='32' height='32' rx='2' transform='translate(1052 303.999)'/><g id='Group_3921' data-name='Group 3921'><path id='Path_1723' data-name='Path 1723' class='cls-13' d='M5.62-12.966a.754.754,0,0,0-.087.1l-.079.112H7.438v1.063H4.25v-.531A1.872,1.872,0,0,1,4.408-13a2.9,2.9,0,0,1,.394-.639,4.425,4.425,0,0,1,.51-.531l.51-.448a3.533,3.533,0,0,0,.394-.4.61.61,0,0,0,.158-.39.511.511,0,0,0-.158-.374.511.511,0,0,0-.374-.158.511.511,0,0,0-.374.158.511.511,0,0,0-.158.374H4.25a1.564,1.564,0,0,1,.125-.623,1.6,1.6,0,0,1,.34-.506,1.6,1.6,0,0,1,.506-.34A1.564,1.564,0,0,1,5.844-17a1.564,1.564,0,0,1,.623.125,1.6,1.6,0,0,1,.506.34,1.6,1.6,0,0,1,.34.506,1.564,1.564,0,0,1,.125.623,1.553,1.553,0,0,1-.125.61,1.687,1.687,0,0,1-.34.519H6.964Zm-2.167.216L.266-8.5,3.453-4.25H2.125L-.4-7.612-2.922-4.25H-4.25L-1.062-8.5-4.25-12.75h1.328L-.4-9.388,2.125-12.75Z' transform='translate(1068 327.999)'/><path id='Path_1394' data-name='Path 1394' class='cls-10' d='M5.62-12.966a.754.754,0,0,0-.087.1l-.079.112H7.438v1.063H4.25v-.531A1.872,1.872,0,0,1,4.408-13a2.9,2.9,0,0,1,.394-.639,4.425,4.425,0,0,1,.51-.531l.51-.448a3.533,3.533,0,0,0,.394-.4.61.61,0,0,0,.158-.39.511.511,0,0,0-.158-.374.511.511,0,0,0-.374-.158.511.511,0,0,0-.374.158.511.511,0,0,0-.158.374H4.25a1.564,1.564,0,0,1,.125-.623,1.6,1.6,0,0,1,.34-.506,1.6,1.6,0,0,1,.506-.34A1.564,1.564,0,0,1,5.844-17a1.564,1.564,0,0,1,.623.125,1.6,1.6,0,0,1,.506.34,1.6,1.6,0,0,1,.34.506,1.564,1.564,0,0,1,.125.623,1.553,1.553,0,0,1-.125.61,1.687,1.687,0,0,1-.34.519H6.964Z' transform='translate(1068 327.999)'/></g></g></svg>`);
                                // Custom icon subscript for Tiny
                                ed.ui.registry.addIcon('subscript', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-5896 -8860 32 32' width='32' height='32'><defs><style>.cls-2 {fill: #666;}.cls-3 {fill: #2E77D0;}</style></defs><g id='FB:_Substring' data-name='FB: Substring' transform='translate(-6884 -9195.999)'><rect id='Rectangle_2295' data-name='Rectangle 2295' class='cls-1' width='32' height='32' rx='2' transform='translate(988 335.999)'/><g id='Group_3932' data-name='Group 3932'><path id='Path_1734' data-name='Path 1734' class='cls-2' d='M5.62-1.278a.754.754,0,0,0-.087.1l-.079.112H7.438V0H4.25V-.531a1.872,1.872,0,0,1,.158-.78A2.9,2.9,0,0,1,4.8-1.951a4.425,4.425,0,0,1,.51-.531l.51-.448a3.533,3.533,0,0,0,.394-.4.61.61,0,0,0,.158-.39.511.511,0,0,0-.158-.374.511.511,0,0,0-.374-.158.511.511,0,0,0-.374.158.511.511,0,0,0-.158.374H4.25a1.564,1.564,0,0,1,.125-.623,1.6,1.6,0,0,1,.34-.506,1.6,1.6,0,0,1,.506-.34,1.564,1.564,0,0,1,.623-.125,1.564,1.564,0,0,1,.623.125,1.6,1.6,0,0,1,.506.34,1.6,1.6,0,0,1,.34.506,1.564,1.564,0,0,1,.125.623,1.553,1.553,0,0,1-.125.61,1.687,1.687,0,0,1-.34.519H6.964ZM3.453-12.75.266-8.5,3.453-4.25H2.125L-.4-7.612-2.922-4.25H-4.25L-1.062-8.5-4.25-12.75h1.328L-.4-9.388,2.125-12.75Z' transform='translate(1004 359.999)'/><path id='Path_1397' data-name='Path 1397' class='cls-3' d='M5.62-1.278a.754.754,0,0,0-.087.1l-.079.112H7.438V0H4.25V-.531a1.872,1.872,0,0,1,.158-.78A2.9,2.9,0,0,1,4.8-1.951a4.425,4.425,0,0,1,.51-.531l.51-.448a3.533,3.533,0,0,0,.394-.4.61.61,0,0,0,.158-.39.511.511,0,0,0-.158-.374.511.511,0,0,0-.374-.158.511.511,0,0,0-.374.158.511.511,0,0,0-.158.374H4.25a1.564,1.564,0,0,1,.125-.623,1.6,1.6,0,0,1,.34-.506,1.6,1.6,0,0,1,.506-.34,1.564,1.564,0,0,1,.623-.125,1.564,1.564,0,0,1,.623.125,1.6,1.6,0,0,1,.506.34,1.6,1.6,0,0,1,.34.506,1.564,1.564,0,0,1,.125.623,1.553,1.553,0,0,1-.125.61,1.687,1.687,0,0,1-.34.519H6.964Z' transform='translate(1004 359.999)'/></g></g></svg>`);
                                // Custom icon ltr for Tiny
                                ed.ui.registry.addIcon('ltr', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-5896 -8824 32 32' width='32' height='32'><g id='FB:_Paragraph_In' data-name='FB: Paragraph In' transform='translate(-6884 -9191.999)'><rect id='Rectangle_2295' data-name='Rectangle 2295' class='cls-1' width='32' height='32' rx='2' transform='translate(988 367.999)'/><g id='Group_3954' data-name='Group 3954'><path id='Path_1756' data-name='Path 1756' class='cls-2' d='M-7.437-12.966l5.528,5.528L-7.437-1.909Zm1.063,8.5L-3.4-7.437l-2.972-2.972ZM6.375-14.875v12.75H7.438v1.063H2.125V-2.125H3.188V-8.5H1.594A3.632,3.632,0,0,1,.145-8.791a3.745,3.745,0,0,1-1.183-.8,3.745,3.745,0,0,1-.8-1.183,3.632,3.632,0,0,1-.291-1.448,3.632,3.632,0,0,1,.291-1.448,3.745,3.745,0,0,1,.8-1.183,3.745,3.745,0,0,1,1.183-.8,3.632,3.632,0,0,1,1.448-.291H7.438v1.063ZM3.188-9.562v-5.312H1.594a2.558,2.558,0,0,0-1.033.212,2.724,2.724,0,0,0-.847.573,2.679,2.679,0,0,0-.569.843,2.572,2.572,0,0,0-.208,1.029,2.6,2.6,0,0,0,.208,1.033,2.666,2.666,0,0,0,.569.847A2.666,2.666,0,0,0,.56-9.77a2.6,2.6,0,0,0,1.033.208ZM5.313-2.125v-12.75H4.25v12.75Z' transform='translate(1004 391.999)'/><path id='Path_1404' data-name='Path 1404' class='cls-3' d='M-7.437-12.966l5.528,5.528L-7.437-1.909Zm1.063,8.5L-3.4-7.437l-2.972-2.972Z' transform='translate(1004 391.999)'/></g></g></svg>`);
                                // Custom icon rtl for Tiny
                                ed.ui.registry.addIcon('rtl', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-5860 -8824 32 32' width='32' height='32'><g id='FB:_Paragraph_Out' data-name='FB: Paragraph Out' transform='translate(-6880 -9191.999)'><rect id='Rectangle_2295' data-name='Rectangle 2295' class='cls-1' width='32' height='32' rx='2' transform='translate(1020 367.999)'/><g id='Group_3965' data-name='Group 3965'><path id='Path_1767' data-name='Path 1767' class='cls-2' d='M1.063-15.937v1.063H0v12.75H1.063v1.063H-4.25V-2.125h1.063V-8.5H-4.781A3.632,3.632,0,0,1-6.23-8.791a3.745,3.745,0,0,1-1.183-.8,3.745,3.745,0,0,1-.8-1.183A3.632,3.632,0,0,1-8.5-12.219a3.632,3.632,0,0,1,.291-1.448,3.745,3.745,0,0,1,.8-1.183,3.745,3.745,0,0,1,1.183-.8,3.632,3.632,0,0,1,1.448-.291Zm-4.25,6.375v-5.312H-4.781a2.558,2.558,0,0,0-1.033.212,2.724,2.724,0,0,0-.847.573,2.679,2.679,0,0,0-.569.843,2.572,2.572,0,0,0-.208,1.029,2.6,2.6,0,0,0,.208,1.033,2.666,2.666,0,0,0,.569.847,2.666,2.666,0,0,0,.847.569,2.6,2.6,0,0,0,1.033.208Zm2.125,7.438v-12.75H-2.125v12.75Zm8.5-10.841V-1.909L1.909-7.437ZM6.375-10.409,3.4-7.437,6.375-4.466Z' transform='translate(1036 391.999)'/><path id='Path_1401' data-name='Path 1401' class='cls-3' d='M7.438-12.966V-1.909L1.909-7.437ZM6.375-10.409,3.4-7.437,6.375-4.466Z' transform='translate(1036 391.999)'/></g></g></svg>`);
                                // Custom icon emoticons for Tiny
                                ed.ui.registry.addIcon('emoji', `<svg xmlns='http://www.w3.org/2000/svg' width='22' height='22' viewBox='0 0 128 128'><radialGradient id='SVGIQWq2fvX' cx='63.6' cy='808.9' r='56.96' gradientTransform='translate(0 -746)' gradientUnits='userSpaceOnUse'><stop offset='.5' stop-color='#fde030'/><stop offset='.92' stop-color='#f7c02b'/><stop offset='1' stop-color='#f4a223'/></radialGradient><path fill='url(#SVGIQWq2fvX)' d='M63.6 118.8c-27.9 0-58-17.5-58-55.9S35.7 7 63.6 7c15.5 0 29.8 5.1 40.4 14.4c11.5 10.2 17.6 24.6 17.6 41.5s-6.1 31.2-17.6 41.4c-10.6 9.3-25 14.5-40.4 14.5'/><path fill='#eb8f00' d='M111.49 29.67c5.33 8.6 8.11 18.84 8.11 30.23c0 16.9-6.1 31.2-17.6 41.4c-10.6 9.3-25 14.5-40.4 14.5c-18.06 0-37-7.35-48.18-22.94c10.76 17.66 31 25.94 50.18 25.94c15.4 0 29.8-5.2 40.4-14.5c11.5-10.2 17.6-24.5 17.6-41.4c0-12.74-3.47-24.06-10.11-33.23'/><path fill='#422b0d' d='M64.25 95.44c-12.74 0-21.82-6.61-24.55-10.77a4.58 4.58 0 0 1-.56-4.67c.53-.97 1.56-1.57 2.67-1.56c.41 0 .82.07 1.21.2a72.3 72.3 0 0 0 21.28 3.07c7.17.04 14.31-1 21.18-3.07c.39-.13.8-.19 1.21-.2c1.11-.01 2.14.59 2.67 1.56a4.58 4.58 0 0 1-.56 4.67C86.07 88.83 77 95.44 64.25 95.44M97.51 62l-.2-.28c-.18-.26-.37-.51-.58-.75c-.72-.81-1.53-1.54-2.42-2.16c-1.2-.84-2.5-1.53-3.87-2.05c-.75-.29-1.52-.54-2.3-.74c-.39-.1-.82-.19-1.26-.28l-.6-.11l.59-.31l1.75-.92c1.13-.58 2.2-1.08 3.1-1.49s1.64-.7 2.14-.89l.76-.27l.22-.09c1.41-.58 2.07-2.2 1.49-3.61c-.4-.96-1.3-1.61-2.33-1.69c-.41-.02-.83-.02-1.24 0c-1.01.09-2.02.27-3 .52q-2.01.51-3.93 1.29c-.68.3-1.4.58-2.09.94s-1.44.74-2.06 1.07s-1.37.82-2 1.25s-1.27.88-1.87 1.32a27 27 0 0 0-3.13 2.7c-.73.72-1.39 1.5-2 2.33c-.18.24-.35.5-.5.76c-.08.16-.13.24-.13.24c-.37.9-.4 1.9-.08 2.82a2.75 2.75 0 0 0 3.57 1.54c.01 0 .02-.01.03-.01l.24-.09L76 63l.24-.06c.17 0 .48-.12.8-.19s.71-.14 1.13-.21c.99-.14 2-.22 3-.22c1.18 0 2.37.08 3.54.25c.21 0 .74.1 1 .15s.54.09.84.16c.58.14 1.15.26 1.69.42c.96.27 1.9.6 2.82 1c.6.28 1.19.59 1.76.94c.4.24.6.39.6.39l.28.21c1.2.91 2.92.67 3.82-.54c.74-.98.73-2.33-.01-3.3M44.67 46.94c-4.19 0-8 3.54-8 9.42s3.81 9.41 8 9.41s8-3.54 8-9.41s-3.81-9.42-8-9.42M29.84 44.8c-.87.01-1.68-.41-2.19-1.11c-.48-.72-.57-1.64-.23-2.44c2.04-5.12 5.98-9.26 11-11.54A20.2 20.2 0 0 1 44.27 28q.195-.015.39 0c1.26-.05 2.35.86 2.53 2.11c.18 1.33-.61 2.59-1.89 3l-.37-.7l.25.74a25.32 25.32 0 0 0-13 10.32c-.48.82-1.36 1.32-2.31 1.32z'/><path fill='#896024' d='M44.28 50.87a2.874 2.874 0 0 0-3.82 1.34c-.53 1.11-.29 2.44.6 3.3c1.42.68 3.13.08 3.82-1.34c.53-1.11.29-2.44-.6-3.3'/></svg>`);
                                // Custom icon table for Tiny
                                ed.ui.registry.addIcon('table', `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-7944 -10400 32 32' width='32' height='32'><g id='FB:_Table' data-name='FB: Table' transform='translate(-8996 -10799.999)'><rect id='Rectangle_2295' data-name='Rectangle 2295' class='cls-1' width='32' height='32' rx='2' transform='translate(1052 399.999)'/><path id='Subtraction_1' data-name='Subtraction 1' class='cls-2' d='M9009,10812h-13v-12h13v12Zm-4-3v2h3v-2Zm-4,0v2h3v-2Zm-4,0v2h3v-2Zm8-3v2h3v-2Zm-4,0v2h3v-2Zm-4,0v2h3v-2Zm8-3v2h3v-2Zm-4,0v2h3v-2Zm-4,0v2h3v-2Zm0-2v1h11v-1Z' transform='translate(-7934 -10390)'/></g></svg>`);
                                // Custom icon undo for Tiny
                                ed.ui.registry.addIcon('undo', `<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-8 -8 32 32' version='1.1' width='32' height='32'><defs><path d='M8.5.031a5.32 5.32 0 0 1 1.445.195c.464.13.898.315 1.305.555a5.55 5.55 0 0 1 1.969 1.969c.24.406.424.841.555 1.305a5.32 5.32 0 0 1 .195 1.445c0 .714-.137 1.402-.41 2.066a5.32 5.32 0 0 1-1.168 1.754l-6.539 6.531-.703-.703 6.531-6.539c.411-.411.729-.887.953-1.426s.336-1.1.336-1.684a4.26 4.26 0 0 0-.355-1.727c-.237-.542-.559-1.016-.965-1.422s-.88-.728-1.422-.965A4.26 4.26 0 0 0 8.5 1.031c-.563 0-1.059.085-1.488.254s-.827.393-1.191.672-.715.595-1.051.949L3.711 4H7v1H2V0h1v3.289l.824-.848.789-.773c.263-.242.531-.464.805-.664a5.08 5.08 0 0 1 .875-.516c.31-.143.646-.255 1.008-.336S8.062.031 8.5.031z' id='A'/></defs><use fill='#666' fill-rule='evenodd' xlink:href='#A'/></svg>`);
                                // Custom icon redo for Tiny
                                ed.ui.registry.addIcon('redo', `<svg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='-8 -8 32 32' version='1.1' width='32' height='32'><defs><path d='M8.5.031a5.32 5.32 0 0 1 1.445.195c.464.13.898.315 1.305.555a5.55 5.55 0 0 1 1.969 1.969c.24.406.424.841.555 1.305a5.32 5.32 0 0 1 .195 1.445c0 .714-.137 1.402-.41 2.066a5.32 5.32 0 0 1-1.168 1.754l-6.539 6.531-.703-.703 6.531-6.539c.411-.411.729-.887.953-1.426s.336-1.1.336-1.684a4.26 4.26 0 0 0-.355-1.727c-.237-.542-.559-1.016-.965-1.422s-.88-.728-1.422-.965A4.26 4.26 0 0 0 8.5 1.031c-.563 0-1.059.085-1.488.254s-.827.393-1.191.672-.715.595-1.051.949L3.711 4H7v1H2V0h1v3.289l.824-.848.789-.773c.263-.242.531-.464.805-.664a5.08 5.08 0 0 1 .875-.516c.31-.143.646-.255 1.008-.336S8.062.031 8.5.031z' id='A'/></defs><use fill='#666' fill-rule='evenodd' xlink:href='#A' transform='matrix(-1 0 0 1 16 0)'/></svg>`);
                            },
                            paste_enable_default_filters: false,
                            plugins: [
                                'advlist mention paste_from_word excelborder autolink lists textcolor link image charmap print preview anchor',
                                'searchreplace visualblocks',
                                'insertdatetime media emoticons table paste help wordcount code tabfocus hr',
                                'directionality',
                            ],
                            mentions: {
                                source: (query, process) => {
                                    const filtered = this.listSuggestionEmail.filter((item) =>
                                        item.email.toLowerCase().includes(query.toLowerCase())
                                    );
                                    const result = filtered.filter(i => !modelData?.to.some(i2 => i.id === i2?.id));
                                    process(result);
                                },
                                queryBy: 'email',
                                insert: function (item) {
                                    handlePushReceiver(item)
                                    return `&nbsp;<span data-type='email-source' data-item='${item.email}' style='font-weight: bold;'>@${item.fullname || item.firstname}</span>&nbsp;`;
                                },

                            },
                            directionality: `${this.composeDirectionCurrent.content}`,
                            // toolbar: `undo redo| fontselect | fontsizeselect | formatselect | bold italic underline strikethrough removeformat | \
                            //         forecolor backcolor | outdent indent bullist numlist blockquote | alignleft aligncenter alignright alignjustify | \
                            //         | ${this.choiceFile} link emoticons charmap hr table | ${this.ltr_rtl} | undo redo | code | fullscreen`,
                            // cấu hình lại theo thiết kế
                            toolbar: `undo redo | fontselect fontsizeselect ${this.choiceFile} link| bold italic underline forecolor backcolor emoticons | align numlist bullist | outdent indent  blockquote | strikethrough removeformat| \
                            |  charmap hr table | ${this.ltr_rtl} |code | fullscreen`,
                            // toolbar_location: 'bottom',
                            font_formats:
                                'Sans Serif=arial, helvetica, sans-serif; Sarif=times new roman, new york,times, serif; Wide Block=arial black, avant garde; Monospaced=courier new, courier, monaco, monospace, sans-serif;Comic=comic sans ms, comic sans, sans-serif; Console=lucida console, sans-serif; Garamond=garamond, new york, times, serif; Elegant=georgia, serif; Professional=tahoma, new york, times, serif; Terminal=terminal, monaco; Modern=trebuchet ms, sans-serif; Wide=verdana, helvetica, sans-serif;',
                            block_formats: 'Paragraph=p;Header 1=h1;Header 2=h2;Header 3=h3;Header 4=h4;Header 5=h5;Header 6=h6;Preformatted=pre',
                            fontsize_formats:
                                '8pt 10pt 11pt 12pt 13pt 14pt 16pt 18pt 24pt 36pt 48pt',
                            content_style:
                                `
                        .light-content body {
                                font-size: ${this.htmlEditorDefaultFontSize.content};
                                font-family: ${this.htmlEditorDefaultFontFamily.content};
                                color: ${this.htmlEditorDefaultFontColor.content}
                            }
                            body {
                                font-size: ${this.htmlEditorDefaultFontSize.content};
                                font-family: ${this.htmlEditorDefaultFontFamily.content};
                                color: ${this.htmlEditorDefaultFontColor.content}
                            }
                            img{max-width: 100%; height: auto} .signature_change { p {margin: 0!important} }
                            .mce-content-body div.mce-resizehandle { background-color: #4099ff; border-color: #4099ff; border-style: solid; border-width: 1px; box-sizing: border-box; height: 10px; position: absolute; width: 10px; z-index: 1298 } .mce-content-body .mce-clonedresizable { cursor: default; opacity: .5; outline: 1px dashed #000; position: absolute; z-index: 10001
                            `,
                            tabfocus_elements: ':prev,:next',
                            style_formats_merge: true,
                            language: languages,

                        }" />
                </div>
                <el-input v-if="contentType == EMAIL_CONTENT_TYPE.PLAIN" type="textarea" :rows="25" v-model="plainText"
                    @change="handleSaveDraft" @keydown.native.ctrl.13="handleSendMsgShortcut"
                    @keydown.native.ctrl.71="handleOpenDialogFormVisible"
                    @keydown.native.ctrl.77="openDialogFileChooser" @keydown.native.ctrl.72="handleChangFormat"
                    @keydown.native.ctrl.83="handleKeySaveDraft">
                    { plainText}
                </el-input>
            </div>
            <div v-if="!modalSecure.isSecureMail" class="top-compose tool-bar-compose" style="padding-right:0px;display: flex;align-items: center;gap: 10px;">

<!--                <el-tooltip class="item" effect="dark" :content="$t('zimbra.zmMsg.slides_deleteTextBox')"-->
<!--                    placement="top-start" :open-delay="1000">-->
<!--                    <span style="margin-right: 10px">-->
<!--                        <img width="20px" style="cursor: pointer;" class="ic-light-dark"-->
<!--                            :src="require('@/assets/images/trash.svg')" @click="DeleteAction()" />-->

<!--                    </span>-->
<!--                </el-tooltip>-->
<!--                <el-tooltip class="item" effect="dark" :content="$t('zimbra.zhMsg.ZM_savedraf')" style=" "-->
<!--                            placement="top-start" :open-delay="1000">-->
<!--                    <a class="btn-send-mail item button-hover mr-12"-->
<!--                       style="color: black;background-color: white;border:1px solid #f3f4f6"-->
<!--                       @click="handleSaveBtnDraft">-->
<!--                        {{ $t("zimbra.zhMsg.ZM_savedraf") }}-->
<!--                    </a>-->
<!--                    &lt;!&ndash;                    <button class="btn-send-mail button-hover float-right" @click="handleSendMsg">&ndash;&gt;-->
<!--                    &lt;!&ndash;                        {{ $t("zimbra.zhMsg.send") }}&ndash;&gt;-->
<!--                    &lt;!&ndash;                    </button>&ndash;&gt;-->
<!--                </el-tooltip>-->
                <div class="flex-item-right">
                    <el-tooltip v-show="showSendAndArchive" :open-delay="1000" class="item" effect="dark"
                                style="margin-right:0.8rem" :content="$t('zimbraNokey.zimbra_setting_zimlet_sendAndArchive')"
                                placement="top-start">
                        <a class="btn-send-mail item button-hover float-right" @click="handleSendAndArchiveMsg">
                            <i class="ic ic-send-mail"></i>
                            {{ $t("zimbraNokey.zimbra_setting_zimlet_sendAndArchive") }}
                        </a>
                        <!--                    <button class="btn-send-mail " @click="handleSendAndArchiveMsg">-->
                        <!--                        {{ $t("zimbraNokey.zimbra_setting_zimlet_sendAndArchive") }}-->
                        <!--                    </button>-->
                    </el-tooltip>

                    <el-tooltip class="item" effect="dark" :content="$t('zimbra.zhMsg.send')" style=" "
                        placement="top-start" :open-delay="1000">
                        <a class="btn-send-mail item button-hover float-right" @click="handleSendMsg">
                            <i class="ic ic-send-mail"></i>
                            {{ $t("zimbra.zhMsg.send") }}
                        </a>
                    </el-tooltip>
                </div>
                <ai-feature ref="aiStream" visible="true" @insert-tiny="onInsertAI" @ai-stream="handleAIStreamNew"/>
                <div class="zm-calendar" style="outline: none">
                    <el-popover placement="top-start" popper-class="popover-secure"
                                :width="400" trigger="click"
                                ref="securePopover"
                                @show="onOpenSecurePopover"
                    >

                        <div  class="secure-form">
                            <div class="d-flex flex-column" style="gap: 16px">
                                <div class="item-group">
                                    <div class="title">{{$t('zimbraNokey.titleSecureForm')}}</div>
                                    <div class="sub-label">{{$t('zimbraNokey.subTitleSecureMail')}}</div>
                                </div>
                                <div class="item-group">
                                    <div class="label">{{$t('zimbraNokey.expireTimeSecureForm')}}</div>
                                    <div class="zm-calendar">
                                        <el-date-picker
                                            v-model="modalSecure.dateExpirePopover"
                                            type="datetime"
                                            format="dd/MM/yyyy HH:mm"
                                            :clearable="false"
                                            @change="onDateExpirePopoverChange"
                                            popper-class="zm-calendar"
                                            :picker-options="pickerOpts"
                                            @focusout.native="onDateExpirePopoverChangeFocusOut"
                                        />
                                    </div>
                                    <div class="sub-label">{{$t('zimbraNokey.subTimeSecureMail')}}</div>
                                </div>
                                <div class="sub-label">{{$t('zimbraNokey.subFormSecureMail')}}</div>
                                <div class="w-100 d-flex justify-content-end button-calendar-grct">
                                    <el-button class="btn-cancel" @click="onCancelSecure">{{ $t("zimbraNokey.secureFormBtnCancel") }}</el-button>
                                    <el-button class="btn-calendar" type="primary" @click="onSubmitPopoverSecure">{{ $t("zimbraNokey.secureFormBtnSubmit") }}</el-button>
                                </div>
                            </div>

                        </div>
                        <span slot="reference">
                            <el-tooltip class="item" effect="dark"
                                        :content="$t('zimbra.zhMsg.emailSecure')"
                                        style=" "
                                        placement="top-start"
                                        :open-delay="0">
                                <a class="btn-send-mail item button-hover d-flex justify-content-end align-items-center"
                                   style="color: black;background-color: white;border:none">
                                    <EmailSecureIcon />
                                </a>
                            </el-tooltip>
                        </span>
                    </el-popover>
                </div>
                <template v-if="signatures && signatures.length >= 0">
                    <el-popover
                        placement="top-start"
                        trigger="click"
                        :width="250"
                        popper-class="popover-signature"
                    >
                        <div class="signature-out">
                            <ul class="zm-signatures">
                                <li v-for="item in signatures"
                                    :key="item.id"
                                    :class="['text', signatureActive === item ? 'active' : '']"
                                    @click="handleSelectSignature(item)"
                                >
                                    <span>{{ item.name }}</span>
                                </li>
                                <li :class="['text']"
                                    @click="handleRedirectSignature"
                                >
                                    <span><el-icon class="el-icon-circle-plus-outline"/> {{ $t('zimbra.zmMsg.createSignature') }}</span>
                                </li>
                            </ul>
                        </div>
                        <span slot="reference">
                            <el-tooltip class="item" effect="dark"
                                        :content="$t('zimbra.zhMsg.optionsAccountSignature')"
                                        style=" "
                                        placement="top-start"
                                        :open-delay="0">
                                <a class="btn-send-mail item button-hover d-flex justify-content-end align-items-center"
                                   style="color: black;background-color: white;border:none">
                                    <Signature />
                                </a>
                            </el-tooltip>
                        </span>
                    </el-popover>
                </template>
                <el-tooltip  effect="dark" :content="$t('zimbra.zhMsg.ZM_savedraf')" style=" "
                             placement="top-start" :open-delay="0">
                    <img class="btn-mail-tool button-hover d-flex justify-content-end align-items-center" src="@/assets/zimbra/images/ic-draft-update1.svg" alt="draft" @click="handleSaveBtnDraft">
                </el-tooltip>
                <div class="control-compose">
                    <!-- Tùy chọn -->
                    <el-popover v-model="visible" placement="right"
                                :width="actionType === EMAIL_ACTION.COMPOSE ? 300 : 340" trigger="click">
                        <ul class="box-control-compose">
                            <!-- Trả lời người gửi/Trả lời tất cả -->
                            <template v-if="
                                [
                                    EMAIL_ACTION.REPLY,
                                    EMAIL_ACTION.REPLY_ALL,
                                ].includes(actionType)
                            ">
                                <li :class="`${actionType === EMAIL_ACTION.REPLY
                                    ? 'text active'
                                    : 'text'
                                    }`" @click="changeTypeReply(EMAIL_ACTION.REPLY)">
                                    <a href="javascript:;">
                                        <i class="ic ic-reply ic-light-dark"></i>
                                        <span>{{
                                            $t("zimbra.zmMsg.replySender")
                                        }}</span>
                                    </a>
                                </li>
                                <li :class="`${actionType === EMAIL_ACTION.REPLY_ALL
                                    ? 'text active'
                                    : 'text'
                                    }`" @click="
                                        changeTypeReply(EMAIL_ACTION.REPLY_ALL)
                                        ">
                                    <a href="javascript:;">
                                        <i class="ic ic-replyall ic-light-dark"></i>
                                        <span>{{
                                            $t("zimbra.zhMsg.replyAll")
                                        }}</span>
                                    </a>
                                </li>
                                <li class="dc-line"></li>
                            </template>
                            <!-- Định dạng theo HTML -->
                            <li :class="`text ${contentType == EMAIL_CONTENT_TYPE.HTML
                                ? 'active'
                                : ''
                                }`" @click="
                                    changeContentType(EMAIL_CONTENT_TYPE.HTML)
                                    ">
                                <a href="javascript:;">
                                    <span>{{
                                        $t("zimbra.zmMsg.formatAsHtml")
                                    }}</span>
                                </a>
                            </li>
                            <!-- Định dạng theo văn bản thuần túy -->
                            <li :class="`text ${contentType == EMAIL_CONTENT_TYPE.PLAIN
                                ? 'active'
                                : ''
                                }`" @click="
                                    changeContentType(EMAIL_CONTENT_TYPE.PLAIN)
                                    ">
                                <a href="javascript:;">
                                    <span>{{
                                        $t("zimbraNokey.zimbra_compose_formatPlainText")
                                    }}</span>
                                </a>
                            </li>
                            <li class="dc-line"></li>
                            <!-- Bao gồm -->
                            <template v-if="
                                [
                                    EMAIL_ACTION.REPLY,
                                    EMAIL_ACTION.REPLY_ALL,
                                    EMAIL_ACTION.FORWARD,
                                ].includes(actionType)
                            ">
                                <li v-if="
                                    [
                                        EMAIL_ACTION.REPLY,
                                        EMAIL_ACTION.REPLY_ALL,
                                    ].includes(actionType)
                                " :class="`${isActive(OPTITON_COMPOSE.INCLUDE_MENU_NONE)
                                    ? 'text active'
                                    : 'text'
                                    }`" @click="changeInclude(INCLUDE_ORIGIN_TYPE.INCLUDE_NONE)">
                                    <a href="javascript:;">
                                        <span>{{
                                            $t("zimbra.zmMsg.dontInclude")
                                        }}</span>
                                    </a>
                                </li>
                                <li :class="`${isActive(OPTITON_COMPOSE.INCLUDE_MENU_BODY)
                                    ? 'text active'
                                    : 'text'
                                    }`" @click="changeInclude(INCLUDE_ORIGIN_TYPE.INCLUDE_BODY_ONLY)">
                                    <a href="javascript:;">
                                        <span>{{
                                            $t("zimbra.zmMsg.includeInBody")
                                        }}</span>
                                    </a>
                                </li>
                                <li v-if="
                                    [
                                        EMAIL_ACTION.REPLY,
                                        EMAIL_ACTION.REPLY_ALL,
                                    ].includes(actionType)
                                " :class="`${isActive(OPTITON_COMPOSE.INCLUDE_MENU_SMART)
                                    ? 'text active'
                                    : 'text'
                                    }`" @click="
                                        changeInclude(INCLUDE_ORIGIN_TYPE.INCLUDE_SMART)
                                        ">
                                    <a href="javascript:;">
                                        <span>{{
                                            $t("zimbra.zmMsg.includeMenuSmart")
                                        }}</span>
                                    </a>
                                </li>
                                <!--  Nếu trả lời từ cuộc hẹn ==> không có bao gồm thư dưới dạng tập đính kèm -->
                                <li v-if="!data.isFromCalendar" :class="`${isActive(OPTITON_COMPOSE.INCLUDE_ORIGINAL_AS_ATTACH)
                                    ? 'text active'
                                    : 'text'
                                    }`" @click="
                                        changeInclude(INCLUDE_ORIGIN_TYPE.INCLUDE_AS_ATTACHMENT)
                                        ">
                                    <a href="javascript:;">
                                        <span>{{
                                            $t(
                                                "zimbra.zmMsg.includeMenuAttachment"
                                            )
                                        }}</span>
                                    </a>
                                </li>
                                <li class="dc-line"></li>
                            </template>
                            <!-- Sử dụng tiền tố/Bao gồm đề mục -->
                            <template v-if="
                                actionType === EMAIL_ACTION.FORWARD ||
                                actionType === EMAIL_ACTION.REPLY ||
                                actionType === EMAIL_ACTION.REPLY_ALL
                            ">
                                <li :class="`${usePrefix ? 'text active' : 'text'
                                    }`" @click="toggleUsePrefix">
                                    <a href="javascript:;">
                                        <span>{{
                                            $t("zimbra.zmMsg.usePrefix")
                                        }}</span>
                                    </a>
                                </li>
                                <li :class="`${includeHeaders ? 'text active' : 'text'
                                    }`" @click="toggleIncludeHeaders">
                                    <a href="javascript:;">
                                        <span>{{
                                            $t("zimbra.zmMsg.includeHeaders")
                                        }}</span>
                                    </a>
                                </li>
                                <li class="dc-line"></li>
                            </template>
                            <!-- Chữ ký -->
                            <template v-if="signatures && signatures.length > 0">
                                <li class="signature-out">
                                    <a href="javascript:;">
                                        <i class="ic ic-signature ic-light-dark"></i>
                                        <span>{{
                                            $t("zimbra.zhMsg.optionsAccountSignature")
                                        }}</span>
                                    </a>
                                    <ul class="sub">
                                        <li v-for="item in signatures" :key="item.id" :class="`text ${signatureActive == item
                                            ? 'active'
                                            : ''
                                            }`" @click="
                                                handleSelectSignature(item);
                                            visible = false;
                                            ">
                                            <a href="javascript:;">
                                                <span>{{ item.name }}</span>
                                            </a>
                                        </li>
                                        <li :class="`text ${signatureActive == null
                                            ? 'active'
                                            : ''
                                            }`" @click="
                                                handleSelectSignature(null);
                                            visible = false;
                                            ">
                                            <a href="javascript:;">
                                                <span>{{
                                                    $t(
                                                        "zimbra.zmMsg.signatureDoNotAttach"
                                                    )
                                                }}</span>
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                                <li class="dc-line"></li>
                            </template>
                            <!-- Độ ưu tiên -->
                            <li :class="`${priority == EMAIL_FLAG.URGENT
                                ? 'text active'
                                : 'text'
                                }`" @click="
                                    priority = EMAIL_FLAG.URGENT;
                                visible = false;
                                ">
                                <a href="javascript:;">
                                    <i class="ic ic-priority-high"></i>
                                    <span>{{
                                        $t("zimbra.zhMsg.ALT_HIGH_PRIORITY")
                                    }}</span>
                                </a>
                            </li>
                            <li :class="`${priority == EMAIL_FLAG.PRIORITY
                                ? 'text active'
                                : 'text'
                                }`" @click="
                                    priority = EMAIL_FLAG.PRIORITY;
                                visible = false;
                                ">
                                <a href="javascript:;">
                                    <i class="ic ic-arrow-right"></i>
                                    <span>{{
                                        $t("zimbra.zhMsg.ALT_NORMAL_PRIORITY")
                                    }}</span>
                                </a>
                            </li>
                            <li :class="`${priority == EMAIL_FLAG.LOW_PRIORITY
                                ? 'text active'
                                : 'text'
                                }`" @click="
                                    priority = EMAIL_FLAG.LOW_PRIORITY;
                                visible = false;
                                ">
                                <a href="javascript:;">
                                    <i class="ic ic-priority-low"></i>
                                    <span>{{
                                        $t("zimbra.zhMsg.ALT_LOW_PRIORITY")
                                    }}</span>
                                </a>
                            </li>
                            <li class="dc-line"></li>
                            <!-- Yêu cầu xác nhận đọc -->
                            <li :class="`${requestReadReceipt ? 'text active' : 'text'
                                }`" @click="
                                    requestReadReceipt = !requestReadReceipt;
                                visible = false;
                                ">
                                <a href="javascript:;">
                                    <i class="ic ic-email-active ic-light-dark"></i>
                                    <span>{{
                                        $t("zimbra.zmMsg.requestReadReceipt")
                                    }}</span>
                                </a>
                            </li>
                            <li class="dc-line"></li>
                            <li class="text" v-if="!isNewWindow">
                                <a href="javascript:" @click="detachComposeTooltip">
                                    <i class="fa fa-window-restore mr-2"></i>
                                    <span>{{
                                            $t("zimbra.zmMsg.detachComposeTooltip")
                                        }}</span>
                                </a>
                            </li>
                        </ul>
                        <span slot="reference">
                            <el-tooltip :open-delay="200" :content="`${this.$t('zimbra.zhMsg.ALT_APP_OPTIONS')}`"
                                placement="bottom" effect="dark">
                                <img width="20px" style="cursor: pointer;"
                                    :src="require('@/assets/images/filled.svg')" />
                            </el-tooltip>
                        </span>
                    </el-popover>
                </div>
<!--                <div v-if="!isNewWindow && mobileAndTabletCheck() != 'mobile'" class="control-compose ml-2">-->
<!--                    <el-tooltip class="item" effect="dark" :content="$t('zimbra.zmMsg.detachComposeTooltip')"-->
<!--                        placement="top-start">-->
<!--                        <span class="ic-control button-hover" @click="detachComposeTooltip">-->
<!--                            <i class="fa fa-window-restore ml-1 mr-1"></i>-->
<!--                        </span>-->
<!--                    </el-tooltip>-->
<!--                </div>-->
                <div class="left flex-item-left" style="justify-content: flex-end;" v-if="mobileAndTabletCheck() !== 'mobile'">
                    <div v-if="[EMAIL_ACTION.REPLY, EMAIL_ACTION.FORWARD, EMAIL_ACTION.REPLY_ALL, EMAIL_ACTION.EDIT_AS_NEW].includes(actionType) && mobileAndTabletCheck() !== 'mobile'" class="d-flex align-items-center">
                        <span @click="handleZoom" class="icon-zoom-dark">
                            <img v-if="isFullScreen" width="20px" style="cursor: pointer;"
                                 src="../../../../assets/images/minimize.svg" />
                            <img class="color_zoom" v-else width="20px" style="cursor: pointer;"
                                 src="../../../../assets/images/zoomout.svg" />
                        </span>
                    </div>

                    <!--                    <div v-if="!isNewWindow && mobileAndTabletCheck() == 'mobile'" class="control-compose ml-2">-->
                    <!--                        <el-tooltip class="item" effect="dark" :content="$t('zimbra.zmMsg.detachComposeTooltip')"-->
                    <!--                                    placement="top-start">-->
                    <!--                            <span class="ic-control button-hover" @click="detachComposeTooltip">-->
                    <!--                                <i class="fa fa-window-restore ml-1 mr-1"></i>-->
                    <!--                            </span>-->
                    <!--                        </el-tooltip>-->
                    <!--                    </div>-->
                </div>
            </div>
            <div v-if="modalSecure.isSecureMail" class="top-compose tool-bar-compose" style="padding-right:0px;display: flex;align-items: center; justify-content: start;gap: 10px;">
                <div class="flex-item-right">
                    <el-tooltip v-show="showSendAndArchive" :open-delay="1000" class="item" effect="dark"
                                style="margin-right:0.8rem" :content="$t('zimbraNokey.zimbra_setting_zimlet_sendAndArchive')"
                                placement="top-start">
                        <a class="btn-send-mail item button-hover float-right" @click="handleSendAndArchiveMsg">
                            <i class="ic ic-send-mail"></i>
                            {{ $t("zimbraNokey.zimbra_setting_zimlet_sendAndArchive") }}
                        </a>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" :content="$t('zimbra.zhMsg.send')" style=" "
                                placement="top-start" :open-delay="1000">
                        <a class="btn-send-mail item button-hover float-right" @click="handleSendMsg">
                            <i class="ic ic-send-mail"></i>
                            {{ $t("zimbra.zhMsg.send") }}
                        </a>
                    </el-tooltip>
                </div>
                <div class="d-flex align-items-center" style="gap: 16px">
                    <span class="text-df">
                        {{ $t("zimbraNokey.secureFormAlertExpireTime", {time: secureExpireTimeFormat })}}
                    </span>
                    <div>
                        <el-popover placement="left-end" popper-class="popover-secure"
                                    :width="400" trigger="click"
                                    ref="securePopovert"
                                    @show="onOpenSecurePopover"
                        >

                            <div class="secure-form">
                                <div class="d-flex flex-column" style="gap: 16px">
                                    <div class="item-group">
                                        <div class="title">{{ $t("zimbraNokey.titleSecureForm") }}</div>
                                        <div class="sub-label">{{ $t("zimbraNokey.subTitleSecureMail") }}</div>
                                    </div>
                                    <div class="item-group">
                                        <div class="label">{{ $t("zimbraNokey.expireTimeSecureForm") }}</div>
                                        <div>
                                            <el-date-picker
                                                ref="refElDatePickerFn"
                                                v-model="modalSecure.dateExpirePopover"
                                                type="datetime"
                                                format="dd/MM/yyyy HH:mm"
                                                :clearable="false"
                                                @change="onDateExpirePopoverChange"
                                                popper-class="zm-calendar"
                                                :picker-options="pickerOpts"
                                                @focusout.native="onDateExpirePopoverChangeFocusOut"
                                            />
                                        </div>
                                        <div class="sub-label">{{ $t("zimbraNokey.subTimeSecureMail") }}</div>
                                    </div>
                                    <div class="sub-label">{{ $t("zimbraNokey.subFormSecureMail") }}</div>
                                    <div class="w-100 d-flex justify-content-end button-calendar-grct">
                                        <el-button class="btn-cancel" @click="onCancelSecure">
                                            {{ $t("zimbraNokey.secureFormBtnCancel") }}
                                        </el-button>
                                        <el-button class="btn-calendar" type="primary" @click="onSubmitPopoverSecure">
                                            {{ $t("zimbraNokey.secureFormBtnSubmit") }}
                                        </el-button>
                                    </div>
                                </div>

                            </div>
                            <span slot="reference">
                        <a class="a-text-link-ct" href="javascript:;" @click="">
                            {{ $t("zimbraNokey.secureFormBtnEdit") }}
                        </a>
                        </span>
                        </el-popover>

                    </div>
                    <div>
                        <a class="a-text-link-dg-ct" href="javascript:;" @click="handleUnSecureMail">
                            {{ $t("zimbraNokey.secureFormBtnUnSecure") }}
                        </a>
                    </div>
                </div>
            </div>

        </div>
        <!-- </perfect-scrollbar> -->
        <DialogAddressSelector ref="refAdressSelector" @onselected="handleSeletedAddress" />
        <DialogBriefcaseSelector ref="refDialogBriefcaseSelector" @handleAttachBriefcase="handleAttachBriefcase" />
        <DialogEmailSelector :dialog-form-visible-props="visibleDialogEmailSelector"
                             @onclose="visibleDialogEmailSelector = false" @handleAttachEmail="handleAttachEmail" />
            <DialogContactSelector ref="refDialogContactSelector" @handleAttachContact="handleAttachContact" />
    </div>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import imgLoading from "@/assets/images/loading.svg"
import imgAI from "@/assets/images/ai.svg"
import AddressSelector from "./components/AddressSelector";
import DialogAddressSelector from "./components/DialogAddressSelector.vue";
import ZimbraMailService from "@/services/ZimbraMailService.js";
import UploadService from "@/services/UploadService.js";
import SecureMailService from "@/services/SecureMailService.js";
import CommonUtils from "@/utils/common-utils";
import AjxStringUtil from "@/utils/zimbra-lib/AjxStringUtil";
// import AjxCallback from "@/utils/zimbra-lib/AjxCallback";
import ZmComposeView from "@/utils/zimbra-lib/ZmComposeView";
import EmailUtils from "@/utils/email-utils";
import AjxUtil from "@/utils/zimbra-lib/AjxUtil.js";
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import ZmMimeTable from "@/utils/zimbra-lib/ZmMimeTable";
import DialogEmailSelector from "@/components/modules/layouts/components/DialogEmailSelector";
import DialogContactSelector from "@/components/modules/layouts/components/DialogContactSelector";
import DialogBriefcaseSelector from "@/components/modules/layouts/components/DialogBriefcaseSelector";
import CalendarUtils from "@/utils/calendar-utils.js";
import AiComposeDialog from "@/components/modules/user-guide/AIComposeDialog.vue";
import MutationObserver from "mutation-observer"
import logoTemplateEmail from '@/assets/images/login/image_logoVmail_new.jpg';
import iconTemplateEmail from '@/assets/images/login/locked_key_secure_mail.jpg';
global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;

import {
    EMAIL_FLAG,
    EMAIL_ACTION,
    EMAIL_CONTENT_TYPE,
    SIGNATURE_STYLE,
    INCLUDE_ORIGIN_TYPE,
    ADDRESS_TYPE,
    FOLDER_DEFAULT,
    CAL_OPERATOR_REPLY_INV,
    ATTACT_TYPE,
    INCLUDE_BODY,
    OPTITON_COMPOSE,
    CAL_RECURRING_DELETE_SERIES_TYPE,
    FROM_ADDRESS_TYPE, READ_EMAIL_LAYOUT_ROUTER, ACTION_AI_COMPOSE, SCREEN_MODE as ACTIONS, SCREEN_MODE as ACTION
} from "@/utils/constants";
import hotkeys from "hotkeys-js";
import EmailSecureIcon from "../../../../assets/icons/EmailSecureIcon.vue";
import moment from "moment";
import { sendMailServiceWorker } from "../../../../utils/serviceWorker";
import {EventBus} from "../../../../utils/eventBus";
// import secureMailTemplate from './components/SecureMail.html';
import SecureMailUtils from "@/utils/secure-mail-utils";
import Signature from "@/assets/icons/Signature.vue";
import AI from "@/assets/icons/AI.vue";
import AiFeature from "@/components/modules/user-guide/AiFeture.vue";


export default {
    name: "MailComposeForm",
    mixins: [CommonUtils, EmailUtils, CalendarUtils, SecureMailUtils],
    components: {
        AiFeature,
        AI,
        Signature,
        EmailSecureIcon,
        editor: Editor,
        AddressSelector,
        DialogAddressSelector,
        DialogEmailSelector,
        DialogContactSelector,
        DialogBriefcaseSelector,
        AiComposeDialog: AiComposeDialog,
    },
    props: {
        data: {
            type: Object,
            default: () => {
            },
        },
        rawData: {
            type: Object,
            default: () => {
                return {};
            },
        },
        isNewWindow: {
            type: Boolean,
            default: false,
        },
        actionName: {
            type: String,
            default: ''
        }
    },
    computed: {
        defaultFromAddressOption() {
            if (this.actionName == EMAIL_ACTION.NEW_RECORD) return
            const targetEmail = this.modelData?.to?.length > 0 ? this.modelData.to[0]?.a : undefined;
            const matchingAddresses = this.fromAddresses.filter(address => address.identity && address.identity.zimbraPrefWhenSentToEnabled == true && address.identity.zimbraPrefWhenSentToAddresses === targetEmail);

            // const defaultUuid = {
            //     REPLY: matchingAddresses[0].uuid,
            //     FORWARD: matchingAddresses[0].uuid,
            //     REPLY_ALL: matchingAddresses[0].uuid,
            // }[this.actionType];
            if (matchingAddresses.length > 0 && targetEmail) {
                const defaultUuid = {
                    REPLY: matchingAddresses[0].uuid,
                    FORWARD: matchingAddresses[0].uuid,
                    REPLY_ALL: matchingAddresses[0].uuid,
                }[this.actionType];
                this.modelData.from = this.fromAddresses.find(item => item.uuid === defaultUuid);
                //return this.fromAddresses.find(item => item.uuid === defaultUuid);
            }

            const targetFolder = this.activeNodeSidebar?.id ? this.activeNodeSidebar.id : undefined;

            const matchingFolderId = this.fromAddresses.filter(address => address.identity?.zimbraPrefWhenInFoldersEnabled === true && address.identity?.zimbraPrefWhenInFolderIds.some(folderId => folderId === targetFolder));
            if (matchingFolderId.length > 0 && matchingFolderId) {
                const defaultUuid = {
                    COMPOSE: matchingFolderId[0].uuid,
                    REPLY: matchingFolderId[0].uuid,
                    FORWARD: matchingFolderId[0].uuid,
                    REPLY_ALL: matchingFolderId[0].uuid,
                }[this.actionType];
                // const defaultUuid = matchingFolderId[0].uuid;

                this.modelData.from = this.fromAddresses.find(item => item.uuid === defaultUuid);
                return this.fromAddresses.find(item => item.uuid === defaultUuid);
            }

        },
        ...mapGetters([
            "externalAccount",
            "fromAddresses",
            "preference",
            "composeFormat",
            "tabInEditorEnabled",
            "useSendMsgShortcut",
            "autoSaveDraftInterval",
            "mailRequestReadReceipts",
            "htmlEditorDefaultFontFamily",
            "htmlEditorDefaultFontSize",
            "htmlEditorDefaultFontColor",
            "maxSizeAttach",
            "composeDirectionCurrent",
            "showComposeDirectionCurrent",
            "currentActiveEmail",
            "currentExtraActiveEmail",
            "signatures",
            "emailAddress",
            "mandatorySpellCheckEnabled",
            "folderArchive",
            "isTablet",
            "activeNodeSidebar",
            "localeCurrent",
            "listSuggestionEmail",
            "theme"
        ]),
        listFileAttachmentDisplay() {
            if (!this.listFileAttachment) {
                return [];
            }
            return this.listFileAttachment.map(e => {
                if (e.name && e.name.length > 40) {
                    e.nameShort = `${e.name.substring(0, 10)}...${e.name.substring(e.name.length - 20, e.name.length)}`
                } else {
                    e.nameShort = e.name;
                }
                return e;
            });
        },
        languages() {
            let _lang = this.localeCurrent?.content?.toString() || "vi";
            const indexOf = _lang.indexOf(",");
            _lang = _lang.substring(indexOf + 1);
            return _lang;
        },
        /**
         * Get id chữ ký hiện tại
         */
        signatureActiveId() {
            return this.signatureActive ? this.signatureActive.id : null;
        },
        secureExpireTimeFormat() {
            if(this.modalSecure.dateExpired){
                return moment(this.modalSecure.dateExpired).format('DD/MM/YYYY HH:mm');
            }
            return '';
        },
        pickerOpts() {
            // chặn ngày trước hôm nay
            const startOfToday = new Date();
            startOfToday.setHours(0, 0, 0, 0);

            const disabledDate = (time) => time.getTime() < startOfToday.getTime();

            // giới hạn time
            const now = new Date(this.nowTick || Date.now());
            const pad = n => String(n).padStart(2, '0');
            const upToNow = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())} - 23:59:59`;

            const val = this.modalSecure.dateExpirePopover && new Date(this.modalSecure.dateExpirePopover);
            const isToday = val && val.toDateString() === now.toDateString();

            if(moment().isAfter(this.modalSecure.dateExpirePopover, 'minutes')){
                this.modalSecure.dateExpirePopover = moment().add(5, "minutes").toDate();
            }
            if(moment().isBefore(this.modalSecure.dateExpirePopover, 'days')){
                this.modalSecure.dateExpirePopover = moment(this.modalSecure.dateExpirePopover).toDate().setHours(moment().hour(), moment().minute(), moment().second(), 0);
            }
            return {
                disabledDate,
                selectableRange: isToday ? upToNow : '00:00:00 - 23:59:59',
            };
        }
    },
    watch: {
        theme() {
            this.changeThemeBoxContent()
        },
        defaultFromAddressOption(newValue) {
            this.modelData.from = newValue;

        },

        data: function () {
            this.viewLoaded = false;
            this.initialData(this.data);
        },
        modelData() {
            this.viewLoaded &&
                this.autoSaveDraftInterval.content &&
                this.handleSaveDraft();
        },
        editorModel(val) {
            if (this.skipFirstWatch) {
                this.skipFirstWatch = false
                return
            }
            if (this.interval) {
                clearTimeout(this.interval);
            }
            // if (this.autoSaveDraftInterval?.content !== 0) {
            this.interval = setTimeout(async () => {
                (this.viewLoaded || this.actionType === EMAIL_ACTION.NEW_RECORD) &&
                    this.autoSaveDraftInterval.content && this.handleSaveDraft();
            }, 500);

        },
        saveDraftComopseNewMail(val) {
            // setting đính kèm liên hệ như vCard
            if (val) {
                setTimeout(() => {
                    this.executeSaveDraft(true);
                }, 300)
            }
        },
        nowTime(val) {
            if(val && moment(val).isAfter(this.modalSecure.dateExpired, 'minutes')){
                this.modalSecure.dateExpired = moment().add(5, "minutes").toDate();
            }
        }
    },
    data() {
        return {
            editorTiny: null,
            timerNow: null,
            nowTime: moment().utcOffset(7),
            dialogAI: false,
            ACTION_AI_COMPOSE: ACTION_AI_COMPOSE,
            observer: null,
            skipFirstWatch: true,
            showDropZone: false, // Kiểm soát hiển thị Drop Zone
            isDraggingInside: false, // Kiểm tra xem có đang kéo file vào vùng Drop Zone không
            isProcessingCheck: false, // Biến cờ xử lý
            modalVisible: false,
            EMAIL_FLAG: EMAIL_FLAG,
            EMAIL_ACTION: EMAIL_ACTION,
            EMAIL_CONTENT_TYPE: EMAIL_CONTENT_TYPE,
            INCLUDE_ORIGIN_TYPE: INCLUDE_ORIGIN_TYPE,
            ATTACT_TYPE: ATTACT_TYPE,
            modelData: {
                to: [],
                subject: null,
            },
            typeDialogAI: "",
            requireContent: "",
            isStreaming: false,
            finalContent: "",
            isShowP: true,
            // listAttachmentPlain : [],
            hasReloadDraft: false, // cờ check chỉ reload 1 lần folder nháp khi soạn
            dialogFormVisible: false,
            showCc: true,
            showBcc: true,
            priority: EMAIL_FLAG.PRIORITY,
            requestReadReceipt: false,
            contentType: EMAIL_CONTENT_TYPE.HTML,
            signatureActive: null,
            identity: null,
            visible: false,
            plainText: "",
            listFileAttachment: [], // Danh sách file đính kèm
            listFileAttachmentSecure: [], // Danh sách file đính kèm
            listFileAttachmentSend: [],
            editorModel: "",
            viewLoaded: false,
            interval: null,
            draftId: null,
            actionType: null,
            usePrefix: false,
            includeHeaders: false,
            confirmChangeIncludeHeaders: false,
            includes: INCLUDE_ORIGIN_TYPE.INCLUDE_BODY_ONLY,
            listAttachMail: [],
            includeAsAttachIndex: null,
            visibleAttach: false,
            visibleDialogEmailSelector: false,
            saveDraftImmediately: false,
            ltr_rtl: "",
            listFileAttachmentOrigin: [], // list file đính kèm từ thư gốc
            isChanged: false,
            options: {
                language_url: "@/assets/zimbra/",
            },
            isContinueUpload: true,
            showSendAndArchive: false,
            isClickBtnDraft: false,
            listImageAttach: [], // list ảnh đính kèm vào nội dung thư
            listImageAttachSecure: [], // list ảnh đính kèm vào nội dung thư
            attachInline: [], // ảnh
            rtf: false,
            firstInitImage: true,
            popoverAttach: false, // hiển thị button chọn loại đính kèm
            listAttachContact: [], // Đính kèm số liên hệ,
            listAttachBriefcase: [],
            listAddressInvalid: ["", "", ""],
            choiceFile: "choiceFile",
            originCid: "",
            allPart: "", // all mine part
            OPTITON_COMPOSE: OPTITON_COMPOSE,
            mapIncludeOption: new Map([
                [INCLUDE_BODY.INCLUDE_NONE, [OPTITON_COMPOSE.INCLUDE_MENU_NONE]],
                [INCLUDE_BODY.INCLUDE_BODY_ONLY, [OPTITON_COMPOSE.INCLUDE_MENU_BODY]],
                [INCLUDE_BODY.INCLUDE_BODY_WITH_PREFIX, [OPTITON_COMPOSE.INCLUDE_MENU_BODY, OPTITON_COMPOSE.USER_PREFIX]],
                [INCLUDE_BODY.INCLUDE_BODY_AND_HEADERS, [OPTITON_COMPOSE.INCLUDE_MENU_BODY, OPTITON_COMPOSE.INCLUDE_HEADERS]],
                [INCLUDE_BODY.INCLUDE_BODY_AND_HEADERS_WITH_PREFIX, [OPTITON_COMPOSE.INCLUDE_MENU_BODY, OPTITON_COMPOSE.USER_PREFIX, OPTITON_COMPOSE.INCLUDE_HEADERS]],
                [INCLUDE_BODY.INCLUDE_SMART, [OPTITON_COMPOSE.INCLUDE_MENU_SMART]],
                [INCLUDE_BODY.INCLUDE_SMART_WITH_PREFIX, [OPTITON_COMPOSE.INCLUDE_MENU_SMART, OPTITON_COMPOSE.USER_PREFIX]],
                [INCLUDE_BODY.INCLUDE_SMART_AND_HEADERS, [OPTITON_COMPOSE.INCLUDE_MENU_SMART, OPTITON_COMPOSE.INCLUDE_HEADERS]],
                [INCLUDE_BODY.INCLUDE_SMART_AND_HEADERS_WITH_PREFIX, [OPTITON_COMPOSE.INCLUDE_MENU_SMART, OPTITON_COMPOSE.USER_PREFIX, OPTITON_COMPOSE.INCLUDE_HEADERS]],
                [INCLUDE_BODY.INCLUDE_AS_ATTACHMENT, [OPTITON_COMPOSE.INCLUDE_ORIGINAL_AS_ATTACH]],
            ]),
            isSaveAuto: true,
            headerAccount: null,
            intervalUploadFile: null,
            fileUploading: null,
            percentUploading: null,
            isAddNew: false,
            isProcessing: true,
            isSendingMail: false,
            isMailBasic: window.location.pathname.includes('v-email'),
            modalSecure: {
                isSecureMail: false,
                dateExpired: null,
                dateExpirePopover: new Date()
            },
            nowTick: 0,
            isFullScreen: false,
            READ_EMAIL_LAYOUT_ROUTER,
            secureMailHtml: '',
            contentTempMail: {
                bg: '',
                icon: '',
                logo: '',
            },
            secureMailCode: null,
            contentHtmlEditor: null

        };
    },
    async created() {
        this.contentType = this.composeFormat.content;
        this.ltr_rtl =
            this.showComposeDirectionCurrent.content === true ? "ltr rtl" : "";
        if (this.isTablet === true) {
            this.choiceFile = "";
        }
        this.changeThemeBoxContent();
    },
    mounted() {
        // document.addEventListener('dragenter', this.onGlobalDragEnter);
        document.addEventListener('dragleave', this.onGlobalDragLeave);
        document.addEventListener('drop', this.handleGlobalDrop);
        hotkeys(
            "e",
            () => {

            }
        );
        this.viewLoaded = false;
        this.$nextTick(() => {
            const isActionValid = [EMAIL_ACTION.NEW_RECORD, EMAIL_ACTION.FEED_BACK, EMAIL_ACTION.COMPOSE_TO_SENDER].includes(this.actionName);
            if (this.fromAddresses?.length > 0 && isActionValid) {
                this.$set(this.modelData, 'from', this.fromAddresses[0]);
                this.getInfo();
                this.$refs.toAddressSelector?.$refs?.inputTag?.$refs?.newTagInput.focus();
            }
        })
        this.initialData(this.data);
        hotkeys(
            "ctrl+enter, command+enter",
            "compose",
            this.handleSendMsgShortcut
        );
        hotkeys("ctrl+s, command+s", "compose", this.handleKeySaveDraft);
        hotkeys("ctrl+m, command+m", "compose", this.openDialogFileChooser);
        hotkeys(
            "ctrl+g, command+g",
            "compose",
            this.handleOpenDialogFormVisible
        );
        hotkeys("ctrl+h, command+h", "compose", this.handleChangFormat);
        // hotkeys.stopCallback = function () {
        //     return false;
        // };
        hotkeys.setScope("compose");


        this.$nextTick(() => {
            const editor = this.$refs.refEditor?.editor;
            editor && editor.on('click', () => {
                this.visible = false
                if (this.$refs.toAddressSelector) this.$refs.toAddressSelector.inputFocused = false;
                if (this.$refs.ccAddressSelector) this.$refs.ccAddressSelector.inputFocused = false;
                if (this.$refs.bccAddressSelector) this.$refs.bccAddressSelector.inputFocused = false;
            });
        });
        if (this.fromAddresses?.length == 1) {
            this.modelData.from = this.fromAddresses[0];
        }
        this.initDataSuggestionEmail()
        this.timerNow = setInterval(() => {
            // Gán lại giá trị mới để Vue detect thay đổi
            this.nowTime = moment().utcOffset(7);
        }, 1000)
    },
    beforeDestroy() {
        if (this.interval) {
            clearTimeout(this.interval);
            this.interval = null;
        }
        if (this.timerNow) {
            clearInterval(this.timerNow);
        }
        document.removeEventListener('dragleave', this.onGlobalDragLeave);
        document.removeEventListener('drop', this.handleGlobalDrop);
        hotkeys.deleteScope("compose");
        this.observer = null;
    },
    methods: {
        ...mapActions([
            "initDataSuggestionEmail"
        ]),
        refreshNow() {
            this.nowTick = Date.now();
        },
        closeAnddraft() {
            this.$confirm(
                this.$t("zimbra.zmMsg.askSaveDraft"),
                this.$t("zimbra.ztMsg.alertFeedReplyTitle"),
                {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("zimbra.zhMsg.yes"),
                    cancelButtonText: this.$t("zimbra.zhMsg.no"),
                    type: "warning"
                }
            )
                .then(async () => {
                    await this.executeSaveDraft(false, true, true);
                    this.$notify({
                        title: this.$t("zimbra.zmMsg.dataSourceTestSuccess"),
                        message: this.$t("zimbra.zmMsg.draftSaved"),
                        type: "success",
                    });
                })
                .catch((action) => {
                    if (action == 'cancel') {
                        this.isFullScreen = false;
                        this.$root.$emit('handleChangeMode')
                    }
                });
        },
        openComposePopup(valDialog) {
            const ed = this.$refs.refEditor.editor;
            this.handleAIStream(ed, valDialog.content, valDialog.type);
        },
        DeleteAction() {
            this.$confirm(
                this.$t("zimbra.zmMsg.confirmDeleteItem"),
                this.$t("zimbra.ztMsg.confirmDeleteApptTitle"),
                {
                    distinguishCancelAndClose: true,
                    confirmButtonText: this.$t("zimbra.zhMsg.yes"),
                    cancelButtonText: this.$t("zimbra.zhMsg.no"),
                    type: "warning"
                }
            )
                .then(async () => {
                    this.$root.$emit('handleNavbarAction',EMAIL_ACTION.DELETE)
                })
                .catch((action) => {
                    if (action == 'cancel') {
                        this.isFullScreen = false;
                        this.$root.$emit('handleChangeMode')
                    }
                });
        },
        handleZoom() {
            this.isFullScreen = !this.isFullScreen;
        },
        changeThemeBoxContent() {
            this.$nextTick(() => {
                const editor = this.$refs.refEditor?.editor;
                if (editor) {
                    const doc = editor.getDoc();
                    if (doc && doc.body) {
                        // Xóa class cũ nếu có
                        // Nếu theme dark thì thêm class
                        if (this.theme == 'dark') {
                            doc.documentElement.classList.remove('light-content');
                            doc.documentElement.classList.add('dark-content');
                        } else {
                            doc.documentElement.classList.remove('dark-content');
                            doc.documentElement.classList.add('light-content');
                        }
                    }
                }
            });
        },
        extractImageData(html) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const signatureDivs = doc.querySelectorAll('.signature_change');
            const listImageObject = [];
            const listDataImgInit = [];
            const reg_src = /^cid:(.*)/;
            signatureDivs.forEach((div) => {
                const images = div.querySelectorAll('img');
                images.forEach((img) => {
                    const imgSrc = img.src;
                    const urlParams = new URL(imgSrc).searchParams;
                    const fileName = imgSrc?.split('/').pop().split('?')[0];
                    const part = urlParams.get('part');
                    const id = urlParams.get('id');
                    const dfsrc = img.getAttribute("dfsrc");
                    // Tạo CID cho mỗi ảnh
                    const cid = ZmComposeView.generateCid();
                    // Cập nhật data-mce-src của ảnh với CID
                    const dfsrcSave = this.attachInline.find(it => it?.ci === "<" + imgSrc?.replace(/^cid:/, '') + ">");
                    img.setAttribute('src', `cid:${dfsrcSave ? dfsrcSave?.ci.replace(/[<>]/g, '') : cid}`);
                    img.setAttribute('data-mce-src', `cid:${dfsrcSave ? dfsrcSave?.ci.replace(/[<>]/g, '') : cid}`);
                    const dataImgInit = {
                        ci: dfsrc && reg_src.test(dfsrc) ? dfsrc?.replace(/^cid:/, '') : dfsrcSave?.ci.replace(/[<>]/g, ''),
                        attach: {
                            mp: [
                                {
                                    mid: id ? id?.toString() : this.data?.id.toString(),
                                    part: part ? part?.toString() : dfsrcSave?.part.toString()
                                }
                            ]
                        }
                    }
                    if (dataImgInit.ci) {
                        listDataImgInit.push(dataImgInit);
                    }
                    // lấy thông tin chân ký
                    const imageObject = {
                        ci: cid,
                        attach: {
                            doc: [
                                {
                                    path: `Briefcase/${fileName}`,
                                    optional: 1
                                }
                            ]
                        }
                    };
                    if (imgSrc.includes('/Briefcase/')) {
                        listImageObject.push(imageObject);
                    }
                });
            });
            return {
                data: listImageObject,
                html: doc.documentElement.innerHTML,
                imgPart: listDataImgInit
            }
        },
        focusEditor(actionType) {
            this.$nextTick(() => {
                if (actionType == EMAIL_ACTION.FORWARD) {
                    // this.$refs.toAddressSelector && this.$refs.toAddressSelector.focus();
                    this.$refs.toAddressSelector.inputFocused = true;
                    setTimeout(() => {
                        if(this.$refs.toAddressSelector){
                            this.$refs.toAddressSelector.handleInputFocused();
                        }
                    }, 0);
                    this.$refs.toAddressSelector && this.$refs.toAddressSelector.focus();
                } else {
                    const editorInstance = this.$refs.refEditor && this.$refs.refEditor.editor;
                    setTimeout(() => { editorInstance.focus(); }, 0)
                }
            })
        },
        onGlobalDragLeave(event) {
            this.showDropZone = false;
        },
        // Khi rời chuột khỏi Drop Zone, ẩn đi nếu chưa thả file
        onDragLeave(event) {
            this.showDropZone = false;
        },
        handleGlobalDrop(e) {
            event.preventDefault();
            this.showDropZone = false;
            const items = event.dataTransfer.items;
            for (let i = 0; i < items.length; i++) {
                const entry = items[i].webkitGetAsEntry();
                if (entry && entry.isDirectory) {
                    return;
                }
            }
            // Xử lý upload file tại đây nếu cần
        },

        onDropOver(event) {
            event.preventDefault();
            this.showDropZone = true;
        },

        // Khi thả file vào Drop Zone
        async onDrop(event) {
            event.preventDefault();
            const items = event.dataTransfer.items;
            this.showDropZone = false; // Ẩn Drop Zone sau khi thả file
            for (let i = 0; i < items.length; i++) {
                const entry = items[i].webkitGetAsEntry();
                if (entry && entry.isDirectory) {
                    this.$notify({
                        title: this.$t("zimbra.ztMsg.alertFeedReplyTitle"),
                        message: this.$t("zimbraNokey.zimbra_zimbraNokey_fileExtentionDeny"),
                        type: "warning",
                    });
                    return;
                }
            }
            const listFile = Array.from(event.dataTransfer.files); // Lấy danh sách file đã thả
            await this.uploadFile(event, listFile, true, null);
        },
        openModal() {
            this.modalVisible = true;
        },
        closeModal() {
            this.modalVisible = false;
        },
        moveAddress(type, value) {
            this.handleShowAddressSelector(type);
            type == 'to' && this.modelData.to.push(value);
            type == 'cc' && (this.modelData.cc ? this.modelData.cc.push(value) : this.modelData.cc = [value]);
            type == 'bcc' && (this.modelData.bcc ? this.modelData.bcc.push(value) : this.modelData.bcc = [value]);
        },
        isActive(value) {
            return this.mapIncludeOption.get(this.includes)?.includes(value);
        },
        changeTextTo(valueText) {
            this.listAddressInvalid[0] = valueText;
        },
        changeTextCc(valueText) {
            this.listAddressInvalid[1] = valueText;
        },
        changeTextBcc(valueText) {
            this.listAddressInvalid[2] = valueText;
        },
        handleTab(e, ed) {
            if (this.tabInEditorEnabled.content) {
                e.preventDefault();
                ed.editorCommands.execCommand(
                    "mceInsertContent",
                    false,
                    "&emsp;"
                );
            }
        },
        handleKeySaveDraft(e) {
            this.isSaveAuto = false;
            e.preventDefault();
            clearTimeout(this.interval)
            this.interval = null
            this.executeSaveDraft();
        },
        handleOpenDialogFormVisible(e) {
            e.preventDefault();
            this.$refs.refAdressSelector.show(this.getAllSelectedAdress());
        },
        handleChangFormat(e) {
            e.preventDefault();
            if (this.contentType != EMAIL_CONTENT_TYPE.HTML) {
                this.changeContentType(EMAIL_CONTENT_TYPE.HTML);
            } else {
                this.changeContentType(EMAIL_CONTENT_TYPE.PLAIN);
            }
        },
        handleSeletedAddress(addresses) {
            this.dialogFormVisible = false;
            const newTags = addresses
                ? addresses.map((e) => {
                    return {
                        ...e,
                        text: `"${e.p} <${e.a}>"`,
                    };
                })
                : [];

            this.$nextTick(() => {
                this.$refs.toAddressSelector && this.$refs.toAddressSelector.addTags(newTags.filter((e) => e.type == "to"));
            })

            const cc = newTags.filter((e) => e.type == "cc");
            if (cc && cc.length > 0) {
                setTimeout(() => {
                    this.$refs.ccAddressSelector.addTags(cc);
                }, 200);
                this.showCc = false;
            }
            const bcc = newTags.filter((e) => e.type == "bcc");
            if (bcc && bcc.length > 0) {
                setTimeout(() => {
                    this.$refs.bccAddressSelector.addTags(bcc);
                }, 200);
                this.showBcc = false;
            }
        },
        handleShowAddressSelector(type) {
            if (type == "cc") {
                this.showCc = false;
            }
            if (type == "bcc") {
                this.showBcc = false;
            }
        },
        openDialogAddressSeletor() {
            this.$refs.refAdressSelector.show(this.getAllSelectedAdress());
        },
        // set style font-family cho nội dung email theo setting mặc định
        injectFontStyle(html, fontFamily) {
            const styleTag = `<style>body { font-family: ${fontFamily} !important;}</style> <style> span,div,p,li,ol,p.MsoNormal, li.MsoNormal, ol.MsoNormal{margin: 0!important;};</style>`;
            return html.replace(/<head>/i, `<head>${styleTag}`);
        },
        buildFormData(isSaveDraft, onlySend, checkFileImgInline = true) {
            const dataIMG = this.extractImageData(this.editorModel)
            // call api send
            const mail = {
                su: _.escape(this.modelData.subject),
            };

            // set flag
            if (this.priority != EMAIL_FLAG.PRIORITY) {
                mail["f"] = this.priority;
            }
            const addressDefault = this.fromAddresses.find(
                (e) => e.uuid === this.preference.defaultFromAddress
            );
            this.modelData.from || this.preference.defaultFromAddress;
            const emailUserLogin = this.modelData.from || addressDefault;
            // build danh sach dia chi email
            const e = [
                ...this.buildListEmailAddress(this.modelData.to, "t"),
                ...this.buildListEmailAddress(this.modelData.cc, "c"),
                ...this.buildListEmailAddress(this.modelData.bcc, "b"),
            ];
            e.push({
                t: "f",
                a: _.escape(emailUserLogin.a),
                p: _.escape(emailUserLogin.d),
            });
            if (emailUserLogin.identity?.zimbraPrefReplyToEnabled && emailUserLogin.identity?.zimbraPrefReplyToAddress) {
                e.push({
                    t: "r",
                    a: _.escape(emailUserLogin.identity.zimbraPrefReplyToAddress),
                    p: _.escape(emailUserLogin.identity.zimbraPrefReplyToDisplay),
                });
            } else if (emailUserLogin.replyToAddress && emailUserLogin.replyToDisplay) {
                e.push({
                    t: "r",
                    a: _.escape(emailUserLogin.replyToAddress),
                    p: _.escape(emailUserLogin.replyToDisplay),
                });
            }
            // TH chọn yêu cầu xác nhận đọc -> thêm email của người gửi
            if (this.requestReadReceipt) {
                e.push({
                    t: "n",
                    a: _.escape(emailUserLogin.a || emailUserLogin.emailAddress),
                    p: _.escape(emailUserLogin.d || emailUserLogin.fromDisplay),
                });
            }
            if (emailUserLogin.type == FROM_ADDRESS_TYPE.DISCOVER_RIGHTS) {
                e.push({
                    t: "s",
                    a: _.escape(addressDefault.a),
                });
            }
            this.headerAccount = {
                by: "name",
                content: _.escape(emailUserLogin.a)
            }
            mail["e"] = e;

            // build mp
            const mp = [];
            if (this.contentType == EMAIL_CONTENT_TYPE.PLAIN) {
                mp.push({
                    // ct: "text/plain",
                    ct: "text/html",
                    content: _.escape(this.removeMarkers(this.plainText).replaceAll('\n', '<br />')),
                });

            } else {
                let contentHTML = this.draftId ? `` : `<div style="font-family: ${this.htmlEditorDefaultFontFamily.content}, sans-serif; font-size: 12pt; color: ${this.htmlEditorDefaultFontColor.content}" dir="${this.composeDirectionCurrent.content}">`;
                contentHTML += this.$refs.refEditor?.editor ? this.$refs.refEditor?.editor.getContent({
                    format: "raw",
                }) : contentHTML;
                contentHTML += `</div>`;
                if (onlySend && dataIMG.html) {
                    contentHTML = dataIMG?.html?.replaceAll('signature_change', '')
                }
                contentHTML = this.injectFontStyle(contentHTML, this.htmlEditorDefaultFontFamily.content); // set font-family
                let mpHtml = {};
                if (this.listImageAttach?.length > 0 || this.attachInline?.length > 0 || dataIMG.data.length) {
                    mpHtml = {
                        ct: "multipart/related",
                        mp: [{
                            ct: "text/html",
                            content: _.escape(this.removeMarkers(this.handleFixImageSrcBeforeSend(contentHTML))),
                        }]
                    }
                    this.listImageAttach && this.listImageAttach.forEach(item => {
                        mpHtml.mp.push({
                            ci: item.cid || item.ci.replace("<", "").replace(">", ""),
                            attach: {
                                aid: item.aid || this.modelData.origid,
                            },
                            isSecure: item?.isSecure
                        })
                    })
                    this.attachInline && this.attachInline.forEach(item => {
                        mpHtml.mp.push({
                            ci: item.ci.replace("<", "").replace(">", ""),
                            attach: {
                                mp: [{
                                    mid: `${this.draftId ? this.draftId : this.modelData.origid}`,
                                    part: item.part
                                }]
                            }
                        })
                    })
                } else {
                    mpHtml = {
                        ct: "text/html",
                        content: _.escape(this.removeMarkers(contentHTML)),
                    };
                }
                mp.push({
                    ct: "multipart/alternative",
                    mp: [
                        {
                            ct: "text/plain",
                            content: _.escape(
                                this.removeMarkers(this.$refs.refEditor?.editor.getContent({
                                    format: "text",
                                }))
                            ),
                        },
                        mpHtml
                    ],
                });
            }
            mail["mp"] = mp;
            const sendIds = this.listFileAttachmentSend.map((e) => e.aid) || []; // file đã gửi
            const attachPart = [];
            // file đính kèm
            if (this.listFileAttachment.length > 0) {
                if (this.listFileAttachmentSend?.length > 0 && this.draftId) {
                    for (
                        let index = 0;
                        index < this.listFileAttachmentSend.length;
                        index++
                    ) {
                        attachPart.push({
                            mid: `${this.draftId}`,
                            part:
                                this.listFileAttachmentSend[index].part ||
                                index + 2,
                            type: "part",
                        });
                    }
                }

                // file forward
                const fileForward =
                    this.listFileAttachment.filter(
                        (e) => e.forward && !sendIds.includes(e.aid)
                    ) || [];
                for (let index = 0; index < fileForward.length; index++) {
                    const element = fileForward[index];
                    attachPart.push({
                        mid: `${this.modelData.origid || element.mid || this.data.id}`, // id thư gốc hoặc id từ thư nháp
                        part: element.part || index + 2,
                        type: "part",
                    });
                }
                const aids = this.listFileAttachment
                    .filter((e) => !sendIds.includes(e.aid) && !e.forward)
                    .map((e) => e.aid);
                if (aids.length > 0) {
                    mail["attach"] = aids.join(",");
                }
            }

            // Đính kèm thư gốc
            if (this.listAttachMail.length > 0) {
                this.listAttachMail.forEach((e) => {
                    attachPart.push({
                        id: e?.toString(),
                        type: "mail",
                    });
                });
            }

            // Đính kèm số liên hệ
            if (this.listAttachContact.length > 0) {
                this.listAttachContact.forEach((e) => {
                    attachPart.push({
                        id: e?.toString(),
                        type: "contact",
                    });
                });
            }

            // Đính kèm Cặp tài liệu
            if (this.listAttachBriefcase.length > 0) {
                this.listAttachBriefcase.forEach((e) => {
                    const formData = {}
                    formData.id = e?.id.toString()
                    if (e.isSub) formData.ver = e.ver
                    formData.type = "doc"
                    attachPart.push(formData)
                });
            }

            mail["attachPart"] = attachPart;
            // TH có nháp
            if (this.draftId) {
                mail["id"] = `${this.draftId}`;
                if (!isSaveDraft) {
                    mail["did"] = `${this.draftId}`;
                }
            }

            // forward or reply
            if (this.modelData.origid) {
                mail["origid"] = this.modelData.origid;
            }
            if (this.modelData.rt) {
                mail["rt"] = this.modelData.rt;
            }
            // mail có chân ký thì gửi kèm đường dẫn tới briefcase
            if (onlySend) {
                // console.log(dataIMG);

                mail.mp?.forEach(item => {
                    item.mp?.forEach(subItem => {
                        if (subItem?.ct === 'multipart/related' && subItem.mp) {
                            subItem.mp.forEach(relatedItem => {
                                if (relatedItem?.ct === 'text/html') {
                                    if (dataIMG?.data.length) subItem.mp = [...subItem.mp, ...dataIMG?.data];
                                    //    if(dataIMG?.imgPart.length)  subItem?.mp =([dataIMG?.imgPart]);
                                }
                            });
                            // if (checkFileImgInline) {
                                subItem.mp = this.filterAttachmentsByHtmlContent(subItem.mp);
                            // }
                            // subItem.mp = this.filterAttachmentsByHtmlContent(subItem.mp);
                        }
                    });
                });
            }
            // mail.mp[0].mp[1].mp.push(dataIMG?.data[0]) //
            return mail;
        },
        // hàm lọc các phần đính kèm trong nội dung HTML có cid trùng với các phần đính kèm khác
        filterAttachmentsByHtmlContent(data) {
            if (!Array.isArray(data)) return [];
            const htmlContentObj = data.find(item => item.ct === "text/html");
            const html = htmlContentObj?.content ?? "";
            const cidMatches = html.match(/cid:([a-zA-Z0-9._@-]+)/gi) || [];
            const cidList = cidMatches.map(match => match.replace("cid:", ""));
            return data.filter(item =>
                item.ct === "text/html" || (item.ci && cidList.includes(item.ci)) || (this.modalSecure.isSecureMail && item.isSecure)
            );
        },
        getInfo() {
            this.signatureActive = this.signatures?.find(
                (e) => e.id == this.preference.zimbraPrefDefaultSignatureId
            );
            this.getSignatureCompose(null, null, true);
            if (this.saveDraftImmediately) {
                this.executeSaveDraft();
            }
        },
        handleRedirectSignature() {
            window.open("/mail/setting?tab=navSignature", "_blank");
        },
        handleSelectSignature(item) {
            // if (this.signatureActive === item) {
            //     return;
            // }
            if (this.listFileAttachmentDisplay.findIndex(e => e.ct === "text/x-vcard") >= 0) {
                this.onRemoveAttachment(this.listFileAttachmentDisplay.findIndex(e => e.ct === "text/x-vcard"))
            }
            const signPrevious = _.cloneDeep(this.signatureActive);
            this.signPrevious = signPrevious;
            this.signatureActive = item;
            this.getSignatureCompose(signPrevious, true);
            // tạm bỏ lưu nháp để check ảnh
            // if(this.signatureActive){
            // this.executeSaveDraft(false, false, true);
            // }
        },
        /**
         * Lấy chữ ký với văn bản thuần túy
         */
        getSignatureComposeTextPlain(signPrevious, isSwitch) {
            if (!this.plainText) {
                return;
            }
            const zimbraPrefMailSignatureStyle = this.preference.zimbraPrefMailSignatureStyle;
            const markerSign = zimbraPrefMailSignatureStyle == SIGNATURE_STYLE.INTERNET ? ZmComposeView.BC_SIG_POST : ZmComposeView.BC_SIG_PRE;
            const startSign = this.plainText.indexOf(ZmComposeView.BC_TEXT_MARKER[markerSign]);
            if (this.plainText && startSign > -1 && isSwitch) {
                this.plainText = this.plainText.substring(0, startSign);
                let _sign = "";
                if (this.signatureActive) {
                    _sign = _sign = this.signatureActive?.content ? this.signatureActive.content.content.toString() : "";
                    const div = document.createElement("div");
                    $(div).html(_sign.replace(/<br>/ig, "\n"));
                    _sign = $(div).text();
                    if (zimbraPrefMailSignatureStyle != SIGNATURE_STYLE.OUTLOOK) {
                        _sign = `--\n${_sign}`;
                    }
                }
                this.plainText = `${this.plainText}${ZmComposeView.BC_TEXT_MARKER[markerSign]}${_sign}`
            }
        },
        getSignatureComposeHtml(signPrevious, isSwitch) {
            // debugger
            const textPre = this.getTextPreHtml(signPrevious, isSwitch);
            const signPre = this.signatureActiveId ? this.getSignature(SIGNATURE_STYLE.OUTLOOK, this.signatureActiveId) : "";
            let divider = this.includeHeaders ? this.getDivider() : "";
            let header = this.getContentByMarkerHtml(ZmComposeView.BC_HEADERS);
            let quoted = this.getContentByMarkerHtml(ZmComposeView.BC_QUOTED_TEXT);
            // if (this.usePrefix) {
            //     quoted = `<blockquote style="${ZmComposeView.styleQuote}">${quoted}</blockquote>`;
            // } else {
            //     quoted = $(quoted).first().html();
            // }
            header = header ? `<div data-marker="${this.getDataMarker(ZmComposeView.BC_HEADERS)}">${header}</div>` : "";
            quoted = quoted ? `<div data-marker="${this.getDataMarker(ZmComposeView.BC_QUOTED_TEXT)}">${quoted}</div>` : "";
            const signPost = this.signatureActiveId ? this.getSignature(SIGNATURE_STYLE.INTERNET, this.signatureActiveId) : "";
            this.editorModel = [`<br>`,textPre, signPre, divider, header, quoted, signPost].join("");
            // this.editorModel = this.handleFixImageSrc(this.editorModel, this.allPart, this.modelData.origid);
            this.$nextTick(() => {
                const editModelTemp = this.handleFixImageSrc(this.editorModel, this.allPart, this.modelData.origid)
                this.editorModel = _.cloneDeep(editModelTemp);
                this.$refs.refEditor && this.$refs.refEditor?.editor && this.$refs.refEditor?.editor.setContent(this.editorModel)
            })
        },
        getSignatureCompose(signPrevious, isSwitch, isFirst = false) {
            // đính kèm vcard
            if (this.signatureActive?.cid) {
                this.listAttachContact = [this.signatureActive.cid]
            }
            if (this.contentType === EMAIL_CONTENT_TYPE.PLAIN) {
                // TH văn bản thuần túy
                this.getSignatureComposeTextPlain(signPrevious, isSwitch);
                return;
            }
            this.getSignatureComposeHtml(signPrevious, isSwitch);
            setTimeout(() => {
                !isFirst && this.executeSaveDraft(false, false, true);
            }, 0);
        },
        async validateBeforeSend() {
            let res = true;
            await ['toAddressSelector', 'ccAddressSelector', 'bccAddressSelector'].forEach(ref => {
                this.$refs[ref]?.forceTriggerTag()
            });
            const checkExistAddressInvalid = this.listAddressInvalid.findIndex(x => x != "") > -1;

            if (
                _.isEmpty(this.modelData.to) &&
                _.isEmpty(this.modelData.cc) &&
                _.isEmpty(this.modelData.bcc) &&
                !checkExistAddressInvalid
            ) {
                res = false;
                await this.$confirm(
                    this.$t("zimbra.zhMsg.noAddresses"),
                    this.$t("zimbraNokey.zimbra_compose_criticalMsg"),
                    {
                        showCancelButton: false,
                        confirmButtonText: this.$t("zimbra.zmMsg.mobileStatusNeedProvision"),
                        type: "error",
                    }
                )
                    .then(() => {
                    })
                    .catch(() => {
                        res = false;
                    });
            }
            if (
                res &&
                (!this.modelData.subject || this.modelData.subject.length == 0)
            ) {
                await this.$confirm(
                    this.$t("zimbra.zhMsg.compSubjectMissing"),
                    this.$t("zimbra.ztMsg.alertFeedReplyTitle"),
                    {
                        confirmButtonText: this.$t("zimbra.zmMsg.mobileStatusNeedProvision"),
                        //  showConfirmButton: false,
                        cancelButtonText: this.$t("zimbra.zhMsg.actionTaskCancelTT"),
                        type: "warning",
                    }
                )
                    .then(() => {
                        res = true;
                    })
                    .catch(() => {
                        res = false;
                    });
            } else {

                if (checkExistAddressInvalid) {
                    await this.$confirm(
                        this.$t("zimbra.zmMsg.compBadAddresses", [this.listAddressInvalid.filter(x => x != "").join(';')]),
                        this.$t("zimbraNokey.zimbra_compose_criticalMsg"),
                        {
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: this.$t("zimbra.zmMsg.mobileStatusNeedProvision"),
                            type: "warning",
                        }
                    )
                        .then(() => {
                            res = true;
                        })
                        .catch(() => {
                            res = false;
                        });
                }
            }

            if (this.modalSecure.isSecureMail && this.modalSecure.dateExpired && moment(this.modalSecure.dateExpired).isBefore(moment())) {
                this.$notify({
                    title: this.$t("zimbra.zhMsg.ALT_ERROR"),
                    message: this.$t("zimbra.zmMsg.secureEmailDateExpired"),
                    type: "error"
                });
                res = false;
            }

            return !res;
        },
        async checkSpellingRequest() {
            let content = "";
            if (this.contentType === EMAIL_CONTENT_TYPE.PLAIN) {
                content = _.escape(this.plainText);
            } else {
                content = _.escape(
                    this.$refs.refEditor?.editor.getContent({
                        format: "text",
                    })
                );
            }
            const form = {
                text: content,
            };
            const res = await ZimbraMailService.checkSpellingRequest(form);
            return res.status === 500;
        },
        async handleSendAndArchiveMsg() {
            const isSendSuccess = await this.handleSendMsg();
            isSendSuccess && this.$root.$emit('handleNavbarAction', EMAIL_ACTION.SEND_AND_ARCHIVE);
        },
        async handleSendMsg(event) {

            if (this.isProcessingCheck) return; // Kiểm tra nếu quá trình đang được xử lý, không thực hiện gì cả
            this.isProcessingCheck = true; // Thiết lập biến cờ
            let isSendSuccess = false;
            // validate before senda
            const validate = await this.validateBeforeSend();
            if (validate) {
                event.target.blur();
                this.isProcessingCheck = false;
                return isSendSuccess;
            }
            if (this.interval) {
                clearTimeout(this.interval);
            }

            if (this.actionType === EMAIL_ACTION.EDIT_REPLY_CAL) {
                // sửa câu trả lời cuộc hẹn
                this.sendInviteReply();
                this.isProcessingCheck = false;
                return;
            }

            if (this.actionType === EMAIL_ACTION.DELETE_APPT) {
                // gửi thư hủy và xóa
                isSendSuccess = await this.sendMail();
                if (isSendSuccess) {
                    //activeAppointment Nguyên
                    const apptData = this.$store.getters.activeAppointment;
                    //Xu ly xoa
                    if (apptData.isInstance == undefined) {
                        this.cancelAppointmentSeriesRequest(apptData.invId);
                    } else if (apptData.isInstance) {
                        // Gọi hàm xóa
                        this.cancelAppointmentInstanceReplyRequest(apptData, apptData.apptInstance);
                    } else {
                        if (CAL_RECURRING_DELETE_SERIES_TYPE.ALL_APPT == apptData.deleteType) {
                            this.cancelAppointmentSeriesRequest(apptData.invId)
                        } else {
                            this.deleteAppointmentFuture(apptData)
                        }
                    }
                }
                this.isProcessingCheck = false;
                return isSendSuccess;
            }

            // Kiem tra chinh ta truoc khi gui mail
            // const isCheckSpelling = this.checkSpellingRequest(); // bỏ không cần thiết
            const isCheckSpelling = true;
            const isCheckEnabled = this.mandatorySpellCheckEnabled.content;
            if (isCheckEnabled) {
                if (isCheckSpelling) {
                    await this.$confirm(
                        this.$t("zimbra.zmMsg.spellCheckFailed"),
                        this.$t("zimbra.ztMsg.alertFeedReplyTitle"),
                        {
                            confirmButtonText: this.$t("zimbra.zhMsg.yes"),
                            cancelButtonText: this.$t("zimbra.zhMsg.no"),
                            type: "warning",
                        }
                    )
                        .then(async () => {
                            isSendSuccess = await this.sendMail();
                        })
                        .catch(() => {
                            isSendSuccess = false;
                            this.isProcessingCheck = false;
                        });
                }
            } else {

                isSendSuccess = await this.sendMail();
                this.isProcessingCheck = false;
            }

            this.isProcessingCheck = false;
            return isSendSuccess;
        },

        getFormMailSecure(data) {
            if (Array.isArray(data?.mp) && data?.mp?.length > 0) {
                const arrContent = data.mp.find((i => i?.ct === 'multipart/alternative'));
                if (Array.isArray(arrContent?.mp) && arrContent?.mp.length > 0) {
                    const contentFn = arrContent?.mp?.find((i) => i?.ct === 'text/html');
                    if (!contentFn && Array.isArray(arrContent?.mp?.find((i) => i?.ct === 'multipart/related')?.mp)) {
                        return arrContent?.mp?.find((i) => i?.ct === 'multipart/related')?.mp.find((i) => i?.ct === 'text/html')
                    }
                    return contentFn;
                }
                return {};
            }
        },

        buildHtmlForGateway(fragmentHtml) {
            const id = Date.now().toString(36); // hoặc uuid
            return `
<head>
  <style>body { font-family: arial, helvetica, sans-serif !important; }</style>
  <style>span,div,p,li,ol,p.MsoNormal, li.MsoNormal, ol.MsoNormal{margin:0!important;}</style>
</head>
<body>
  <div id="${id}" data-marker="__SIG_PRE__">
    ${fragmentHtml}
  </div>
</body>
`.trim();
        },
        async setImgTempSecure(url, type) {
            const response = await fetch(url);
            const blob = await response.blob();
            // const base64 = await this.blobToBase64(blob);
            // console.log('checked base64', base64);
            // if(type === 'bg') {
            //     this.contentTempMail.bg  = base64;
            //     return;
            // }
            await this.uploadFile(null, [blob], null, null, type);
        },

        blobToBase64(blob) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result); // result trả về là base64 string (data:image/png;base64,...)
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        resetFileSecureError(cidLstInline = []) {
            this.listFileAttachment = this.listFileAttachment.filter((a) => a?.cid && cidLstInline.includes(a.cid));
        },
        async sendMail() {
            this.isSendingMail = true;
            let isSendSuccess = true;
            // sendMsgRequest
            let formDataRequest = null;
            let mpContent = {};
            let fileInContent = [];
            //case file email template
            if (this.modalSecure.isSecureMail) {
                let cidLstInline = [];
                try {
                    const keyCodeRs = await SecureMailService.getKeySecureMail();
                    if (keyCodeRs?.data?.code !== 1000) throw new String("error");
                    this.secureMailCode = keyCodeRs?.data?.result;
                    await Promise.all([this.setImgTempSecure(iconTemplateEmail, "icon"), this.setImgTempSecure(logoTemplateEmail, "logo")]);
                    formDataRequest = await this.checkFileAttachInContent(this.buildFormData(false, true, !this.modalSecure.isSecureMail));
                    const bodyContent = this.getFormMailSecure(_.clone(formDataRequest));
                    // return;
                    if (bodyContent) {
                        mpContent = _.cloneDeep(bodyContent);
                        // formDataRequest['mp'] = [];
                        if (Array.isArray(formDataRequest.mp) && formDataRequest.mp?.length > 0) {
                            try {
                                // formDataRequest.mp[0].mp.find(part => part.ct === "multipart/related").mp.find(part => part.ct === "text/html").content = await _.escape(this.buildHtmlForGateway(this.getHtmlSecureMail(this.modalSecure, formDataRequest, this.secureMailCode, this.contentTempMail)));
                                formDataRequest.mp[0].mp.find(part => part.ct === "multipart/related").mp.find(part => part.ct === "text/html").content = await _.escape(this.getHtmlSecureMail(this.modalSecure, formDataRequest, this.secureMailCode, this.contentTempMail));
                                // formDataRequest.mp[0].mp.find(part => part.ct === "multipart/related").mp.find(part => part.ct === "text/html").content = _.escape(this.getHtmlTest());
                                formDataRequest.mp[0].mp.find(part => part.ct === "text/plain").content = "";
                                const fileInLine = formDataRequest.mp[0].mp.find(part => part.ct === "multipart/related").mp ?? [];
                                if (this.listImageAttachSecure?.length > 0) {
                                    // const fileInLine = formDataRequest.mp[0].mp.find(part => part.ct === "multipart/related").mp ?? [];
                                    cidLstInline = fileInLine?.filter((i) => i?.ci && !i?.isSecure)?.map((i) => i?.ci) ?? [];
                                    fileInContent = this.listImageAttachSecure?.filter((i) => i.cid && cidLstInline.includes(i.cid));
                                }
                                if (fileInLine?.length > 0) formDataRequest.mp[0].mp.find(part => part.ct === "multipart/related").mp = fileInLine.filter((i) => i?.ct === "text/html" || i?.isSecure);
                            } catch (e) {
                                //do nothing
                                console.log("error", e);
                            }
                        }
                    }
                    formDataRequest["attachPart"] = [];
                    if (!this.modalSecure.dateExpired) {
                        isSendSuccess = false;
                        this.$notify({
                            title: this.$t("zimbra.zhMsg.ALT_ERROR"),
                            message: this.$t("zimbraNokey.secureMailServiceConnect"),
                            type: "error"
                        });
                        return isSendSuccess;
                    }
                    const formInsert = new FormData();
                    const secureMailUsers = (Array.isArray(formDataRequest?.e) ? formDataRequest?.e : []).map((i) => {
                        return { userMail: i?.a, userType: i?.t };
                    });

                    // formInsert.append("mailId", sendMsgResponse?.m?.id);
                    formInsert.append("contentEncryted", mpContent?.content);
                    formInsert.append("mailGroup", this.getEmailLogin());
                    formInsert.append("sendTo", [...new Set((Array.isArray(formDataRequest?.e) ? formDataRequest?.e : []).map(({ a }) => a).filter(Boolean))]);
                    formInsert.append("expiresAt", this.modalSecure.dateExpired ? moment(this.modalSecure.dateExpired)?.toISOString() : null);
                    formInsert.append("secureCode", this.secureMailCode);
                    formInsert.append("subject", formDataRequest?.su);
                    formInsert.append("sentAt", moment().toISOString());
                    if (Array.isArray(secureMailUsers) && secureMailUsers?.length > 0) {
                        secureMailUsers.forEach((u, i) => {
                            formInsert.append(`secureMailUsers[${i}].userMail`, u.userMail);
                            formInsert.append(`secureMailUsers[${i}].userType`, u.userType);
                        });
                    }
                    if (fileInContent?.length > 0) {
                        fileInContent?.forEach((u, i) => {
                            // formInsert.append("fileInContents", u.file);
                            formInsert.append(`fileInContents[${i}].file`, u.file);
                            formInsert.append(`fileInContents[${i}].cid`, u.cid);
                        });
                    }
                    if (this.listFileAttachmentSecure?.length > 0) {
                        this.listFileAttachmentSecure?.forEach((i) => {
                            formInsert.append("files", i.file);
                        });
                    }
                    this.isSendingMail = true;
                    const resInsertSecure = await SecureMailService.insertSecureMail(formInsert);
                    if(!resInsertSecure?.data?.result?.secureMailId) throw new Error('error');
                } catch (error) {
                    this.$notify({
                        title: this.$t("zimbra.zhMsg.ALT_ERROR"),
                        message: this.$t("zimbraNokey.secureMailServiceConnect"),
                        type: "error"
                    });
                    this.resetFileSecureError(cidLstInline);
                    isSendSuccess = false;
                    this.isSendingMail = false;
                    return isSendSuccess;
                }
            } else {
                formDataRequest = this.checkFileAttachInContent(this.buildFormData(false, true, !this.modalSecure.isSecureMail));
            }

            EventBus.$emit('handleDisplayPopupCompose', false)
            // this.isSendingMail = false;
            // return

            const payload = {
                m: formDataRequest,
                account: this.headerAccount
            }
            // return;
            const sendMsgRequest = await sendMailServiceWorker(payload).catch((error) => {
                const { detail = { Error: { Code: "" } } } = this.getResponseBody(error.response)?.["soap:Fault"] ?? {};
                let errCode = detail.Error.Code;
                if (errCode == "mail.SEND_FAILURE") {
                    const msgConfirm = `${this.$t("zimbra.zmMsg.sendErrorAbort")} <br> ${this.$t("zimbra.zmMsg.apptSendErrorInvalidAddresses",
                        [_.escape(this.listAddressInvalid.filter(x => x != "").join(';'))])}`
                    this.$confirm(
                        msgConfirm,
                        this.$t("zimbraNokey.zimbra_compose_criticalMsg"),
                        {
                            dangerouslyUseHTMLString: true,
                            showConfirmButton: false,
                            cancelButtonText: this.$t("zimbra.zmMsg.mobileStatusNeedProvision"),
                            type: "error",
                        }
                    )
                        .then(() => {
                        })
                        .catch(() => {
                        });
                } else if (errCode == "mail.QUOTA_EXCEEDED" ) {
                    this.$confirm(
                        this.$t("zimbra.error.mail.QUOTA_EXCEEDED"),
                        this.$t("zimbra.zhMsg.zimbraTitle"),
                        {
                            showConfirmButton: false,
                            cancelButtonText: this.$t("zimbra.zmMsg.mobileStatusNeedProvision"),
                            type: "error",
                        }
                    )
                        .then(() => {
                        })
                        .catch(() => {
                        });
                } else if (errCode == "mail.MESSAGE_TOO_BIG"){
                    this.$confirm(
                        this.$t("zimbra.error.mail.MESSAGE_TOO_BIG"),
                        this.$t("zimbra.zhMsg.zimbraTitle"),
                        {
                            showConfirmButton: false,
                            cancelButtonText: this.$t("zimbra.zmMsg.mobileStatusNeedProvision"),
                            type: "error",
                        }
                    )
                        .then(() => {
                        })
                        .catch(() => {
                        });
                }else if (errCode == "mail.SEND_ABORTED_ADDRESS_FAILURE") {
                    const { content } = detail.Error?.a;
                    this.$notify({
                        title: this.$t("zimbraNokey.zimbra_sidebar_criticalMsg"),
                        message: this.$t("zimbra.error.mail.SEND_ABORTED_ADDRESS_FAILURE", { 0: content }),
                        type: "error",
                    });
                } else if (errCode == "service.PERM_DENIED") {
                    this.$notify({
                        title: this.$t("zimbraNokey.zimbra_sidebar_criticalMsg"),
                        message: this.$t("zimbraNokey.PERM_DENIED"),
                        type: "error",
                    });
                }
                else {
                    this.$notify({
                        title: this.$t("zimbraNokey.zimbra_sidebar_criticalMsg"),
                        message: this.$t("zimbraNokey.ERROR_SEND_MAIL"),
                        type: "warning",
                    });
                }
                isSendSuccess = false;
            }).finally(() => {
                this.isSendingMail = false;
                this.isFullScreen = false;
            })
            if (!isSendSuccess) {
                return false;
            }
            const sendMsgResponse =
                this.getResponseBody(sendMsgRequest)["SendMsgResponse"];
            if (this.modalSecure.isSecureMail) {
                // if(!this.modalSecure.dateExpired){
                //     isSendSuccess = false;
                //     this.$notify({
                //         title: this.$t("zimbra.zhMsg.ALT_ERROR"),
                //         message: this.$t("zimbraNokey.secureMailServiceConnect"),
                //         type: "error",
                //     });
                //     return;
                // }
                // const formInsert = new FormData();
                // const secureMailUsers = (Array.isArray(formDataRequest?.e) ? formDataRequest?.e : []).map((i) => {
                //     return { userMail: i?.a, userType: i?.t }
                // });
                //
                // formInsert.append("mailId", sendMsgResponse?.m?.id);
                // formInsert.append("contentEncryted", mpContent?.content);
                // formInsert.append("mailGroup", this.getEmailLogin());
                // formInsert.append("sendTo", [...new Set((Array.isArray(formDataRequest?.e) ? formDataRequest?.e : []).map(({ a }) => a).filter(Boolean))]);
                // formInsert.append("expiresAt", this.modalSecure.dateExpired ? moment(this.modalSecure.dateExpired)?.toISOString() : null);
                // formInsert.append("secureCode", this.secureMailCode);
                // formInsert.append("subject", formDataRequest?.su);
                // formInsert.append("sentAt", moment().toISOString());
                // if (Array.isArray(secureMailUsers) && secureMailUsers?.length > 0) {
                //     secureMailUsers.forEach((u, i) => {
                //         formInsert.append(`secureMailUsers[${i}].userMail`, u.userMail);
                //         formInsert.append(`secureMailUsers[${i}].userType`, u.userType);
                //     });
                // }
                // if (fileInContent?.length > 0) {
                //     fileInContent?.forEach((u, i) => {
                //         // formInsert.append("fileInContents", u.file);
                //         formInsert.append(`fileInContents[${i}].file`, u.file);
                //         formInsert.append(`fileInContents[${i}].cid`, u.cid);
                //     });
                // }
                // if (this.listFileAttachmentSecure?.length > 0) {
                //     this.listFileAttachmentSecure?.forEach((i) => {
                //         formInsert.append("files", i.file);
                //     });
                // }
                // this.isSendingMail = true;
                // Promise.all([SecureMailService.insertSecureMail(formInsert)])
                //     .then(([resSecureMail]) => {
                //         if (resSecureMail) {
                //             this.$notify({
                //                 title: this.$t("zimbra.zmMsg.dataSourceTestSuccess"),
                //                 message: this.$t("zimbra.zmMsg.messageSentSecureMail"),
                //                 type: "success",
                //             });
                //             this.$emit("sendMsgSuccess", sendMsgResponse);
                //             isSendSuccess = true;
                //             this.$root.$emit("reloadDataFolder", FOLDER_DEFAULT.DRAFTS)
                //         } else {
                //             // gửi thất bại
                //             isSendSuccess = false;
                //         }
                //     })
                //     .catch((error) => {
                //         console.log(error);
                //         isSendSuccess = false;
                //         this.$notify({
                //             title: this.$t("zimbra.zhMsg.ALT_ERROR"),
                //             message: this.$t("zimbraNokey.secureMailServiceConnect"),
                //             type: "error",
                //         });
                //     })
                //     .finally(() => {
                //         this.isSendingMail = false;
                //     })
                if (sendMsgResponse) {
                    this.$notify({
                        title: this.$t("zimbra.zmMsg.dataSourceTestSuccess"),
                        message: this.$t("zimbra.zmMsg.messageSentSecureMail"),
                        type: "success"
                    });
                    this.$emit("sendMsgSuccess", sendMsgResponse);
                    isSendSuccess = true;
                    this.$root.$emit("reloadDataFolder", FOLDER_DEFAULT.DRAFTS)
                } else {
                            this.$notify({
                                title: this.$t("zimbra.zhMsg.ALT_ERROR"),
                                message: this.$t("zimbraNokey.secureMailServiceConnect"),
                                type: "error",
                            });
                    isSendSuccess = false;
                }
                return isSendSuccess;
            } else {
                if (sendMsgResponse) {
                    // this.$notify({
                    //     title: this.$t("zimbra.zmMsg.messageSent"),
                    //     type: "success",
                    //     showClose: false,
                    //     customClass: 'noti-sending'
                    // });
                    this.$emit("sendMsgSuccess", sendMsgResponse);
                    isSendSuccess = true;
                    // const { id } = sendMsgResponse?.m;
                    // if (this.originId && id) {
                    //     const form = {
                    //         id: `${this.originId}`,
                    //         l: `${FOLDER_DEFAULT.TRASH}`,
                    //         op: `trash`,
                    //         tcon: "-dtj",
                    //     };
                    //     await ZimbraMailService.msgActionRequest(form).catch(error => {
                    //         console.log(">>>>> error: ", error);
                    //     });
                    // }
                    this.$root.$emit("reloadDataFolder", FOLDER_DEFAULT.DRAFTS)
                } else {
                    // gửi thất bại
                    isSendSuccess = false;
                }
            }

            return isSendSuccess;
        },
        /**
         * Gửi thư sửa câu trả lời cuộc hẹn
         */
        sendInviteReply() {
            ZimbraMailService.sendInviteReplyRequest({
                id: this.modelData?.id?.toString(),
                compNum: 0, // ???
                verb: this.modelData?.verb,
                updateOrganizer: "TRUE",
                m: this.buildFormData(false),
            }).then(() => {
                let msg = "";
                switch (this.modelData?.verb) {
                    case CAL_OPERATOR_REPLY_INV.ACCEPT:
                        msg = this.$t("zimbra.zmMsg.inviteAccepted");
                        break;
                    case CAL_OPERATOR_REPLY_INV.TENTATIVE:
                        msg = this.$t("zimbra.zmMsg.inviteAcceptedTentatively");
                        break;
                    case CAL_OPERATOR_REPLY_INV.DECLINE:
                        msg = this.$t("zimbra.zmMsg.inviteDeclined");
                        break;
                }
                this.$notify({
                    title: this.$t("zimbra.zmMsg.dataSourceTestSuccess"),
                    message: this.$t(msg),
                    type: "success",
                });
                this.$emit("sendMsgSuccess");
                this.$root.$emit("handleNavbarAction", EMAIL_ACTION.DELETE_IMMEDIATELY);
            });
        },
        changeContentType(type, withoutConfirm) {
            this.visible = false;
            if (type == this.contentType) {
                return;
            }
            const title =
                type == EMAIL_CONTENT_TYPE.PLAIN
                    ? this.$t("zimbra.zmMsg.switchIncludeAndFormat")
                    : this.$t("zimbra.zmMsg.switchIncludeWarning");
            if (withoutConfirm) {
                this.handleChangeContentType(type);
            } else {
                this.$confirm(title, this.$t("zimbra.ztMsg.alertFeedReplyTitle"))
                    .then(() => {
                        this.handleChangeContentType(type);
                    })
                    .catch(() => {
                    });
            }
        },
        _htmlToText(html) {
            const convertor = {
                "blockquote": function () {
                    return "\n" + ZmComposeView.BQ_BEGIN + "\n";
                },
                "/blockquote": function () {
                    return "\n" + ZmComposeView.BQ_END + "\n";
                },
                "_after": this.simpleClosure
            }
            return AjxStringUtil.convertHtml2Text(html, convertor);
        },
        simpleClosure(text) {
            const arr = text.split("\n");
            if (arr.length > 0) {
                const result = [];
                let numberQuoted = 0;
                for (let index = 0; index < arr.length; index++) {
                    if (arr[index] === ZmComposeView.BQ_BEGIN) {
                        numberQuoted++;
                        continue;
                    } else if (arr[index] === ZmComposeView.BQ_END) {
                        numberQuoted--;
                        continue;
                    }
                    result.push(`\n${this.repeat(this.preference.zimbraPrefForwardReplyPrefixChar, numberQuoted)} ${arr[index]}`)
                }
                return result.join("");
            }
            return "";
        },
        /**
         * Lặp lại text với số lần number
         */
        repeat(text, number) {
            if (!text) {
                return "";
            }
            const result = [];
            for (let index = 0; index < number; index++) {
                result.push(text);
            }
            return result.join("");
        },
        /**
         * Chuyển định dạng sang văn bản thuần túy
         */
        handleChangeContentTypePlainText() {
            const div = document.createElement("div");
            $(div).html(this.$refs.refEditor?.editor.getContent());
            // const temp = $(div).children(`[data-marker='${this.getDataMarker(ZmComposeView.BC_DIVIDER)}']`);
            const textPre = this._htmlToText(this.getTextPreHtml());
            const signPre = this._htmlToText(this.getSignature(SIGNATURE_STYLE.OUTLOOK, this.signatureActiveId));
            let divider = "";
            let quoted = "";
            if (!this.isAddNew) {
                divider = this.getDividerPlainText();
                quoted = this._htmlToText(this.getContentByMarkerHtml(ZmComposeView.BC_QUOTED_TEXT));
            }
            const signPost = this._htmlToText(this.getSignature(SIGNATURE_STYLE.INTERNET, this.signatureActiveId));
            this.plainText = [
                textPre,
                signPre ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_SIG_PRE]}${signPre}` : "",
                divider ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_DIVIDER]}${divider}` : "",
                quoted ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_QUOTED_TEXT]}${quoted}` : quoted,
                signPost ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_SIG_POST]}${signPost}` : signPost,
            ].filter(Boolean).join("\n");
        },
        /**
         * Chuyển định dạng sang HTML
         */
        handleChangeContentTypeHtml(type) {
            const prefix = this.preference.zimbraPrefForwardReplyPrefixChar;
            const textPre = AjxStringUtil.convertToHtml(this.getContentByMarkerText(ZmComposeView.BC_TEXT_PRE), prefix);
            const signPre = this.getSignature(SIGNATURE_STYLE.OUTLOOK, this.signatureActiveId);
            let divider = "";
            let header = "";
            let quoted = "";
            if (!this.isAddNew && this.actionType !== EMAIL_ACTION.COMPOSE) {
                if (this.includeHeaders) {
                    divider = this.getDivider();
                    header = `<div data-marker="${this.getDataMarker(ZmComposeView.BC_HEADERS)}">${this.getHeader(this.rawData)}</div>`;
                } else {
                    if (this.data?.isFromCalendar) {
                        header = this.getDividerWithoutHeadersCalendar();
                    } else {
                        header = `<div data-marker="${this.getDataMarker(ZmComposeView.BC_HEADERS)}">${this.getDividerWithoutHeaders(this.rawData, type)}</div>`;
                    }
                }
                quoted = AjxStringUtil.convertToHtml(this.getContentByMarkerText(ZmComposeView.BC_QUOTED_TEXT), prefix, `<blockquote style="${ZmComposeView.styleQuote}">`);
                quoted = `<div data-marker="${this.getDataMarker(ZmComposeView.BC_QUOTED_TEXT)}">${quoted}</div>`;
            }
            const signPost = this.getSignature(SIGNATURE_STYLE.INTERNET, this.signatureActiveId);
            this.editorModel = [textPre, signPre, divider, quoted, signPost].join("");
            this.editorModel = this.handleFixImageSrc(this.editorModel, this.allPart, this.modelData.origid);
        },
        /**
         * Thay đổi định dạng nhập nội dung
         */
        handleChangeContentType(type) {
            if (type == EMAIL_CONTENT_TYPE.PLAIN) {
                this.handleChangeContentTypePlainText(type);
            } else {
                this.handleChangeContentTypeHtml(type);
            }
            this.contentType = type;
        },
        handleFocusAddress(){
            this.$refs.toAddressSelector?.showInput()
            this.$refs.ccAddressSelector && this.$refs.ccAddressSelector?.showInput()
            this.$refs.bccAddressSelector && this.$refs.bccAddressSelector?.showInput()
        },
        openDialogFileChooser() {
            this.$refs.fileChooser.click();
        },
        validateFileExtention(listFile) {
            listFile = Array.isArray(listFile) ? listFile : [...listFile];
            const invalid = listFile.filter(e => this.validateFileExtentionDeny(e.name));
            return invalid && invalid.length > 0;
        },
        validateFileSize(listFile) {
            // validate file bị làm tròn nhiều lần
            // listFile = Array.isArray(listFile) ? listFile : [...listFile];
            // const invalid = listFile.some(file => {
            //     let sizeFile = file.size / (1024 * 1024);
            //     sizeFile = Math.round(sizeFile * 10) / 10;
            //     return sizeFile >= 27;
            // });
            // return invalid;
            const files = Array.isArray(listFile) ? listFile : Array.from(listFile);
            const totalBytes = files.reduce((sum, file) => sum + file.size, 0);
            const totalMB = totalBytes / (1024 * 1024);
            return totalMB >= 27;
        },
        async uploadFile(event, listFile, isDrog, editor, tempType = null) {
            this.isContinueUpload = true;
            if (this.validateFileExtention(listFile)) {
                this.$notify({
                    title: this.$t("zimbra.ztMsg.alertFeedReplyTitle"),
                    message: this.$t("zimbraNokey.zimbra_zimbraNokey_fileExtentionDeny"),
                    type: "warning",
                });
                return;
            }
            if (this.validateFileSize(listFile)) {
                this.$notify({
                    title: this.$t("zimbra.ztMsg.alertFeedReplyTitle"),
                    message: this.$t("zimbra.zmMsg.attachmentSizeError", { 0: "27MB" }),
                    type: "warning",
                });
                return;
            }
            for (let index = 0; index < listFile.length && this.isContinueUpload; index++) {
                const file = listFile[index];
                // validate max size
                let invalid = false;
                if (file.size > this.maxSizeAttach) {
                    const size = this.formatSize(this.maxSizeAttach, true);
                    await this.$confirm(
                        this.$t("zimbraNokey.zimbra_compose_validateMaxSizeAttach", { size }),
                        this.$t("zimbraNokey.zimbra_compose_criticalMsg"),
                        {
                            showConfirmButton: false,
                            cancelButtonText: this.$t("zimbra.zmMsg.mobileStatusNeedProvision"),
                            type: "error",
                        }
                    ).then(() => {
                    }).catch(() => {
                        invalid = true;
                    });
                }
                if (invalid) {
                    return;
                }
                const formData = new FormData();
                formData.append("file", file);
                this.fileUploading = file;
                this.percentUploading = 1;
                this.intervalUploadFile = setInterval(() => {
                    if (this.percentUploading < 95) {
                        this.percentUploading++;
                    }
                }, 100);
                await UploadService.uploadFile(formData).then(async (upload) => {
                    const data = upload.data || "";
                    const arrResponse = eval(`[${data}]`);
                    if (arrResponse && arrResponse[0] && arrResponse[0] == 200) {
                        const attach = arrResponse[2][0];
                        const regex_img = /^image/i;
                        this.fileUploading = null;

                        if(!tempType && !editor)this.listFileAttachmentSecure.push({ aid: attach.aid, file: file });

                        clearInterval(this.intervalUploadFile);
                        if (!editor || !regex_img.test(attach.ct)) {
                            file["aid"] = attach.aid;
                            file["part"] = this.listFileAttachment.length + 2;
                            this.listFileAttachment.push(file);
                        }
                        if (this.viewLoaded || upload.data) {
                            if (this.modalSecure.isSecureMail && tempType && regex_img.test(attach.ct)) {
                                const cid = ZmComposeView.generateCid();

                                this.listImageAttach.push({
                                    cid: cid,
                                    aid: attach.aid,
                                    isSecure: true
                                })
                                switch (tempType) {
                                    case 'bg':
                                        // this.contentTempMail.bg = `<img pnsrc="cid:${cid}" data-mce-src="cid:${cid}" src="cid:${cid}" style="max-width: 100%; max-height: 200px">`
                                        this.contentTempMail.bg = cid;
                                        break;
                                    case 'icon':
                                        // this.contentTempMail.icon = `<img pnsrc="cid:${cid}" data-mce-src="cid:${cid}" src="cid:${cid}" style="max-width: 100%; height: auto">`
                                        this.contentTempMail.icon = cid;
                                        break;
                                    case 'logo':
                                        // this.contentTempMail.logo = `<img  pnsrc="cid:${cid}" data-mce-src="cid:${cid}" src="cid:${cid}" style="max-width: 100%; height: auto">`
                                        this.contentTempMail.logo = cid;
                                        break;
                                    default:
                                        break;
                                }
                            } else if (!editor) {
                                await this.executeSaveDraft(!!editor, false);
                            } else if (regex_img.test(attach.ct)) {
                                const cid = ZmComposeView.generateCid();
                                this.listImageAttach.push({
                                    cid: cid,
                                    aid: attach.aid,
                                    file: file
                                })
                                const img = `<div><img pnsrc="cid:${cid}" data-mce-src="cid:${cid}" src="cid:${cid}" style="max-width: 100%; height: auto"></div>`;
                                editor.insertContent(img);
                            }
                        }
                    }
                }).catch(() => {
                    this.fileUploading = null;
                    clearInterval(this.intervalUploadFile);
                });
            }
            if (editor) {
                this.listImageAttachSecure = [...new Map([...this.listImageAttachSecure, ...this.listImageAttach].map(item => [item.cid, item])).values()]
                await this.executeSaveDraft(!!editor, false, false, true);
                // await this.executeSaveDraft(!!editor, false);
            }
            if (!isDrog && event?.target) {
                event.target.files = null;
                this.$refs.fileChooser.value = '';
            }
        },
        async onSelectedFile(event) {
            if (event && event.target.files.length > 0) {
                await this.uploadFile(event, event.target.files, false);
            }
        },
        onRemoveAttachment(index) {
            if (
                this.includeAsAttachIndex &&
                index <= this.includeAsAttachIndex
            ) {
                this.includeAsAttachIndex--;
            }
            this.listFileAttachment.splice(index, 1);
            this.listFileAttachmentSecure.splice(index, 1);
            this.listFileAttachmentSend = _.cloneDeep(this.listFileAttachment);
        },
        handleSaveDraft() {
            if (
                !this.viewLoaded && this.actionType != EMAIL_ACTION.NEW_RECORD ||
                this.preference.zimbraPrefAutoSaveDraftInterval == 0 ||
                this.actionType === EMAIL_ACTION.EDIT_REPLY_CAL
            ) {
                return;
            }
            if (this.interval) {
                clearTimeout(this.interval);
            }
            // if (this.autoSaveDraftInterval?.content !== 0) {
            this.interval = setTimeout(async () => {
                await this.executeSaveDraft();
            }, this.$configZimbra.TIME_SAVE_DRAFT);
            // this.someThingChanged();
            // }
        },
        handleSaveBtnDraft() {
            this.isClickBtnDraft = true;
            this.executeSaveDraft(true);
        },
        async executeSaveDraft(isSaveManual, withNotify = true, isChangeAddr = false, isPateProcess = false) {
            await ZimbraMailService.saveDraftRequest({
                m: this.buildFormData(true),
            }, withNotify)
                .then(async (saveDraftRequest) => {
                    const saveDraftResponse =
                        this.getResponseBody(saveDraftRequest)[
                            "SaveDraftResponse"
                            ];
                    if (saveDraftResponse?.m?.id) {
                        saveDraftResponse.m.signatureActive = this.signatureActive;
                        this.draftId = saveDraftResponse?.m?.id;
                        await this.updateListAttach(saveDraftResponse);
                        const modelData = await this.initDataForEditDraft(null, saveDraftResponse?.m);
                        modelData.actionType = this.actionType;
                        isSaveManual && await this.initialData(modelData, isSaveManual, isPateProcess);
                        const formData = {
                            key: saveDraftResponse?.m?.id,
                            value: saveDraftResponse
                        }
                        await this.$store.dispatch("updateMessageData", formData);
                        if (isChangeAddr) {
                            this.$nextTick(() => {
                                this.editorModel = this.handleFixImageSrc(modelData.editorModel || "", this.attachInline, modelData?.draftId);
                            })
                        }
                        this.listImageAttach = [];
                    }
                    if (isSaveManual) {
                        this.$notify({
                            title: this.$t("zimbra.zmMsg.dataSourceTestSuccess"),
                            message: this.$t("zimbra.zmMsg.draftSaved"),
                            type: "success",
                        });
                    }
                    this.$root.$emit("executeSaveDraft", this.draftId);
                    /// reload Folder thư nháp 1 lần khi soạn
                    if (!this.hasReloadDraft) {
                        this.hasReloadDraft = true;
                        this.$root.$emit("reloadDataFolder", FOLDER_DEFAULT.DRAFTS);
                    }
                    // cập nhật list bản nháp mỗi khi có thay đổi
                    // bổ sung reload list khi bấm lưu nháp
                    if ((this.activeNodeSidebar.id == FOLDER_DEFAULT.DRAFTS && this.actionName == EMAIL_ACTION.NEW_RECORD) || isSaveManual) {
                        if (this.isMailBasic) return;
                        this.$root.$emit("reloadListMail");
                    }
                    /// reload mail trên list mail
                    if (saveDraftResponse?.m?.cid && this.originCid
                        && this.preference?.zimbraPrefGroupMailBy == "conversation" && !(this.activeNodeSidebar.id == FOLDER_DEFAULT.DRAFTS)) {
                        this.$root.$emit("reloadConvAfterAction", {
                            originId: this.originCid,
                            newId: saveDraftResponse.m.cid
                        });
                    }
                })
                .catch((error) => {
                    const { detail } = this.getResponseBody(error.response)["soap:Fault"] || {};
                    let errCode = detail.Error.Code;
                    let msg = "";
                    if (errCode == "mail.QUOTA_EXCEEDED") {
                        this.listFileAttachment = [];
                        msg = this.$t("zimbra.zmMsg.errorQuotaExceeded");
                    } else if (errCode == "mail.NO_SUCH_CONTACT") {
                        this.listAttachContact = [];
                        msg = this.$t("zimbra.zmMsg.vcardContactGone");
                    } else if (errCode == "mail.MESSAGE_TOO_BIG") {
                        this.listFileAttachment.pop()
                        this.listAttachContact = [];
                        msg = this.$t("zimbra.zmMsg.attachmentSizeError", { 0: "27MB" });
                    }
                    if (msg) {
                        this.$confirm(
                            msg,
                            this.$t("zimbraNokey.zimbra_compose_criticalMsg"),
                            {
                                showConfirmButton: false,
                                cancelButtonText: this.$t("zimbra.zmMsg.mobileStatusNeedProvision"),
                                type: "error",
                            }
                        )
                            .then(() => {
                            })
                            .catch(() => {
                            });
                    }
                    this.isContinueUpload = false;
                });
        },
        getTabData() {
            return {
                modelData: this.modelData,
                dialogFormVisible: this.dialogFormVisible,
                showCc: this.showCc,
                showBcc: this.showBcc,
                priority: this.priority,
                requestReadReceipt: this.requestReadReceipt,
                contentType: this.contentType,
                emailAddress: this.emailAddress,
                plainText: this.plainText,
                listFileAttachment: this.listFileAttachment,
                listFileAttachmentSend: this.listFileAttachmentSend,
                editorModel: this.editorModel,
                draftId: this.draftId,
                isChanged: this.isChanged,
                actionType: this.actionType,
                isSaveAuto: this.isSaveAuto,
                allPart: this.allPart,
                attachInline: this.attachInline,
                isChangeTab: true,
                signatureActive: this.signatureActive,
            };
        },
        initImageMail(data) {
            const dataImg = data.allPart
            let arrImageInline = [];
            if (data?.rtf && this.firstInitImage) {
                this.firstInitImage = false;
                const div = document.createElement("div");
                $(div).html(data?.editorModel.trim());
                const images = $(div).find("img");
                this.rtf = true
                for (const key in dataImg) {
                    const part = dataImg[key];
                    // Kiểm tra nếu là attachment và là ảnh
                    if (part?.cd === "attachment" && part?.ct.includes("image")) {
                        const fileName = part?.filename?.toLowerCase();

                        // Tìm ảnh inline có chứa filename trong thuộc tính data-mce-src
                        const matchedImg = images.filter(function() {
                            const mceSrc = $(this).attr("data-mce-src")?.toLowerCase();
                            return mceSrc && fileName && mceSrc.includes(fileName);
                        });

                        if (matchedImg.length) {
                            const mceSrc = matchedImg.first().attr("data-mce-src")
                            part.ci = mceSrc && mceSrc.split(':')[1]
                            arrImageInline.push(part);
                        }
                    }
                }

                this.attachInline = arrImageInline
                return;
            }
            if (data.attachInline) {
                this.attachInline = data.attachInline;
                return
            }

            if (dataImg) {
                let images = []
                for (const key in dataImg) {
                    if (dataImg[key]?.ci && dataImg[key]?.ct.includes("image")) {
                        images.push(dataImg[key])
                    }
                }
                arrImageInline.push(...images);
            }
            this.attachInline = arrImageInline;

        },
        async initialData(data, isInitManual, isPateProcess = false) {
            // set mặc định cho soạn thư
            // if (this.fromAddresses?.length > 0 && this.actionName == EMAIL_ACTION.NEW_RECORD) {
            //     this.$set(this.modelData, 'from', this.fromAddresses[0]);
            //     // this.getInfo();
            // }
            this.isChanged = false;
            if (isInitManual) {
                this.viewLoaded = false;
            }
            if (data) {
                this.originId = data.id;
                this.originCid = data.cid;
                this.showCc = data.showCc == true || _.isNil(data.showCc);
                this.showBcc = data.showBcc == true || _.isNil(data.showBcc);
                // this.contentType = data.contentType || EMAIL_CONTENT_TYPE.HTML;
                this.contentType = EMAIL_CONTENT_TYPE.HTML;  // auto để HTML
                this.actionType = data.actionType;
                // this.attachInline = data.attachInline;
                this.initImageMail(data);
                this.signatureActive = data.signatureActive;
                this.allPart = data.allPart;
                this.isAddNew = data.isAddNew;
                this.actionType = data.actionType;
                if (data.listAttachBriefcase && data.listAttachBriefcase.length) {
                    this.listAttachBriefcase = data.listAttachBriefcase
                    this.executeSaveDraft(false, false, isPateProcess)
                }
                setTimeout(() => {
                    this.modelData = (isPateProcess ? {...data.modelData, to: this.modelData?.to ?? []} : data.modelData) || {} ;
                    // loại bỏ các địa chỉ email trùng lặp trong danh sách người nhận đối với mail gửi cho bản thân
                    if (!isPateProcess) {
                        this.modelData.to = Array.isArray(data?.modelData?.to)
                            ? Object.values(
                                data.modelData.to.reduce((acc, item) => {
                                    const email = item.a.toLowerCase();
                                    if (!acc[email] || (acc[email].p && !item.p)) {
                                        acc[email] = item;
                                    }
                                    return acc;
                                }, {})
                            )
                            : [];
                    }

                    if (this.modelData.fromAddress?.length > 0) {
                        const _from = this.fromAddresses.find(x => x.a === this.modelData.fromAddress[0].a);
                        if (_from) {
                            this.modelData.from = _from;
                        }
                    } else if (this.fromAddresses?.length > 0) {
                        this.modelData.from = this.fromAddresses[0];
                    }
                    this.modelData.from = this.activeNodeSidebar?.emailDefault || this.modelData.from;
                    this.dialogFormVisible = data.dialogFormVisible || false;
                    this.priority = data.priority || EMAIL_FLAG.PRIORITY;
                    this.requestReadReceipt = data.requestReadReceipt || this.mailRequestReadReceipts?.content || false;
                    //   this.emailAddress = data.emailAddress;
                    this.plainText = data.plainText;
                    this.listFileAttachmentSend = data.listFileAttachmentSend || [];
                    // this.listFileAttachment = data.listFileAttachment || [];
                    // this.editorModel = data.editorModel || "";

                    this.$nextTick(() => {
                        this.editorModel = this.handleFixImageSrc(data.editorModel || "", this.attachInline, data?.draftId || data.id);
                        this.$refs.refEditor && this.$refs.refEditor?.editor && this.$refs.refEditor?.editor.setContent(this.editorModel);
                    });

                    if (data.actionType === EMAIL_ACTION.EDIT_AS_NEW) {
                        this.draftId = data.id;
                    }

                    if (data.modelData.emailContact) {
                        // chuyển tiếp số liên hệ
                        let fileContact = []
                        data.modelData.emailContact.listFileAttachment?.map(ele => {
                            fileContact.push({
                                ...ele,
                                href: this.createUrlDownloadFile(
                                    data.modelData.emailContact.id,
                                    ele.part)
                            })
                        });
                        // const sizeFile = AjxUtil.formatSize(fileContact.s);
                        this.listFileAttachment =
                            fileContact.map(e => {
                                return {
                                    name: `${e.filename} (${AjxUtil.formatSize(e.s).size} ${AjxUtil.formatSize(e.s).units})`,
                                    href: `${e.href}`,
                                }
                            })
                        this.listFileAttachmentSend =
                            fileContact.map(e => {
                                return {
                                    name: `${e.filename} (${AjxUtil.formatSize(e.s).size} ${AjxUtil.formatSize(e.s).units})`,
                                    href: `${e.href}`,
                                }
                            })
                        this.draftId = data.modelData.emailContact.id;
                    }
                    if (data.modelData.listAttachMail) {
                        this.listAttachMail = data.modelData.listAttachMail;
                    }
                    if (data.isAddNew) {
                        this.$refs.toAddressSelector.focus();
                        this.getInfo();
                    }
                    if (
                        this.actionType === EMAIL_ACTION.FORWARD ||
                        this.actionType === EMAIL_ACTION.FORWARD_CONVERSATION ||
                        this.actionType === EMAIL_ACTION.EDIT_REPLY_CAL ||
                        this.actionType === EMAIL_ACTION.COMPOSE ||
                        this.actionType === EMAIL_ACTION.EDIT_AS_NEW ||
                        data.draftId
                    ) {
                        this.listFileAttachment = data.listFileAttachment || [];
                    } else {
                        this.listFileAttachmentOrigin =
                            data.listFileAttachment;
                    }
                    this.saveDraftImmediately = data.saveDraftImmediately;
                    if (!isInitManual && !data.isAddNew && !data.isNewWindow && !data.isChangeTab && !data.isInitManual) {
                        setTimeout(() => {
                            this.$nextTick().then(() => {
                                if (this.actionType === EMAIL_ACTION.FORWARD) {
                                    this.handleChangeInclude(this.preference.zimbraPrefForwardIncludeOriginalText);
                                    this.includes = this.preference.zimbraPrefForwardIncludeOriginalText;
                                } else if (this.actionType === EMAIL_ACTION.REPLY || this.actionType === EMAIL_ACTION.REPLY_ALL) {
                                    this.handleChangeInclude(this.preference.zimbraPrefReplyIncludeOriginalText);
                                    this.includes = this.preference.zimbraPrefReplyIncludeOriginalText;
                                }
                                // TODO không rõ đoạn code dưới dùng thêm vào làm gì khi mà code ở trên đã tạo header rồi
                                // this.includeHeaders = this.isActive(OPTITON_COMPOSE.INCLUDE_HEADERS);
                                // this.usePrefix = this.isActive(OPTITON_COMPOSE.USER_PREFIX);
                                // if (this.includes != INCLUDE_BODY.INCLUDE_NONE
                                //     && this.includes != INCLUDE_BODY.INCLUDE_AS_ATTACHMENT) {
                                //     setTimeout(() => {
                                //         this.$nextTick().then(() => {
                                //             this.handleChangeIncludeHeaders(this.includeHeaders);
                                //             this.$nextTick().then(() => {
                                //                 this.handleChangeUsePrefix(this.usePrefix);
                                //             });
                                //         });
                                //     }, 300);
                                // }
                            });
                        }, 500);
                    }
                    if (this.actionType === EMAIL_ACTION.COMPOSE && data.isAddNew) {
                        setTimeout(() => {
                            this.changeContentType(this.preference?.zimbraPrefComposeFormat, true);
                        }, 300);
                    }
                }, 200);
                setTimeout(() => {
                    this.viewLoaded = true;
                    if (data.autoSaveDraftInterval) {
                        this.handleSaveDraft()
                    }
                }, 2000);
            }
            if (this.actionType == EMAIL_ACTION.REPLY_ALL || this.actionType == EMAIL_ACTION.FORWARD || this.actionType == EMAIL_ACTION.EDIT_AS_NEW || this.actionType == EMAIL_ACTION.REPLY || this.actionName == EMAIL_ACTION.NEW_RECORD) {
               setTimeout(()=>{
                   this.focusEditor(this.actionType)
               }, 500)
            }
            /// check hiện nút gửi và lưu sau khi truyền data xang
            this.showSendAndArchive = this.folderArchive && this.folderArchive.showSendAndArchive &&
                (this.actionType == EMAIL_ACTION.REPLY || this.actionType == EMAIL_ACTION.REPLY_ALL || this.actionType == EMAIL_ACTION.FORWARD);
        },
        handleSendMsgShortcut(e) {
            if (e.preventDefault && this.useSendMsgShortcut.content) {
                e.preventDefault();
                this.handleSendMsg();
            } else {
                e.returnValue = false;
            }
        },
        handlePushReceiver(val) {
            this.modelData?.to.push(val)
        },
        onInsertAI(html) {
            const editor = this.$refs.refEditor?.editor;
            if (!editor) return;

            // Lấy vùng chọn hiện tại
            const selected = editor.selection.getContent({ format: 'html' });

            // Nếu có text được bôi đen → replace luôn
            if (selected && selected.trim() !== "") {
                editor.selection.setContent(html);
                editor.focus();
                return;
            }

            // Không có vùng chọn → insert như cũ
            if (!editor.hasFocus()) {
                editor.focus();
                editor.selection.select(editor.getBody(), true);
                editor.selection.collapse(true);
            }

            editor.insertContent(html);
        },
    //     async callAI(requestId, message, ed) {
    //         if (this.isStreaming) {
    //             this.$message({
    //                 message: this.$t('zimbraNokey.waitAi'),
    //                 type: "warning",
    //             });
    //             return;
    //         }
    //         this.isStreaming = true;
    //
    //         const originalText = ed.selection.getContent({ format: "html" });
    //         const spanId = `ai-streaming-${requestId}`;
    //
    //         // Chèn placeholder với div bao ngoài
    //         ed.selection.setContent(`
    //     <div class="ai-stream-container">
    //       <span id="${spanId}">
    //         <img src='${imgAI}' alt="AI" style="width:20px;height:20px;"/>
    //         <img src='${imgLoading}' alt="loading..." style="width:20px;height:20px;"/>
    //       </span>
    //     </div>
    // `);
    //
    //         this.finalContent = "";
    //         let firstChunk = true;
    //         let buffer = "";
    //
    //         // safeguard: auto reset sau 5S
    //         const timeoutId = setTimeout(() => {
    //             this.isStreaming = false;
    //         }, 5000);
    //
    //         try {
    //             const res = await fetch(`https://vmail.viettel.vn/api/ai/events/${requestId}`, {
    //                 method: "POST",
    //                 headers: { "Content-Type": "application/json",
    //                         "Accept": "text/event-stream",
    //                     "Cache-Control": "no-cache",
    //                     "Connection": "keep-alive"},
    //                 body: JSON.stringify(message)
    //             });
    //
    //             if (!res.ok || !res.body) {
    //                 throw new Error("AI API error: " + res.status);
    //             }
    //
    //             const reader = res.body.getReader();
    //             const decoder = new TextDecoder("utf-8");
    //
    //             while (true) {
    //                 const { done, value } = await reader.read();
    //                 if (done) break;
    //
    //                 buffer += decoder.decode(value, { stream: true });
    //
    //                 // Chia thành nhiều event theo SSE chuẩn
    //                 const parts = buffer.split("\n\n");
    //                 buffer = parts.pop(); // giữ lại phần cuối (có thể chưa đủ)
    //
    //                 for (const line of parts) {
    //                     if (line.startsWith("data:")) {
    //                         const dataStr = line.replace("data:", "").trim();
    //                         if (!dataStr) continue; // bỏ qua rỗng
    //
    //                         try {
    //                             const json = JSON.parse(dataStr);
    //
    //                             // Chunk đầu tiên -> clear loading icon
    //                             if (firstChunk) {
    //                                 const node = ed.dom.get(spanId);
    //                                 if (node) node.innerHTML = "";
    //                                 firstChunk = false;
    //                             }
    //
    //                             // Nếu server báo end
    //                             if (json.event === "end") {
    //                                 this.isStreaming = false;
    //                                 clearTimeout(timeoutId);
    //                                 break;
    //                             }
    //
    //                             // Append dữ liệu stream
    //                             if (json.content) {
    //                                 this.finalContent += json.content;
    //                                 const node = ed.dom.get(spanId);
    //                                 if (node) node.innerHTML = this.finalContent;
    //                             }
    //                         } catch (e) {
    //                             console.error("Parse JSON error:", e, "Raw:", dataStr);
    //                             // Không dừng hẳn, chỉ bỏ chunk lỗi
    //                         }
    //                     }
    //                 }
    //             }
    //
    //             this.isStreaming = false;
    //             clearTimeout(timeoutId);
    //
    //         } catch (err) {
    //             console.error("AI streaming error:", err);
    //             this.$message({
    //                 message: `${this.$t('zimbraNokey.AIError')}`,
    //                 type: "warning",
    //             });
    //
    //             // Khôi phục nội dung cũ khi lỗi
    //             const node = ed.dom.get(spanId);
    //             if (node) {
    //                 node.outerHTML = originalText;
    //             }
    //
    //             this.isStreaming = false;
    //             clearTimeout(timeoutId);
    //         }
    //     },
        handleAIStreamNew(type) {
            const editor = this.$refs.refEditor.editor
            const selectedText = editor.selection.getContent({ format: "text" });
            this.$refs.aiStream.runDirectAction(type, selectedText, editor);

        },
        // handleAIStream(ed, selectedText, actionName) {
        //     if (actionName == ACTION_AI_COMPOSE.CUSTOM){
        //         selectedText = `${selectedText} ${this.$t('zimbraNokey.for')} ${this.requireContent}`
        //     }
        //     const requestBody = {
        //         message: selectedText,
        //         action_name: actionName,
        //         sso_token: localStorage.getItem("token_sso")
        //     };
        //
        //     if (!selectedText && actionName !== ACTION_AI_COMPOSE.COMPOSE_MAIL ) {
        //         this.$message({
        //             message: this.$t('zimbraNokey.noSelectedText'),
        //             type: "warning",
        //         });
        //         return;
        //     }
        //
        //     const requestId = this.generateUniqueId();
        //     this.callAI(requestId, requestBody, ed);
        // },
        handleOpenBrowser(ed) {
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
            input.setAttribute('multiple', 'multiple');
            input.onchange = (evt) => {
                this.uploadFile(evt, evt.target.files, false, ed);
            };
            input.click();
        },
        toggleUsePrefix() {
            if (!this.confirmChangeIncludeHeaders) {
                this.visible = false;
                this.$confirm(
                    this.$t("zimbra.zmMsg.switchIncludeWarning"),
                    this.$t("zimbra.ztMsg.alertFeedReplyTitle"),
                    {
                        type: "warning",
                    }
                )
                    .then(() => {
                        this.confirmChangeIncludeHeaders = true;
                        this.handleChangeUsePrefix();
                    })
                    .catch(() => {
                    });
                return;
            }
            this.handleChangeUsePrefix();
        },
        /**
         * Sử dụng tiền tố với văn bản thuần túy
         */
        handleChangeUsePrefixTextPlain() {
            if (!this.plainText) {
                return;
            }
            const textPre = this.getContentByMarkerText(ZmComposeView.BC_TEXT_PRE);
            const signPre = this._htmlToText(this.getSignature(SIGNATURE_STYLE.OUTLOOK, this.signatureActiveId));
            let divider = this.getDividerPlainText();
            let quoted = this.getContentByMarkerText(ZmComposeView.BC_QUOTED_TEXT);
            if (this.usePrefix) {
                const wrapParams = {
                    text: quoted,
                    preserveReturns: true,
                    htmlMode: false,
                    prefix: this.preference.zimbraPrefForwardReplyPrefixChar
                };
                quoted = AjxStringUtil.wordWrap(wrapParams);
            } else {
                quoted = quoted.replace(/^[>|] ?/, "").replace(/\n[>|] ?/g, "\n");
            }
            const signPost = this._htmlToText(this.getSignature(SIGNATURE_STYLE.INTERNET, this.signatureActiveId));

            this.plainText = [
                textPre,
                signPre ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_SIG_PRE]}${signPre}` : "",
                divider ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_DIVIDER]}${divider}` : "",
                quoted ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_QUOTED_TEXT]}${quoted}` : quoted,
                signPost ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_SIG_POST]}${signPost}` : signPost,
            ].join("");
            this.visible = false;
        },
        /**
         * Sử dụng tiền tố
         */
        handleChangeUsePrefix(_usePrefix) {
            this.usePrefix = _usePrefix ?? !this.usePrefix;
            if (this.contentType === EMAIL_CONTENT_TYPE.PLAIN) {
                // TH văn bản thuần túy
                this.handleChangeUsePrefixTextPlain();
            } else {
                this.includeHeadersUsePrefixHtml(true);
            }
            this.visible = false;
        },
        toggleIncludeHeaders() {
            if (!this.confirmChangeIncludeHeaders) {
                this.visible = false;
                this.$confirm(
                    this.$t("zimbra.zmMsg.switchIncludeWarning"),
                    this.$t("zimbra.ztMsg.alertFeedReplyTitle"),
                    {
                        type: "warning",
                    }
                )
                    .then(() => {
                        this.confirmChangeIncludeHeaders = true;
                        this.handleChangeIncludeHeaders();
                    })
                    .catch(() => {
                    });
                return;
            }
            this.handleChangeIncludeHeaders();
        },
        /**
         * Bao gồm đề mục định dạng văn bản thuần túy
         */
        handleChangeIncludeHeadersPlainText() {
            const textPre = this.getContentByMarkerText(ZmComposeView.BC_TEXT_PRE);
            const signPre = this._htmlToText(this.getSignature(SIGNATURE_STYLE.OUTLOOK, this.signatureActiveId));
            const divider = this.getDividerPlainText();
            const quoted = this.getContentByMarkerText(ZmComposeView.BC_QUOTED_TEXT);
            const signPost = this._htmlToText(this.getSignature(SIGNATURE_STYLE.INTERNET, this.signatureActiveId));
            this.plainText = [
                textPre,
                signPre ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_SIG_PRE]}${signPre}` : "",
                divider ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_DIVIDER]}${divider}` : "",
                quoted ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_QUOTED_TEXT]}${quoted}` : quoted,
                signPost ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_SIG_POST]}${signPost}` : signPost,
            ].join("");
        },
        getDividerWithoutHeadersCalendar() {
            const from = this.getEmailAddrers(this.data.e, ADDRESS_TYPE.FROM, true, false);
            const replyPrefix = this.$t('zimbra.zmMsg.replyPrefix', [this.formatDateTime(this.data.d, "MMMM DD YYYY", false), this.formatDateTime(this.data.d, "h:mm A"), from.map(e => e.text).join(", ")]);
            const preface = `<span id="${AjxStringUtil.HTML_SEP_ID}" data-marker="${this.getDataMarker(ZmComposeView.BC_DIVIDER)}">${_.escape(replyPrefix)}<span>`;
            return `<div data-marker="${this.getDataMarker(ZmComposeView.BC_HEADERS)}">${preface}</div>`;
        },
        handleInitEditorObserver(ed, observer) {
            const editorBody = ed.getBody();
            observer = new MutationObserver((mutationsList) => {
                mutationsList.forEach((mutation) => {
                    if (mutation.type === 'childList') {
                        mutation.removedNodes.forEach((removedNode) => {
                            if (
                                removedNode.tagName === 'SPAN' && // Kiểm tra thẻ <span>
                                removedNode.hasAttribute('data-type') // Có thuộc tính `email-source`
                            ) {
                                this.modelData.to = this.modelData.to.filter(item => item.a !== removedNode.getAttribute('data-item'));
                            }
                        });
                    }
                });
            },);
            observer.observe(editorBody, {
                childList: true,
                subtree: true
            });
        },
        /**
         * Khởi tạo TH bao gồm đề mục định dạng html
         */
        initIncludeHeadersHtml() {
            const div = document.createElement("div");
            $(div).html(this.$refs.refEditor?.editor.getContent());
            const mailSelect =
                this.currentExtraActiveEmail || this.currentActiveEmail;
            if (this.includeHeaders) {
                // bao gồm đề mục
                const header = this.data.isFromCalendar ? "" : this.getHeader(mailSelect?.rawData);
                if (this.usePrefix) {
                    $(div).find(`[data-marker='${this.getDataMarker(ZmComposeView.BC_HEADERS)}']`)
                        .html(`<blockquote style="${ZmComposeView.styleQuote}">${header}</blockquote>`);
                } else {
                    $(div).find(`[data-marker='${this.getDataMarker(ZmComposeView.BC_HEADERS)}']`).html(header);
                }
                $(div).find(`[data-marker='${this.getDataMarker(ZmComposeView.BC_DIVIDER)}']`).replaceWith(this.getDivider());
            } else {
                let _header = "";
                if (this.data.isFromCalendar) {
                    _header = this.getDividerWithoutHeadersCalendar();
                } else {
                    _header = this.getDividerWithoutHeaders(this.rawData);
                }
                // không bao gồm đề mục
                $(div).find(`[data-marker='${this.getDataMarker(ZmComposeView.BC_HEADERS)}']`).remove();
                $(div).find(`[data-marker='${this.getDataMarker(ZmComposeView.BC_DIVIDER)}']`).replaceWith(_header);
            }
            this.editorModel = this.handleFixImageSrc($(div).html(), this.allPart, this.modelData.origid);
        },
        /**
         * Xử lý Sử dụng tiền tố + Bao gồm đề mục ở định dạng HTML
         */
        includeHeadersUsePrefixHtml(isChangeUsePrefix) {
            const textPre = this.getTextPreHtml();
            const signPre = this.getSignature(SIGNATURE_STYLE.OUTLOOK, this.signatureActiveId);
            let divider = "";
            let header = "";
            if (!this.data.isFromCalendar) {
                if (this.includeHeaders) {
                    divider = this.getDivider();
                    header = this.getHeader(this.rawData);
                    if (this.usePrefix) {
                        header = `<blockquote style="${ZmComposeView.styleQuote}">${header}</blockquote>`;
                    }
                    header = `<div data-marker="${this.getDataMarker(ZmComposeView.BC_HEADERS)}">${header}</div>`;
                } else {
                    header = `<div data-marker="${this.getDataMarker(ZmComposeView.BC_HEADERS)}">${this.getDividerWithoutHeaders(this.rawData, EMAIL_CONTENT_TYPE.HTML)}</div>`;
                }
            } else {
                if (this.includeHeaders) {
                    divider = this.getDivider();
                } else {
                    header = this.getDividerWithoutHeadersCalendar();
                }
            }
            let quoted = this.getContentByMarkerHtml(ZmComposeView.BC_QUOTED_TEXT);
            if (isChangeUsePrefix) {
                if (this.usePrefix) {
                    quoted = `<blockquote style="${ZmComposeView.styleQuote}">${quoted}</blockquote>`;
                } else {
                    quoted = $(quoted).first().html();
                }
            }
            quoted = `<div data-marker="${this.getDataMarker(ZmComposeView.BC_QUOTED_TEXT)}">${quoted}</div>`;
            const signPost = this.getSignature(SIGNATURE_STYLE.INTERNET, this.signatureActiveId);
            this.editorModel = [textPre, signPre, divider, header, quoted, signPost].join("");
            this.$nextTick(() => {
                this.editorModel = this.handleFixImageSrc(this.editorModel, this.allPart, this.modelData?.origid);
            })
        },
        /**
         * Bao gồm đề mục
         */
        handleChangeIncludeHeaders(_includeHeaders) {
            this.includeHeaders = _includeHeaders ?? !this.includeHeaders;
            if (this.contentType === EMAIL_CONTENT_TYPE.PLAIN) {
                // TH văn bản thuần túy
                this.handleChangeIncludeHeadersPlainText();
            } else {
                if (_includeHeaders != null && _includeHeaders != undefined) {
                    this.initIncludeHeadersHtml();
                } else {
                    this.includeHeadersUsePrefixHtml(false);
                }
            }
            this.visible = false;
        },
        changeInclude(type) {
            if (type === this.includes) {
                this.visible = false;
                return;
            }
            this.visible = false;
            this.$confirm(
                this.$t("zimbra.zmMsg.switchIncludeWarning"),
                this.$t("zimbra.ztMsg.alertFeedReplyTitle"),
                {
                    type: "warning",
                }
            )
                .then(() => {
                    this.handleChangeInclude(type);
                })
                .catch(() => {
                });
            return;
        },
        /**
         * Lấy phần nội dung người nhập của định dạng HTML
         */
        getTextPreHtml(signPrevious, isSwitch) {
            const markerRemove = [
                ZmComposeView.BC_SIG_PRE,
                ZmComposeView.BC_DIVIDER,
                ZmComposeView.BC_HEADERS,
                ZmComposeView.BC_QUOTED_TEXT,
                ZmComposeView.BC_SIG_POST,
            ];
            const div = document.createElement("div");
            $(div).html(this.$refs.refEditor?.editor?.getContent());
            for (let index = 0; index < markerRemove.length; index++) {
                const item = markerRemove[index];
                $(div)
                    .find(`[data-marker='${this.getDataMarker(item)}']`)
                    .remove();
            }
            // Xóa chữ ký
            if (this.signatureActive) {
                const { id } = this.signatureActive;
                $(div).find(`[id='${id}']`).remove();
            }
            if (isSwitch && signPrevious) {
                const { id } = signPrevious;
                $(div).find(`[id='${id}']`).remove();
            }
            return $(div).html();
        },
        /**
         * Lấy nội dung của định dạng văn bản thuần túy
         */
        getContentByMarkerText(marker) {
            if (marker == ZmComposeView.BC_TEXT_PRE) {
                const firstNoSpace = this.plainText.indexOf(ZmComposeView.BC_MARKER_CHAR);
                return firstNoSpace > -1 ? this.plainText.substring(0, firstNoSpace) : "";
            }
            const firstNoSpace = this.plainText.indexOf(ZmComposeView.BC_TEXT_MARKER[marker]);
            if (firstNoSpace > -1) {
                let nextNoSpace = this.plainText.indexOf(ZmComposeView.BC_MARKER_CHAR, firstNoSpace + ZmComposeView.BC_TEXT_MARKER[marker].length);
                nextNoSpace = nextNoSpace > -1 ? nextNoSpace : this.plainText.length;
                return this.plainText.substring(firstNoSpace + ZmComposeView.BC_TEXT_MARKER[marker].length, nextNoSpace)
            }
            return "";
        },
        /**
         * Lấy nội dung của định dạng HTML
         */
        getContentByMarkerHtml(marker) {
            const div = document.createElement("div");
            $(div).html(this.editorModel);
            return $(div).find(`[data-marker='${this.getDataMarker(marker)}']`).html();
        },
        getDividerPlainText() {
            let divider = "";
            if (
                this.actionType === EMAIL_ACTION.FORWARD ||
                this.actionType === EMAIL_ACTION.REPLY ||
                this.actionType === EMAIL_ACTION.REPLY_ALL
            ) {
                const msg = this.actionType === EMAIL_ACTION.FORWARD ? "zimbra.compose.forwardEmail" : "zimbra.compose.originEmail";
                if (this.data.isFromCalendar) {
                    if (this.includeHeaders) {
                        divider = this.$t(msg);
                    } else {
                        const from = this.getEmailAddrers(this.data.e, ADDRESS_TYPE.FROM, true, false);
                        divider = this.$t('zimbra.zmMsg.replyPrefix', [this.formatDateTime(this.data.d, "MMMM DD YYYY"), this.formatDateTime(this.data.d, "h:mm A"), from.map(e => e.text).join(", ")]);
                    }
                    return divider;
                }
                if (this.includeHeaders) {
                    let header = this.getHeader(this.rawData);
                    if (this.usePrefix) {
                        header = `<blockquote style="${ZmComposeView.styleQuote}">${header}</blockquote>`;
                        divider = `${this.$t(msg)}${this._htmlToText(header).replace("\n", "")}`;
                    } else {
                        divider = `${this.$t(msg)}\n${this._htmlToText(header).replace("\n", "")}`;
                    }
                } else {
                    divider = this.getDividerWithoutHeaders(this.rawData, EMAIL_CONTENT_TYPE.PLAIN);
                }
            }
            return divider;
        },
        isIncludeBody() {
            return this.includes.indexOf("includeBody") > -1;
        },
        isIncludeSmart() {
            return this.includes.indexOf("includeSmart") > -1;
        },
        /**
         * Thay đổi bao gồm định dạng văn bản thuần túy
         */
        handleChangeIncludePlainText() {
            const textPre = this.getContentByMarkerText(ZmComposeView.BC_TEXT_PRE);
            const signPre = this._htmlToText(this.getSignature(SIGNATURE_STYLE.OUTLOOK, this.signatureActiveId));
            let divider = "";
            let quoted = "";
            if (this.isIncludeBody() || this.isIncludeSmart()) {
                divider = this.getDividerPlainText();
                let body = "";
                if (this.isIncludeBody()) {
                    body = this.data.isFromCalendar ? this.data.descHtml || this.data.desc : this.getBody(this.rawData);
                } else {
                    if (this.data.isFromCalendar) {
                        const isHtml = !!this.data.descHtml;
                        body = AjxStringUtil.getOriginalContent(this.data.descHtml || this.data.desc, isHtml) || "";
                    } else {
                        const mp = this.getBodyPart(this.rawData.mp);
                        const isHtml = mp?.ct == ZmMimeTable.TEXT_HTML;
                        body = AjxStringUtil.getOriginalContent(mp ? mp.content : "", isHtml) || "";
                    }
                }
                if (this.usePrefix) {
                    body = `<blockquote style="${ZmComposeView.styleQuote}">${body}</blockquote>`;
                }
                body = `<div data-marker="${this.getDataMarker(ZmComposeView.BC_QUOTED_TEXT)}">${body}</div>`;
                quoted = this._htmlToText(body);
            } else if (this.includes == INCLUDE_ORIGIN_TYPE.INCLUDE_AS_ATTACHMENT) {
                this.listAttachMail = [this.modelData.origid];
                this.includeAsAttachIndex = this.listFileAttachment.length;
            }
            const signPost = this._htmlToText(this.getSignature(SIGNATURE_STYLE.INTERNET, this.signatureActiveId));
            this.plainText = [
                textPre,
                signPre ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_SIG_PRE]}${signPre}` : "",
                divider ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_DIVIDER]}${divider}` : "",
                quoted ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_QUOTED_TEXT]}${quoted}` : quoted,
                signPost ? `${ZmComposeView.BC_TEXT_MARKER[ZmComposeView.BC_SIG_POST]}${signPost}` : signPost,
            ].join("");
            if (this.includes == INCLUDE_ORIGIN_TYPE.INCLUDE_AS_ATTACHMENT) {
                this.saveDraftAfterChangeInclude();
            }
        },
        saveDraftAfterChangeInclude() {
            ZimbraMailService.saveDraftRequest({
                m: this.buildFormData(true),
            }).then((saveDraftRequest) => {
                const saveDraftResponse =
                    this.getResponseBody(saveDraftRequest)[
                        "SaveDraftResponse"
                        ];
                if (saveDraftResponse?.m?.id) {
                    this.draftId = saveDraftResponse?.m?.id;
                    this.listAttachMail = [];
                    this.updateListAttach(saveDraftResponse);
                }
            });
        },
        /**
         * Thay đổi bao gồm định dạng HTML
         */
        handleChangeIncludeHtml() {
            const textPre = this.getTextPreHtml();
            const signPre = this.getSignature(SIGNATURE_STYLE.OUTLOOK, this.signatureActiveId);
            let divider = "";
            let header = "";
            let quoted = "";
            if (this.isIncludeBody() || this.isIncludeSmart()) {
                let content = "";
                let isHtml = true;
                if (this.data.isFromCalendar) {
                    content = this.data.descHtml || this.data.desc;
                    isHtml = !!this.data.descHtml;
                } else {
                    const mp = this.getBodyPart(this.rawData.mp);
                    isHtml = mp?.ct == ZmMimeTable.TEXT_HTML;
                    content = mp ? mp.content : "";
                }
                divider = this.getDivider();
                header = `<div data-marker="${this.getDataMarker(ZmComposeView.BC_HEADERS)}">${this.getHeader(this.rawData)}</div>`;
                let body = "";
                if (this.isIncludeBody()) {
                    body = this.data.isFromCalendar ? content : this.getBody(this.rawData);
                } else {

                    body = AjxStringUtil.getOriginalContent(content, isHtml) || "";
                }
                if (this.usePrefix) {
                    body = `<blockquote style="${ZmComposeView.styleQuote}">${body}</blockquote>`;
                }
                body = `<div data-marker="${this.getDataMarker(ZmComposeView.BC_QUOTED_TEXT)}">${body}</div>`;
                quoted = body;
            } else if (this.includes == INCLUDE_ORIGIN_TYPE.INCLUDE_AS_ATTACHMENT) {
                this.listAttachMail = [this.modelData.origid];
                this.includeAsAttachIndex = this.listFileAttachment.length;
            }
            const signPost = this.getSignature(SIGNATURE_STYLE.INTERNET, this.signatureActiveId);
            this.editorModel = [textPre, signPre, divider, header, quoted, signPost].join("");
            this.editorModel = this.handleFixImageSrc(this.editorModel, this.allPart, this.modelData.origid);
            if (this.includes == INCLUDE_ORIGIN_TYPE.INCLUDE_AS_ATTACHMENT) {
                this.$nextTick().then(() => {
                    this.saveDraftAfterChangeInclude();
                });
            }
        },
        handleChangeInclude(type) {
            this.includes = type;
            if (this.contentType === EMAIL_CONTENT_TYPE.PLAIN) {
                // TH văn bản thuần túy
                this.handleChangeIncludePlainText();
            } else {
                this.handleChangeIncludeHtml();
            }
        },
        async updateListAttach(saveDraftResponse) {
            const listAttachments = Array.isArray(saveDraftResponse?.m?.mp.mp) ? saveDraftResponse?.m?.mp.mp : [saveDraftResponse?.m?.mp.mp];

            let isAttachZeroSize = false
            const attachments = listAttachments
                .filter((e) => {
                    if (e.cd == "attachment" && AjxUtil.formatSize(e.s)?.size > 0) {
                        return e
                    } else if (AjxUtil.formatSize(e.s)?.size <= 0) {
                        isAttachZeroSize = true
                    }
                }).map((e, idx) => {
                    const sizeFile = AjxUtil.formatSize(e.s);
                    return {
                        ...e,
                        name: `${e.filename} (${sizeFile.size} ${sizeFile.units})`,
                        href: this.createUrlDownloadFile(
                            this.modelData.origid || this.draftId,
                            e.part
                        ),
                        isOriginMail: this.includeAsAttachIndex === idx,
                        aid: this.generateUniqueId(),
                        part: e.part || idx + 2,
                    };
                });

            //Lọc ra những thằng file trong editor
            const inlineFileList = this.filterInlineParts(listAttachments);

            // if (isAttachZeroSize) {
            //     this.$notify({
            //         type: "warning",
            //         dangerouslyUseHTMLString: true,
            //         message: `<div style="margin-top: -10px; margin-right: 10px"> ${this.$t("zimbra.zhMsg.zeroSizedAtts")}</div>`,
            //         position: "top-right",
            //         duration: 3000,
            //     });
            // }
            // console.log(attachments)
            this.listFileAttachment = attachments;
            this.listFileAttachmentSend = _.cloneDeep(attachments);
            this.listAttachMail = [];
            this.listAttachContact = [];
            // if(this.rtf){
            //     this.listAttachmentPlain = [];
            //     this.listAttachmentPlain = inlineFileList;
            // }
            this.listAttachBriefcase = [];
            // this.attachInline =

            //update part cho this.attachInline xử lý case chèn ảnh ở editor trước rồi chèn file sau
            if (this.attachInline) {
                await this.updatePart(this.attachInline, inlineFileList);
            }

        },
        filterInlineParts(data) {
            let inlineParts = [];

            function traverse(part) {
                if (part.cd === "inline") {
                    inlineParts.push(part);
                }

                if (Array.isArray(part.mp)) {
                    part.mp.forEach(traverse);
                }
            }

            data.forEach(traverse);
            return inlineParts;
        },
        updatePart: function(array1, array2) {
            array1.forEach(item1 => {
                const match = array2.find(item2 => item2?.ci.includes(item1?.ci)); // tránh case item có <cid:abc> và cid:abc
                if (match) {
                    item1['part'] = match?.part; // Thay thế part
                }
            });
        },
        openDialogAttachMail() {
            this.visibleAttach = false;
            this.visibleDialogEmailSelector = true;
        }
        ,
        handleAttachEmail(listEmail) {
            this.visibleDialogEmailSelector = false;
            this.listAttachMail = listEmail.map((e) => `${e.id}`);
            this.executeSaveDraft();
        }
        ,
        changeTypeReply(type) {
            this.actionType = type;
            this.visible = false;
            let { e, f } = this.rawData;
            const address = Array.isArray(e) ? e : e ? [e] : [];
            let to = [];
            let cc = [];
            let bcc = [];
            if (
                CommonUtils.methods.checkFlagsContainKey(
                    f,
                    EMAIL_FLAG.SENT_BY_ME
                )
            ) {
                to =
                    type == EMAIL_ACTION.FORWARD
                        ? []
                        : this.getEmailAddrers(address, ADDRESS_TYPE.TO);
                cc =
                    type == EMAIL_ACTION.REPLY_ALL
                        ? this.getEmailAddrers(address, ADDRESS_TYPE.CC)
                        : [];
                bcc =
                    type == EMAIL_ACTION.REPLY_ALL
                        ? this.getEmailAddrers(address, ADDRESS_TYPE.BCC)
                        : [];
            } else {
                to =
                    type == EMAIL_ACTION.FORWARD
                        ? []
                        : this.getEmailAddrers(address, ADDRESS_TYPE.FROM);
                cc =
                    type == EMAIL_ACTION.REPLY_ALL
                        ? [
                            ...this.getEmailAddrers(address, ADDRESS_TYPE.TO),
                            ...this.getEmailAddrers(address, ADDRESS_TYPE.CC),
                        ]
                        : [];
            }


            this.showCc = cc.length === 0;
            this.showBcc = bcc.length === 0;
            setTimeout(() => {
                this.modelData.to = to;
                this.modelData.cc = cc;
                this.modelData.bcc = bcc;
            }, 200);
        }
        ,
        addOriginalAttachments() {
            this.listFileAttachment = _.concat(
                this.listFileAttachment || [],
                this.listFileAttachmentOrigin
            );
            this.listFileAttachmentOrigin = [];
            this.executeSaveDraft();
        }
        ,
        someThingChanged() {
            this.isChanged = true;
        }
        ,
        isChangedData() {
            return this.isChanged;
        }
        ,
        dropHandler(event) {
            let droppedFiles = event.dataTransfer.files;
            if (!droppedFiles) {
                return;
            }
            this.uploadFile(event, droppedFiles, true);
        }
        ,
        getAllSelectedAdress() {
            // lấy tất cả địa chỉ đã chọn
            const to = this.modelData.to?.map(e => ({ ...e, type: "to" })) || [];
            const cc = this.modelData.cc?.map(e => ({ ...e, type: "cc" })) || [];
            const bcc = this.modelData.bcc?.map(e => ({ ...e, type: "bcc" })) || [];
            const allSelectedAddress = _.concat(to, cc, bcc);
            return allSelectedAddress;
        }
        ,
        paste_preprocess(plugin, args) {
            const div = document.createElement("div");
            $(div).html(args.content);
            const images = $(div).find("img");
            if (images && images.length == 1) {
                args.preventDefault();
                const img = images[0];
                fetch(img.src)
                    .then(res => res.blob()) // Gets the response and returns it as a blob
                    .then(blob => {
                        this.uploadFile(null, [blob], false, args.target);
                    });
            }

        }
        ,
        changeFromAddress(evt) {
            const _from = evt;
            if (_from && _from.identityId) {
                // Định danh khác thì thay đổi chữ ký theo cấu hình
                let signId = null;
                if (this.actionType === EMAIL_ACTION.COMPOSE) {
                    signId = _from.identity.zimbraPrefDefaultSignatureId;
                } else {
                    signId = _from.identity.zimbraPrefForwardReplySignatureId;
                }
                if (this.listFileAttachmentDisplay.findIndex(e => e.ct === "text/x-vcard") >= 0) {
                    this.onRemoveAttachment(this.listFileAttachmentDisplay.findIndex(e => e.ct === "text/x-vcard"))
                }
                const signActive = this.signatures.find(e => e.id === signId);
                this.handleSelectSignature(signActive);
            }
        }
        ,
        /**
         * Đính kèm trực tiếp
         */
        handleAttachInline() {
            this.popoverAttach = false;
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');
            input.setAttribute('multiple', 'multiple');
            input.onchange = (evt) => {
                this.uploadFile(evt, evt.target.files, false, this.$refs.refEditor?.editor);
            };
            input.click();
        }
        ,
        /**
         * Mở dialog đính kèm danh bạ
         */
        openDialogAttachBriefcase() {
            this.popoverAttach = false;
            this.$refs.refDialogBriefcaseSelector.show();
        }
        ,
        /**
         * Mở dialog đính kèm danh bạ
         */
        openDialogAttachContact() {
            this.popoverAttach = false;
            this.$refs.refDialogContactSelector.show();
        }
        ,
        /**
         * Đính kèm danh bạ
         */
        handleAttachContact(listSelectedContact) {
            this.listAttachContact = listSelectedContact.map((e) => `${e.id}`);
            this.executeSaveDraft();
        }
        ,
        /**
         * Đính kèm Cặp tài liệu
         */
        handleAttachBriefcase(listSelectedBriefcase) {
            this.listAttachBriefcase = listSelectedBriefcase
            this.executeSaveDraft();
        }
        ,
        handleAttachCommand(command) {
            switch (command) {
                case ATTACT_TYPE.MY_COMPUTER:
                    this.openDialogFileChooser();
                    break;
                case ATTACT_TYPE.ATTACHINLINE:
                    this.handleAttachInline();
                    break;
                case ATTACT_TYPE.BRIEFCASE:
                    this.openDialogAttachBriefcase();
                    break;
                case ATTACT_TYPE.CONTACTS:
                    this.openDialogAttachContact();
                    break;
                case ATTACT_TYPE.MAIL:
                    this.openDialogAttachMail();
                    break;
            }
        }
        ,
        /**
         * Soạn thư trong cửa sổ riêng
         */
        detachComposeTooltip() {
            const currentData = this.getTabData();
            const uuid = this.generateUniqueId();
            // Lưu dữ liệu hiện tại vào local storage
            const datacompose = this.getLocalStorageObject("data_compose") || [];
            datacompose.push({
                uuid: uuid,
                data: currentData,
                isAddNew: false,
            });
            this.addLocalStorageObject("data_compose", datacompose);
            const { origin } = window.location;
            const url = `${origin}/launchNewWindow?compose=1&uuid=${uuid}`;
            // Mở cửa sổ tối đa kích thước màn hình, ẩn thanh công cụ nếu có thể
            const features = [
                "noopener",
                "noreferrer",
                "toolbar=0",
                "location=0",
                "menubar=0",
                "status=0",
                "scrollbars=1",
                "resizable=1",
                "left=0",
                "top=0",
                `width=${screen.availWidth}`,
                `height=${screen.availHeight}`,
                "fullscreen=yes"
            ].join(",");

            const win = window.open(url, "_blank", features);
            if (win) {
                try {
                    win.moveTo(0, 0);
                    win.resizeTo(screen.availWidth, screen.availHeight);
                } catch (e) {
                    console.log(e);
                }
                const goFullscreen = () => {
                    try {
                        const doc = win.document;
                        const el = doc && doc.documentElement;
                        if (el && el.requestFullscreen) {
                            el.requestFullscreen().catch(() => {});
                        } else if (el && el.webkitRequestFullscreen) {
                            el.webkitRequestFullscreen(); // Safari
                        }
                    } catch (e) {
                        console.log(e);
                    }
                };
                try {
                    if (win.document && win.document.readyState === "complete") {
                        goFullscreen();
                    } else {
                        win.onload = goFullscreen;
                    }
                } catch (e) {
                    // cross-origin sẽ chặn truy cập document — trong trường hợp này
                }
            }
            // Đóng tab hiện tại (nếu cần)
            // this.$emit("closeComposeForm")
        }
        ,
        formatprogress() {
            return this.stringTruncateFileName(this.fileUploading.filename || this.fileUploading.name);
        }
        ,
        checkFileAttachInContent(formDataOld) {
            // Duyệt qua các phần tử trong `mp`
            formDataOld?.mp.forEach((multipart, mpIndex) => {
                // Kiểm tra nếu phần tử chứa `multipart/related`
                if (multipart?.mp) {
                    multipart?.mp.forEach((relatedPart, rpIndex) => {
                        if (relatedPart?.ct === "multipart/related" && relatedPart.mp) {
                            let contentHtml = '';

                            // Tìm nội dung HTML trong `multipart/related`
                            relatedPart?.mp.forEach(subPart => {
                                if (subPart?.ct === "text/html") {
                                    contentHtml = subPart.content; // Lưu chuỗi content HTML
                                }
                            });

                            // Duyệt qua các phần tử có `cid` trong `multipart/related`
                            relatedPart.mp = relatedPart?.mp.filter(subPart => {
                                // Kiểm tra `cid` và chỉ giữ lại phần tử có `cid` được tham chiếu trong `contentHtml`
                                if (subPart?.ci) {
                                    // if (!contentHtml.includes(subPart.ci)) {
                                    //     return false; // Loại bỏ phần tử nếu `cid` không tồn tại trong `contentHtml`
                                    // }
                                }
                                return true; // Giữ lại các phần tử không chứa `cid`
                            });
                        }
                    });
                }
            });

            return formDataOld;
        },
        onOpenSecurePopover() {
            if (this.modalSecure.dateExpired) {
                this.modalSecure.dateExpirePopover = this.modalSecure.dateExpired;
            } else {
                this.modalSecure.dateExpirePopover = moment()
                    .add(5, "minutes")
                    .toDate();
            }
        },
        onCancelSecure() {
            if (this.modalSecure.isSecureMail) {
                this.$refs.securePopovert?.doClose();
            } else {
                this.$refs.securePopover?.doClose();
            }
        },
        onSubmitPopoverSecure() {
            this.modalSecure.isSecureMail = true;
            this.modalSecure.dateExpired = this.modalSecure.dateExpirePopover;
            if (this.modalSecure.isSecureMail) {
                this.$refs.securePopovert?.doClose();
            } else {
                this.$refs.securePopover?.doClose();
            }
        },
        handleUnSecureMail() {
            this.modalSecure.isSecureMail = false;
            this.modalSecure.dateExpired = null;
        },
        onDateExpirePopoverChange(val) {
            if (!val || moment(val).isBefore(moment(this.nowTime), 'minutes')) {
                this.modalSecure.dateExpirePopover = moment().add(5, "minutes").toDate();
            }
        },
        onDateExpirePopoverChangeFocusOut(e) {
            if (e?.target?.value) {
                const m = moment(e.target.value, "DD/MM/YYYY HH:mm", true);
                const rs = m.isValid() ? m : null;// true = strict mode
                if (rs != null) {
                    this.modalSecure.dateExpirePopover = m.toDate();
                }
            }

        },
        reBuildFormDataMail(mail){

        }
        ,
    },
}
;
</script>
<style lang="scss">
.box-control-compose {
    position: unset !important;
    background-color: #fff !important;
    width: 100% !important;
    box-shadow: unset !important;
    padding: unset !important;
}

.tox .tox-toolbar__select.tox-font-select {
    width: 150px !important;
    /* Điều chỉnh kích thước độ rộng tại đây */
}

.zb-editor.newrecord-mode .tox-tinymce {
    //max-height: 46vh !important;
}

.zb-editor.replyall-mode .tox-tinymce {
    max-height: 100% !important;
    border: unset !important;
}

.zb-editor.forward-mode .tox-tinymce {
    max-height: 55vh !important;
    border: unset !important;
}

.sticky_action {
    position: sticky;
    bottom: 0;
    z-index: 2;
    background-color: white;
    //padding-top: 10px;
    //padding-bottom: 10px;
}

.from_mail {
    background-color: white !important;
    text-align: left !important;
    font-weight: 400 !important;
}

.send_mail {
    font-weight: 500;
    color: #fff;
    font-size: 1.4rem;
    border: 1px solid #ee0033;

    height: 3.8rem;
    border-radius: 0.8rem;
    background: #ee0033;
    transition: 0.3s;
}

@media screen and (max-width: 480px) {
    .group-email {
        //width: calc(100vw - 100px);
    }

    .head {
        flex: auto !important;
    }

    .row-input-email,
    .row-input-subject,
    .row-input-attach {
        display: block !important;
        flex-direction: column;
        padding: 0;
        align-items: flex-start;
    }

    .btn-book-email {
        display: none;
    }

    .btn-book-email {
        top: -6px !important;
    }
}

.non-pop .row-input .head {
    color: white;
}

.ispop .popup-overlay .row-input .head {
    color: black;
}

.bottom_action {
    position: sticky;
    bottom: -12px;
    background: white;
}

.top_sub {
    position: sticky;
    top: 0;
    background: #f3f4f6;
    z-index: 3;
}

.is-fullscreen {
    top: 50%;
    left: 50%;
    position: fixed;
    background: white;
    transform: translate(-50%, -50%);
    width: 98vw;
    height: 98vh !important;
    border-radius: 10px;
    z-index: 5;
    padding-right: unset !important;
    box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
    rgba(0, 0, 0, 0.12) 0px -12px 30px,
    rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px,
    rgba(0, 0, 0, 0.09) 0px -3px 5px;

    .top_sub {
        padding: 5px;
    }

    .zb-editor.replyall-mode .tox-tinymce {
        max-height: 100% !important;
    }
}

@media screen and (max-width: 480px) {
    .editor_off {
        padding-top: 10px;
        padding-bottom: 10px;
    }

    .title-mobile {
        max-width: 70vw;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}

.title-mobile {
    display: -webkit-box;
    display: box;
    -webkit-box-orient: vertical;
    box-orient: vertical;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.5;
    white-space: normal;
}
.tool-bar-compose{
    margin: 0px!important;
}
.signature-out .zm-signatures{
    .active::before {
        content: "●";
        color: #2ecc71;
        font-size: 16px;
        margin-right: 8px;
    }
    .text{
        font-weight: 400;
        padding: 4px 8px;
        &:hover{
            cursor: pointer;
            color: var(--color-primary);
        }
    }
}
.reply-mode{
    height: 96% !important;
    border-radius: 16px;
}
@media (max-width: 1200px) {
    .reply-mode{
        height: 90% !important;
    }
}
</style>
